import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.sources');
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";
import { OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

import { activateListRow } from "src/libs/portal/season/util/list-row";

@Component({
    selector: 'wiz-page-sources',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.sources/view.scss */
:host {
  display: block;
  height: auto;
  min-height: 0;
}

.drive-shell {
  display: flex;
  min-height: 640px;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 14px;
  overflow: hidden;
}

.file-pane {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.drive-toolbar {
  padding: 16px 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid var(--ui-line);
}

.drive-location {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.path-bar {
  display: flex;
  align-items: center;
  gap: 9px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
}

.path-bar button {
  font-size: 13px;
  color: var(--ui-muted);
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 4px 0;
}

.path-bar button:last-child {
  color: var(--ui-text);
  font-weight: 600;
}

.path-divider {
  color: var(--ui-muted);
  font-size: 12px;
}

.drive-search {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 8px;
  padding: 0 4px 0 12px;
  max-width: 100%;
  width: 230px;
}

.drive-search > i {
  font-size: 12px;
  color: var(--ui-muted);
}

.drive-search input {
  width: 100%;
  min-width: 0;
  background: transparent;
  border: 0;
  outline: 0;
  font-size: 13px;
  color: var(--ui-text);
  padding: 11px 0;
}

.drive-search:focus-within {
  border-color: var(--ui-accent);
  box-shadow: 0 0 0 2px var(--ui-selected);
}

.drive-search input::placeholder {
  color: var(--ui-muted);
}

.drive-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 24px;
  color: var(--ui-muted);
  font-size: 12px;
}

.list-location {
  display: flex;
  align-items: center;
  min-height: 34px;
}

.parent-check-space {
  width: 15px;
  flex-shrink: 0;
}

.parent-folder-row .drive-file-icon {
  font-size: 17px;
  color: var(--ui-muted);
}

.parent-folder-row:hover {
  background: var(--ui-soft);
}

.selection-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  font-size: 12px;
}

.selection-summary, .selection-tools {
  display: flex;
  align-items: center;
  gap: 4px;
}

.selection-summary {
  white-space: nowrap;
}

.selection-tools {
  padding-left: 10px;
  border-left: 1px solid var(--ui-line);
}

.selection-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: var(--ui-muted);
  font-size: 14px;
  transition: background 0.15s, color 0.15s;
}

.selection-icon:hover:not(:disabled), .selection-icon:focus-visible {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.selection-icon:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.selection-icon:disabled {
  opacity: 0.35;
  cursor: default;
}

.selection-icon::after {
  content: attr(aria-label);
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  pointer-events: none;
  white-space: nowrap;
  padding: 7px 9px;
  border-radius: 6px;
  background: var(--ui-text);
  color: var(--ui-paper);
  font-size: 11px;
  font-weight: 450;
  line-height: 1.4;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.12s;
}

.selection-icon:focus-visible::after {
  opacity: 1;
  visibility: visible;
}

@media (hover: hover) {
  .selection-icon:hover:not(:disabled)::after {
    opacity: 1;
    visibility: visible;
    transition-delay: 0.25s;
  }
}
.selection-trash:hover:not(:disabled), .selection-trash:focus-visible {
  color: var(--ui-danger);
  background: #fcf0f0;
}

.selection-clear {
  font-size: 12px;
}

.selection-actions .selection-extract {
  min-height: 36px;
  margin-left: 6px;
  padding: 8px 12px;
  font-size: 13px;
  gap: 7px;
}

@media (max-width: 620px) {
  .selection-actions {
    display: contents;
  }
  .selection-icon {
    width: 44px;
    height: 44px;
  }
  .selection-tools {
    flex-basis: 100%;
    justify-content: flex-end;
    padding-left: 0;
    border-left: 0;
    gap: 0;
  }
  .selection-actions .selection-extract {
    min-height: 44px;
    padding: 8px 10px;
    margin-left: 3px;
  }
  .selection-summary {
    gap: 0;
    margin-left: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .selection-icon, .selection-icon::after {
    transition: none;
  }
}
.drive-name-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
}

.drive-list-heading b {
  margin-left: 7px;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
}

.view-label {
  display: flex;
  gap: 7px;
  color: var(--ui-muted);
  font-size: 12px;
}

.drive-table-wrap {
  flex: 1;
  overflow: auto;
}

.drive-table {
  table-layout: fixed;
  white-space: normal;
  width: 100%;
}

.drive-table th {
  font-size: 12px;
  background: var(--ui-soft);
  padding: 12px 16px;
  color: var(--ui-muted);
}

.drive-table th:first-child {
  width: 55%;
  padding-left: 24px;
}

.drive-table th:nth-child(2) {
  width: 15%;
}

.drive-table th:nth-child(3) {
  width: 13%;
}

.drive-table th:nth-child(4) {
  width: 17%;
}

.drive-table td {
  padding: 10px 16px;
  height: 66px;
}

.drive-table td:first-child {
  padding-left: 24px;
}

.drive-file {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  text-align: left;
  padding: 4px 0;
  color: var(--ui-text);
}

.drive-file-label {
  min-width: 0;
  flex: 1;
}

.drive-file strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
}

.drive-file small {
  display: block;
  color: var(--ui-muted);
  font-size: 12px;
  margin-top: 3px;
}

.drive-file-icon {
  display: grid;
  place-items: center;
  width: 32px;
  height: 36px;
  flex-shrink: 0;
  font-size: 20px;
  color: var(--ui-muted);
}

.drive-file-icon.is-folder {
  color: var(--ui-muted);
  font-size: 25px;
}

.drive-file-icon.is-pdf {
  color: var(--ui-danger);
  font-size: 23px;
}

.folder-arrow {
  color: var(--ui-muted);
  font-size: 9px;
  margin: 0 8px;
}

.drive-state {
  font-size: 12px;
  color: var(--ui-muted);
  white-space: nowrap;
}

.drive-state.registered {
  color: var(--ui-muted);
}

.drive-state.warning {
  color: var(--ui-warning);
  background: #fbf5eb;
  padding: 4px 6px;
  border-radius: 5px;
}

.file-size, .file-date {
  color: var(--ui-muted);
  font-size: 12px;
  white-space: nowrap;
}

.unavailable .drive-file {
  opacity: 0.65;
}

.drive-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  border-top: 1px solid var(--ui-line);
  padding: 12px 18px;
  color: var(--ui-muted);
  font-size: 12px;
  margin-top: auto;
}

.drive-footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.drive-footer button {
  width: 32px;
  height: 32px;
}

.drive-empty, .drive-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 80px 24px;
  color: var(--ui-muted);
  font-size: 13px;
}

.drive-loading {
  flex-direction: row;
}

.drive-empty > i {
  font-size: 36px;
  color: var(--ui-muted);
}

.drive-empty strong {
  font-size: 13px;
  font-weight: 450;
}

.drive-empty .button {
  font-size: 12px;
}

.drive-error {
  margin: 18px 24px;
}

.file-dialog {
  width: calc(100% - 64px);
  max-width: 1200px;
  border: 0;
  border-radius: 16px;
  padding: 0;
  color: var(--ui-ink);
  max-height: calc(100dvh - 64px);
  overflow: auto;
  box-shadow: 0 35px 100px rgba(35, 39, 47, 0.1882352941);
}

.file-dialog::backdrop {
  background: rgba(35, 39, 47, 0.3960784314);
  backdrop-filter: blur(4px);
}

.file-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 25px;
  border-bottom: 1px solid var(--ui-line);
  gap: 16px;
}

.file-dialog-header > div {
  min-width: 0;
}

.file-dialog-header h2 {
  font-size: 15px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  font-weight: 600;
  margin-top: 6px;
}

.preview-eyebrow {
  font-size: 12px;
  color: var(--ui-muted);
}

.file-dialog-header .icon-button {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  font-size: 22px;
}

.preview-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 310px;
  min-height: 600px;
}

.file-preview {
  background: var(--ui-soft);
  min-width: 0;
  position: relative;
}

.file-preview iframe {
  border: 0;
  width: 100%;
  height: 72vh;
  min-height: 600px;
  display: block;
}

.file-preview pre {
  font-size: 13px;
  line-height: 1.8;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  padding: 20px 25px;
  margin: 0;
  max-height: 70vh;
  overflow: auto;
  color: var(--ui-text);
  tab-size: 4;
}

.text-preview-note {
  padding: 12px 22px;
  border-bottom: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 12px;
}

.preview-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
  min-height: 500px;
  padding: 25px;
  color: var(--ui-muted);
}

.preview-empty > i {
  font-size: 45px;
  color: var(--ui-muted);
}

.preview-empty strong {
  font-size: 13px;
  font-weight: 600;
}

.preview-empty p {
  font-size: 12px;
  line-height: 1.8;
}

.file-metadata {
  padding: 23px;
  background: var(--ui-paper);
  border-left: 1px solid var(--ui-line);
  max-height: 75vh;
  overflow: auto;
}

.metadata-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.metadata-heading h3 {
  font-size: 13px;
  font-weight: 600;
}

.file-metadata dl {
  margin: 17px 0 24px;
}

.file-metadata dl > div {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 12px;
  line-height: 1.7;
}

.file-metadata dt {
  color: var(--ui-muted);
  flex-shrink: 0;
}

.file-metadata dd {
  margin: 0;
  text-align: right;
  color: var(--ui-text);
  overflow-wrap: anywhere;
  min-width: 0;
}

.file-metadata h4 {
  font-size: 12px;
  font-weight: 600;
  border-top: 1px solid var(--ui-line);
  padding-top: 20px;
  margin: 0;
}

.file-metadata a {
  color: var(--ui-accent);
  text-underline-offset: 3px;
}

.file-metadata .checksum {
  font-size: 12px;
  font-family: monospace;
}

.unregistered-note {
  font-size: 12px;
  line-height: 1.8;
  color: var(--ui-muted);
  padding-top: 20px;
  border-top: 1px solid var(--ui-line);
}

button:focus-visible, a:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

@media (max-width: 1200px) {
  .drive-table th:first-child {
    width: 55%;
  }
  .drive-table th:nth-child(2) {
    width: 23%;
  }
  .drive-table th:nth-child(3) {
    width: 22%;
  }
  .drive-table th:nth-child(4), .drive-table td:nth-child(4) {
    display: none;
  }
  .drive-toolbar {
    padding: 18px;
  }
  .drive-search {
    width: 100%;
  }
}
@media (max-width: 800px) {
  .drive-shell {
    min-height: 600px;
  }
  .drive-toolbar {
    gap: 15px;
  }
  .drive-table td, .drive-table th {
    padding-right: 12px;
    padding-left: 12px;
  }
  .drive-table td:first-child, .drive-table th:first-child {
    padding-left: 16px;
  }
  .drive-file {
    gap: 7px;
  }
  .drive-file-icon {
    width: 25px;
  }
  .drive-table th:first-child {
    width: 57%;
  }
  .drive-table th:nth-child(2) {
    width: 23%;
  }
  .drive-table th:nth-child(3) {
    width: 20%;
  }
  .file-size {
    font-size: 12px;
  }
  .drive-file strong {
    font-size: 14px;
  }
  .drive-list-heading {
    padding: 10px 16px;
  }
  .drive-file-icon.is-folder {
    font-size: 22px;
  }
  .folder-arrow {
    display: none;
  }
  .file-dialog {
    width: calc(100% - 24px);
    max-height: calc(100dvh - 24px);
  }
  .preview-body {
    grid-template-columns: 1fr;
  }
  .file-preview iframe {
    height: 52vh;
    min-height: 340px;
  }
  .file-preview pre {
    max-height: 45vh;
  }
  .preview-empty {
    min-height: 200px;
  }
  .file-metadata {
    max-height: none;
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .file-dialog-header {
    padding: 16px 20px;
  }
  .file-metadata dl > div {
    font-size: 13px;
  }
  .file-metadata .file-path {
    max-width: 220px;
  }
  .path-bar button {
    max-width: 200px;
  }
}
@media (prefers-reduced-motion: reduce) {
  * {
    scroll-behavior: auto !important;
  }
}
.drive-shell {
  height: calc(100dvh - 220px);
  min-height: 520px;
}

.file-pane, .drive-table-wrap {
  min-height: 0;
}

.drive-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.pdf-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  font-size: 12px;
  color: var(--ui-muted);
  padding: 7px 12px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-soft);
}

.pdf-canvas {
  height: 66vh;
  min-height: 500px;
  overflow: auto;
  padding: 20px;
  text-align: center;
}

.pdf-canvas img {
  max-width: 100%;
  height: auto;
  box-shadow: 0 3px 20px rgba(35, 39, 47, 0.0941176471);
  background: var(--ui-paper);
}

.pdf-canvas img.is-loading {
  opacity: 0.25;
}

.pdf-status {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: var(--ui-muted);
}

@media (max-width: 800px) {
  .drive-shell {
    height: calc(100dvh - 205px);
    min-height: 520px;
  }
  .pdf-canvas {
    height: 48vh;
    min-height: 300px;
    padding: 12px;
  }
}
.drive-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.drive-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -8px 0 16px;
  padding: 9px 14px;
  border: 1px solid var(--ui-line);
  background: var(--ui-soft);
  color: var(--ui-muted);
  border-radius: 9px;
  font-size: 13px;
}

.source-form-dialog {
  width: calc(100% - 32px);
  max-width: 620px;
  border: 0;
  border-radius: 16px;
  padding: 25px 28px;
  color: var(--ui-ink);
  max-height: calc(100dvh - 40px);
  overflow: auto;
  box-shadow: 0 28px 90px rgba(35, 39, 47, 0.1450980392);
}

.source-form-dialog::backdrop {
  background: rgba(35, 39, 47, 0.4);
  backdrop-filter: blur(4px);
}

.folder-form-dialog {
  max-width: 420px;
}

.source-form-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 22px;
}

.source-form-heading h2 {
  font-size: 18px;
  font-weight: 600;
}

.source-form-heading p {
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 8px;
}

.source-form-heading .icon-button {
  font-size: 22px;
  width: 38px;
  height: 38px;
}

.source-file-picker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 18px;
  background: var(--ui-soft);
  border: 1px dashed var(--ui-control);
  border-radius: 10px;
  margin-bottom: 22px;
  cursor: pointer;
  color: var(--ui-muted);
}

.source-file-picker strong {
  font-size: 13px;
  color: var(--ui-muted);
  font-weight: 600;
  overflow-wrap: anywhere;
  text-align: center;
}

.source-file-picker > span {
  font-size: 12px;
  color: var(--ui-muted);
}

.source-file-picker input {
  position: absolute;
  inset: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.source-file-picker:focus-within {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.source-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.source-form-grid .field {
  margin: 0;
  min-width: 0;
}

.source-form-grid .full-width {
  grid-column: 1/-1;
}

.source-form-dialog .field label {
  font-size: 13px;
  color: var(--ui-muted);
  font-weight: 600;
}

.source-form-dialog .field label > span {
  font-size: 12px;
  color: var(--ui-muted);
  font-weight: 450;
  margin-left: 5px;
}

.source-form-dialog input, .source-form-dialog select, .source-form-dialog textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--ui-line);
  border-radius: 8px;
  padding: 11px 12px;
  font: inherit;
  font-size: 13px;
  color: var(--ui-text);
  background: var(--ui-paper);
}

.source-form-dialog textarea {
  resize: vertical;
  min-height: 70px;
  max-height: 160px;
}

.source-form-dialog input:focus, .source-form-dialog select:focus, .source-form-dialog textarea:focus {
  outline: 2px solid var(--ui-selected);
  border-color: var(--ui-accent);
}

.source-form-dialog input:disabled, .source-form-dialog select:disabled, .source-form-dialog textarea:disabled {
  background: var(--ui-soft);
  color: var(--ui-muted);
}

.input-note {
  display: block;
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 7px;
}

.registration-file-name {
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 13px;
  background: var(--ui-soft);
  border-radius: 8px;
  padding: 13px;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
  margin-bottom: 20px;
}

.registration-note {
  font-size: 12px;
  line-height: 1.8;
  color: var(--ui-muted);
  margin: 18px 0;
}

.source-form-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 22px;
}

.source-form-footer .button {
  font-size: 13px;
  min-height: 39px;
  padding: 10px 15px;
}

.registration-progress {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 14px 0;
  font-size: 12px;
  color: var(--ui-muted);
}

.registration-progress progress {
  width: 100%;
  height: 5px;
  accent-color: var(--ui-accent);
}

.registered-result {
  border: 1px solid var(--ui-line);
  border-radius: 9px;
  margin-top: 12px;
  overflow: hidden;
}

.registered-result button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  padding: 12px 14px;
  border-bottom: 1px solid var(--ui-line);
  text-align: left;
  font-size: 13px;
  color: var(--ui-muted);
}

.registered-result button:last-child {
  border-bottom: 0;
}

.registered-result small {
  font-size: 12px;
  white-space: nowrap;
  color: var(--ui-muted);
}

.version-actions {
  margin: 12px 0;
}

.version-actions .button, .unregistered-note .button {
  font-size: 12px;
  padding: 9px 12px;
  min-height: 34px;
}

.version-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0 20px;
  font-size: 12px;
  color: var(--ui-muted);
}

.version-links button {
  text-align: left;
  line-height: 1.7;
}

.unregistered-note .button {
  margin-top: 12px;
}

@media (max-width: 800px) {
  .drive-actions {
    margin-left: auto;
  }
  .source-form-dialog {
    padding: 20px;
  }
  .source-form-grid {
    gap: 14px;
  }
  .source-form-grid .field {
    grid-column: 1/-1;
  }
  .source-form-dialog {
    max-height: calc(100dvh - 24px);
  }
}
.extraction-entry {
  margin: 12px 0;
}

.extraction-entry .button {
  font-size: 13px;
  padding: 9px 12px;
}

.extraction-dialog {
  border: 0;
  border-radius: 16px;
  width: calc(100% - 40px);
  max-width: 1280px;
  max-height: calc(100dvh - 32px);
  padding: 0;
  overflow: auto;
  color: var(--ui-ink);
  box-shadow: 0 28px 90px rgba(35, 39, 47, 0.1450980392);
}

.extraction-dialog::backdrop {
  background: rgba(35, 39, 47, 0.4);
  backdrop-filter: blur(4px);
}

.extraction-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 22px 26px;
  border-bottom: 1px solid var(--ui-line);
}

.extraction-heading h2 {
  font-size: 16px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.extraction-heading .icon-button {
  font-size: 22px;
}

.extraction-controls {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 18px 26px;
  background: var(--ui-soft);
}

.extraction-controls label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  color: var(--ui-muted);
}

.extraction-controls input {
  width: 86px;
  padding: 9px;
  border: 1px solid var(--ui-line);
  border-radius: 7px;
  color: var(--ui-text);
  background: var(--ui-paper);
}

.extraction-controls .button {
  font-size: 13px;
  min-height: 38px;
  padding: 8px 16px;
}

.range-divider {
  padding-bottom: 10px;
  color: var(--ui-muted);
}

.extraction-provider {
  font-size: 12px;
  line-height: 1.8;
  color: var(--ui-muted);
  padding-bottom: 2px;
}

.extraction-message {
  margin: 16px 26px;
  font-size: 13px;
  line-height: 1.8;
}

.extraction-empty {
  padding: 55px 20px;
  text-align: center;
  color: var(--ui-muted);
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  font-size: 13px;
}

.extraction-empty i {
  font-size: 30px;
  color: var(--ui-muted);
}

.extraction-empty strong {
  color: var(--ui-muted);
  font-weight: 600;
}

.extraction-jobbar {
  padding: 14px 26px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: var(--ui-muted);
  flex-wrap: wrap;
}

.extraction-jobbar select {
  font: inherit;
  color: var(--ui-text);
  max-width: 100%;
  border: 1px solid var(--ui-line);
  border-radius: 7px;
  background: var(--ui-paper);
  padding: 9px;
}

.extraction-jobbar .button {
  font-size: 12px;
  padding: 7px 10px;
  min-height: 32px;
}

.extraction-jobbar .icon-button {
  margin-left: auto;
}

.extraction-total-progress {
  display: block;
  width: 100%;
  height: 3px;
  accent-color: var(--ui-accent);
}

.extraction-page-list {
  display: flex;
  gap: 7px;
  padding: 14px 26px;
  overflow: auto;
  border-bottom: 1px solid var(--ui-line);
}

.extraction-page-list button {
  display: flex;
  align-items: center;
  gap: 9px;
  white-space: nowrap;
  padding: 8px 11px;
  border-radius: 7px;
  border: 1px solid var(--ui-line);
  font-size: 13px;
  color: var(--ui-muted);
}

.extraction-page-list button span {
  font-size: 12px;
  color: var(--ui-muted);
}

.extraction-page-list button.active {
  background: var(--ui-accent);
  border-color: var(--ui-accent);
  color: var(--ui-paper);
}

.extraction-page-list button.active span {
  color: inherit;
}

.extraction-page-list button.failed:not(.active) span {
  color: var(--ui-danger);
}

.extraction-comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 360px;
}

.extraction-original {
  background: var(--ui-soft);
  border-right: 1px solid var(--ui-line);
  min-width: 0;
}

.extraction-original img {
  width: 100%;
  height: auto;
  display: block;
  padding: 14px;
}

.extraction-section-title {
  padding: 14px 20px;
  font-size: 13px;
  color: var(--ui-muted);
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
  display: flex;
  gap: 12px;
  align-items: center;
}

.extraction-section-title span {
  font-size: 12px;
  background: var(--ui-selected);
  padding: 3px 7px;
  border-radius: 5px;
  color: var(--ui-accent);
}

.extraction-text {
  min-width: 0;
}

.extraction-block {
  margin: 20px 23px;
}

.extraction-kind {
  font-size: 12px;
  color: var(--ui-muted);
}

.extraction-block pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: inherit;
  font-size: 13px;
  line-height: 1.9;
  color: var(--ui-text);
  margin: 8px 0;
}

.extraction-warning {
  background: #fff9ed;
  color: var(--ui-warning);
  font-size: 12px;
  line-height: 1.8;
  padding: 9px 12px;
  margin: 14px 20px;
  border-radius: 7px;
}

.extraction-block .extraction-warning {
  margin: 8px 0;
}

.extraction-trace {
  border-top: 1px solid var(--ui-line);
  padding: 14px 23px;
  color: var(--ui-muted);
  font-size: 12px;
}

@media (max-width: 800px) {
  .extraction-dialog {
    width: calc(100% - 20px);
    max-height: calc(100dvh - 20px);
  }
  .extraction-heading {
    padding: 16px;
  }
  .extraction-controls {
    padding: 16px;
    gap: 8px;
    flex-wrap: wrap;
  }
  .extraction-provider {
    width: 100%;
  }
  .extraction-jobbar, .extraction-page-list {
    padding: 12px 16px;
  }
  .extraction-comparison {
    grid-template-columns: 1fr;
  }
  .extraction-original {
    border-right: 0;
  }
  .extraction-original img {
    max-height: 45vh;
    object-fit: contain;
  }
  .extraction-block {
    margin: 17px;
  }
  .extraction-controls input {
    width: 70px;
  }
}
.extraction-total-progress {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  background: var(--ui-canvas);
}

.extraction-total-progress::-webkit-progress-bar {
  background: var(--ui-canvas);
}

.extraction-total-progress::-webkit-progress-value {
  background: var(--ui-accent);
}

.extraction-total-progress::-moz-progress-bar {
  background: var(--ui-accent);
}

/* Desktop comparison keeps each reading pane independent; mobile uses one document view. */
.extraction-dialog[open] {
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 40px);
  overflow: hidden;
}

.extraction-heading {
  padding: 10px 16px;
  flex-shrink: 0;
}

.extraction-heading h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 650;
}

.extraction-heading-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.extraction-heading-actions .button {
  min-height: 34px;
  font-size: 13px;
  padding: 8px 12px;
}

.extraction-controls {
  padding: 10px 16px;
  flex-shrink: 0;
}

.extraction-jobbar {
  padding: 6px 16px;
  gap: 10px;
  flex-shrink: 0;
}

.extraction-page-list {
  padding: 6px 16px;
  flex-shrink: 0;
}

.extraction-comparison {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.extraction-original, .extraction-text {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.extraction-section-title {
  min-height: 40px;
  padding: 6px 16px;
  flex-shrink: 0;
  color: var(--ui-text);
}

.extraction-section-title strong {
  font-weight: 600;
}

.extraction-text-toggle {
  margin-left: auto;
  color: var(--ui-accent);
  font-size: 13px;
  white-space: nowrap;
}

.extraction-zoom {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.extraction-zoom .icon-button {
  width: 28px;
  height: 28px;
  font-size: 17px;
}

.extraction-zoom span {
  width: 40px;
  text-align: center;
  background: none;
  padding: 0;
  color: var(--ui-muted);
}

.extraction-paper {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 18px;
}

.extraction-original .extraction-paper img {
  max-width: none;
  max-height: none;
  display: block;
  height: auto;
  padding: 0;
  margin: 0 auto;
  box-shadow: 0 2px 12px rgba(35, 39, 47, 0.0941176471);
}

.extraction-editor-toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 6px 16px;
  border-bottom: 1px solid var(--ui-line);
  flex-shrink: 0;
  min-height: 48px;
}

.extraction-editor-toolbar select {
  max-width: 175px;
  padding: 7px 9px;
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  color: var(--ui-text);
  font: inherit;
  font-size: 13px;
  background: var(--ui-paper);
}

.revision-author {
  color: var(--ui-muted);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.editor-actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}

.editor-actions .button {
  min-height: 34px;
  padding: 7px 13px;
  font-size: 13px;
  white-space: nowrap;
}

.extraction-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.extraction-saved-text {
  padding: 20px 24px;
  margin: 0;
  color: var(--ui-ink);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: inherit;
  font-size: 16px;
  line-height: 1.85;
  tab-size: 4;
}

.extraction-edit {
  display: block;
  flex: 1;
  width: calc(100% - 28px);
  min-height: 250px;
  margin: 14px;
  padding: 14px;
  resize: none;
  border: 1px solid var(--ui-control);
  border-radius: 7px;
  outline: none;
  background: var(--ui-paper);
  color: var(--ui-ink);
  font: inherit;
  font-size: 14px;
  line-height: 1.9;
  tab-size: 4;
}

.extraction-edit:focus {
  border-color: var(--ui-accent);
  box-shadow: 0 0 0 2px rgba(40, 88, 214, 0.0705882353);
}

.extraction-edit:disabled {
  background: var(--ui-soft);
}

.extraction-editor-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  flex-shrink: 0;
  min-height: 41px;
  padding: 11px 18px;
  border-top: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 12px;
}

.extraction-message {
  flex-shrink: 0;
}

.extraction-dialog > .extraction-message {
  margin: 8px 22px;
}

.extraction-dialog select:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

@media (max-width: 800px) {
  .extraction-dialog[open] {
    height: calc(100dvh - 20px);
    overflow: auto;
  }
  .extraction-heading {
    padding: 12px 16px;
  }
  .extraction-heading-actions {
    gap: 5px;
  }
  .extraction-comparison {
    display: flex;
    flex-direction: column;
    overflow: visible;
    flex: none;
    min-height: 0;
  }
  .extraction-original {
    height: auto;
    flex-shrink: 0;
    border-bottom: 1px solid var(--ui-line);
  }
  .extraction-text {
    min-height: 0;
    height: auto;
    flex-shrink: 0;
  }
  .extraction-controls, .extraction-jobbar, .extraction-page-list {
    padding: 10px 14px;
  }
  .extraction-editor-toolbar, .extraction-section-title {
    padding: 9px 12px;
  }
  .extraction-editor-toolbar select {
    max-width: 150px;
  }
  .revision-author {
    display: none;
  }
  .extraction-edit {
    font-size: 16px;
    min-height: 200px;
  }
  .extraction-editor-footer {
    padding: 10px 12px;
  }
  .extraction-saved-text {
    padding: 18px;
  }
}
.queue-panel {
  border: 1px solid var(--ui-line);
  border-radius: 10px;
  background: var(--ui-paper);
  margin: 0 0 14px;
  overflow: hidden;
}

.queue-summary {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  min-height: 52px;
  padding: 12px 18px;
  text-align: left;
  color: var(--ui-muted);
  font-size: 13px;
}

.queue-summary strong {
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-text);
}

.queue-summary strong i {
  margin-right: 7px;
  color: var(--ui-accent);
}

.queue-summary > i {
  margin-left: auto;
  font-size: 10px;
}

.queue-live {
  color: var(--ui-accent);
}

.queue-details {
  border-top: 1px solid var(--ui-line);
}

.queue-row {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 13px 18px;
  border-bottom: 1px solid var(--ui-line);
}

.queue-row:last-child {
  border-bottom: 0;
}

.queue-file {
  flex: 1;
  min-width: 0;
}

.queue-file strong {
  display: block;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ui-text);
}

.queue-file > span {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: var(--ui-muted);
}

.queue-file progress {
  display: block;
  max-width: 300px;
  width: 100%;
  height: 3px;
  margin-top: 9px;
  accent-color: var(--ui-accent);
}

.queue-actions {
  display: flex;
  gap: 7px;
  align-items: center;
}

.queue-actions .button {
  font-size: 12px;
  min-height: 32px;
  padding: 7px 10px;
  white-space: nowrap;
}

.queue-stopping {
  font-size: 12px;
  color: var(--ui-warning);
}

.queue-empty, .queue-error {
  padding: 16px 18px;
  color: var(--ui-muted);
  font-size: 13px;
}

.queue-error {
  color: var(--ui-danger);
}

.queue-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  padding: 6px;
}

.file-check {
  accent-color: var(--ui-accent);
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  cursor: pointer;
}

.drive-file-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.file-check:disabled {
  opacity: 0.3;
  cursor: default;
}

.file-extraction-state {
  display: block;
  margin-top: 7px;
  color: var(--ui-muted);
  font-size: 12px;
  white-space: nowrap;
}

.file-extraction-state.running {
  color: var(--ui-accent);
}

.file-extraction-state:hover {
  text-decoration: underline;
}

.batch-description {
  font-size: 13px;
  line-height: 1.8;
  color: var(--ui-muted);
  margin: 14px 0;
}

.batch-total {
  display: flex;
  gap: 18px;
  align-items: baseline;
  padding: 18px 0;
  color: var(--ui-accent);
}

.batch-total strong {
  font-size: 22px;
  font-weight: 600;
}

.batch-total span {
  font-size: 16px;
}

.batch-items {
  max-height: 270px;
  overflow: auto;
  border-top: 1px solid var(--ui-line);
  border-bottom: 1px solid var(--ui-line);
}

.batch-items > div {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 11px 0;
  font-size: 13px;
}

.batch-items span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.batch-items small {
  font-size: 12px;
  color: var(--ui-muted);
  flex-shrink: 0;
}

.drive-shell {
  height: calc(100dvh - 202px);
  min-height: 400px;
}

@media (max-width: 800px) {
  .queue-summary {
    gap: 12px;
    padding: 12px;
  }
  .queue-summary strong {
    font-size: 13px;
  }
  .queue-summary > span {
    font-size: 12px;
  }
  .queue-row {
    padding: 12px;
    flex-wrap: wrap;
  }
  .queue-file {
    flex-basis: 100%;
  }
  .queue-actions {
    margin-left: auto;
  }
  .drive-file-cell, .drive-name-heading {
    gap: 7px;
  }
  .drive-table th:first-child {
    width: 53%;
  }
  .drive-table th:nth-child(2) {
    width: 29%;
  }
  .drive-table th:nth-child(3) {
    width: 18%;
  }
  .batch-items > div {
    flex-wrap: wrap;
    gap: 5px;
  }
  .batch-items span {
    width: 100%;
  }
  .drive-shell {
    height: calc(100dvh - 275px);
  }
}
.queue-head {
  display: flex;
  align-items: center;
}

.queue-summary {
  flex: 1;
  min-width: 0;
}

.queue-stop-all {
  margin-right: 14px;
  font-size: 12px;
  min-height: 32px;
  padding: 7px 10px;
  flex-shrink: 0;
}

.quality-panel {
  margin: 0 0 14px;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: hidden;
}

.quality-summary {
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;
  padding: 14px 18px;
  text-align: left;
  font-size: 13px;
  color: var(--ui-muted);
}

.quality-summary strong {
  font-size: 13px;
  color: var(--ui-text);
  white-space: nowrap;
}

.quality-summary strong i {
  margin-right: 6px;
}

.quality-summary > i {
  margin-left: auto;
  font-size: 10px;
}

.needs-check {
  color: var(--ui-warning) !important;
}

.quality-details {
  border-top: 1px solid var(--ui-line);
}

.quality-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  font-size: 13px;
}

.quality-filters button {
  padding: 6px 9px;
  color: var(--ui-muted);
  border-radius: 6px;
}

.quality-filters button.active {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.quality-filters > span {
  margin-left: auto;
  font-size: 12px;
  color: var(--ui-muted);
}

.quality-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 18px;
  border-top: 1px solid var(--ui-line);
}

.quality-file {
  min-width: 0;
  flex: 1;
}

.quality-file strong {
  display: block;
  font-size: 13px;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.quality-file strong span {
  margin-left: 6px;
  color: var(--ui-muted);
  font-weight: 450;
}

.quality-file small {
  display: block;
  margin-top: 5px;
  color: var(--ui-muted);
  font-size: 12px;
}

.quality-row .button {
  font-size: 12px;
  min-height: 32px;
  padding: 7px 10px;
  flex-shrink: 0;
}

.quality-empty, .quality-error {
  padding: 14px 18px;
  font-size: 13px;
  color: var(--ui-muted);
}

.quality-error {
  color: var(--ui-warning);
}

.quality-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 6px 14px;
  font-size: 13px;
  color: var(--ui-muted);
}

.page-quality {
  padding: 0 16px;
}

.quality-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 10px 0;
}

.quality-flags > span {
  background: #fbf5e9;
  color: var(--ui-warning);
  border-radius: 5px;
  padding: 4px 7px;
  font-size: 12px;
}

.quality-flags small {
  flex-basis: 100%;
  color: var(--ui-muted);
  font-size: 12px;
}

.quality-page-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.quality-page-actions .button {
  min-height: 30px;
  padding: 6px 10px;
  font-size: 12px;
}

.quality-confirmed {
  display: block;
  padding: 8px 0;
  font-size: 12px;
  color: var(--ui-muted);
}

@media (max-width: 620px) {
  .quality-summary {
    gap: 10px;
    padding: 12px;
  }
  .quality-ok {
    display: none;
  }
  .quality-filters {
    flex-wrap: wrap;
    gap: 6px;
  }
  .quality-filters > span {
    width: 100%;
    margin-left: 9px;
  }
  .quality-row {
    padding: 10px 12px;
  }
  .quality-file strong {
    font-size: 12px;
  }
}
.drive-table th.item-actions-cell, .drive-table td.item-actions-cell {
  width: 42px;
  padding: 4px;
  text-align: center;
}

.item-more {
  width: 32px;
  height: 32px;
  color: var(--ui-muted);
  border-radius: 6px;
}

.item-more:hover {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.source-item-menu {
  position: fixed;
  inset: auto;
  margin: 0;
  width: 176px;
  border: 0;
  border-radius: 12px;
  padding: 6px;
  background: var(--ui-paper);
  box-shadow: 0 12px 36px rgba(35, 39, 47, 0.1490196078);
  color: var(--ui-text);
}

.source-item-menu button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: left;
  padding: 10px 8px;
  white-space: nowrap;
  font-size: 13px;
  border-radius: 5px;
}

.source-item-menu button:hover, .source-item-menu button:focus-visible {
  background: var(--ui-soft);
  outline: none;
}

.organize-dialog {
  width: calc(100% - 28px);
  max-width: 480px;
}

.rename-form > label {
  display: block;
  font-size: 13px;
  color: var(--ui-muted);
  margin: 20px 22px 8px;
}

.rename-form > input {
  display: block;
  width: calc(100% - 44px);
  margin: 0 22px 20px;
  padding: 11px 12px;
  border: 1px solid var(--ui-line);
  border-radius: 7px;
  color: var(--ui-text);
  font: inherit;
  font-size: 13px;
}

.rename-form > input:focus {
  outline: 2px solid var(--ui-line);
  border-color: var(--ui-control);
}

.rename-form > .form-message, .organize-error {
  margin: 12px 22px;
}

.destination-path {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-bottom: 1px solid var(--ui-line);
  font-size: 13px;
  color: var(--ui-muted);
}

.destination-path button {
  color: var(--ui-muted);
  overflow-wrap: anywhere;
  text-align: left;
}

.destination-path button:last-child {
  color: var(--ui-accent);
}

.destination-list {
  height: 280px;
  overflow: auto;
  padding: 8px;
}

.destination-list > p {
  padding: 24px 12px;
  text-align: center;
  color: var(--ui-muted);
  font-size: 13px;
}

.destination-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 46px;
  padding: 10px 12px;
  text-align: left;
  border-radius: 6px;
  color: var(--ui-text);
  font-size: 13px;
}

.destination-row:hover:not(:disabled) {
  background: var(--ui-soft);
}

.destination-row:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.destination-row > span {
  flex: 1;
  overflow-wrap: anywhere;
}

.destination-row > .fa-folder {
  color: var(--ui-control);
}

.destination-row > .fa-chevron-right {
  font-size: 9px;
  color: var(--ui-muted);
}

.destination-pagination {
  display: flex;
  justify-content: center;
  gap: 14px;
  align-items: center;
  font-size: 12px;
  color: var(--ui-muted);
}

.destination-pagination button {
  padding: 8px;
}

@media (max-width: 800px) {
  .drive-table th:first-child {
    width: calc(53% - 42px);
  }
  .selection-actions {
    flex-wrap: wrap;
    gap: 8px;
  }
  .drive-list-heading {
    flex-wrap: wrap;
    gap: 10px;
  }
  .destination-list {
    height: 250px;
  }
}
@media (max-width: 480px) {
  .drive-table th:nth-child(3), .drive-table td:nth-child(3) {
    display: none;
  }
  .drive-table th:first-child {
    width: calc(100% - 108px);
  }
  .drive-table th:nth-child(2) {
    width: 72px;
  }
  .drive-table th.item-actions-cell, .drive-table td.item-actions-cell {
    width: 36px;
  }
  .item-more {
    width: 28px;
  }
}
.trash-pane {
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 210px);
  min-height: 380px;
}

.trash-toolbar-actions, .trash-select-all {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: var(--ui-muted);
}

.trash-toolbar-actions {
  flex-wrap: wrap;
}

.trash-list {
  flex: 1;
  overflow: auto;
}

.trash-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--ui-line);
}

.trash-file {
  flex: 1;
  min-width: 0;
}

.trash-file strong, .trash-file small {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.trash-file strong {
  font-size: 13px;
  color: var(--ui-text);
  font-weight: 600;
}

.trash-file small {
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 5px;
}

.trash-file > span {
  display: block;
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 6px;
}

.trash-row-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.trash-row-actions .button {
  min-height: 32px;
  padding: 7px 12px;
  font-size: 13px;
}

.danger-text {
  color: var(--ui-danger) !important;
}

.danger-button {
  background: var(--ui-danger) !important;
  border-color: var(--ui-danger) !important;
}

.trash-confirm {
  max-width: 450px;
}

.trash-confirm-body {
  padding: 20px 22px;
  font-size: 13px;
  color: var(--ui-text);
}

.trash-confirm-body > strong {
  display: block;
  overflow-wrap: anywhere;
  font-weight: 600;
}

.trash-confirm-body > p {
  font-size: 13px;
  line-height: 1.8;
  margin: 12px 0 0;
  color: var(--ui-muted);
}

.trash-progress {
  display: flex;
  gap: 9px;
  align-items: center;
}

@media (max-width: 620px) {
  .trash-pane {
    height: calc(100dvh - 235px);
  }
  .trash-row {
    gap: 8px;
    padding: 14px 12px;
    flex-wrap: wrap;
  }
  .trash-row > .drive-file-icon {
    width: 28px;
  }
  .trash-row-actions {
    margin-left: auto;
  }
  .trash-toolbar-actions {
    gap: 8px;
  }
  .trash-pane .drive-toolbar {
    align-items: stretch;
  }
  .trash-file {
    min-width: 100px;
  }
  .trash-row-actions .button {
    padding: 6px 8px;
  }
  .trash-confirm-body {
    padding: 18px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .trash-confirm, .trash-pane {
    animation: none;
    transition: none;
  }
}
.download-status {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 40;
  width: 340px;
  max-width: calc(100vw - 32px);
  padding: 17px 18px;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(35, 39, 47, 0.1098039216);
  color: var(--ui-text);
}

.download-status-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.download-status-head > strong {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
}

.download-status-head > i {
  font-size: 13px;
  color: var(--ui-accent);
}

.download-status-head .icon-button {
  width: 24px;
  height: 24px;
}

.download-name {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 12px 0 8px;
  color: var(--ui-muted);
}

.download-status progress {
  display: block;
  width: 100%;
  height: 4px;
  accent-color: var(--ui-accent);
  margin: 12px 0 7px;
}

.download-status small {
  font-size: 12px;
  color: var(--ui-muted);
}

.download-message {
  font-size: 13px;
  line-height: 1.7;
  color: var(--ui-warning);
  margin: 10px 0;
}

.download-status-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.download-status-actions:empty {
  display: none;
}

.download-status-actions .button {
  min-height: 30px;
  padding: 6px 10px;
  font-size: 12px;
}

.source-item-menu button:disabled {
  opacity: 0.4;
  cursor: default;
}

@media (max-width: 620px) {
  .download-status {
    right: 16px;
    bottom: 16px;
    width: calc(100vw - 32px);
  }
}
.drive-actions > .button, .selection-actions .button {
  white-space: nowrap;
  flex-shrink: 0;
}

@media (max-width: 480px) {
  .drive-actions {
    display: flex;
    width: auto;
  }
  .drive-actions > .button {
    justify-content: center;
    min-width: 0;
  }
}
.source-item-menu button > i {
  width: 14px;
  text-align: center;
  flex-shrink: 0;
  color: var(--ui-muted);
}

.source-item-menu .menu-trash:hover, .source-item-menu .menu-trash:focus-visible {
  color: var(--ui-danger);
  background: #fcf0f0;
}

.source-item-menu .menu-trash:hover > i, .source-item-menu .menu-trash:focus-visible > i {
  color: inherit;
}

@media (pointer: coarse) {
  .source-item-menu button {
    min-height: 44px;
  }
}
/* Main document text carries more weight than metadata. */
.drive-file strong, .queue-file strong, .quality-file strong, .trash-file strong {
  font-size: 14px;
  font-weight: 600;
  color: var(--ui-text);
}

.drive-file, .file-preview pre, .file-metadata dd, .destination-row, .source-item-menu {
  color: var(--ui-text);
}

.drive-state.registered {
  color: var(--ui-success);
}

.drive-state.warning {
  color: var(--ui-warning);
}

.needs-check {
  color: var(--ui-warning) !important;
}

.drive-table th {
  font-weight: 600;
}

.path-bar button, .source-item-menu button, .selection-extract {
  font-weight: 550;
}

.source-item-menu button {
  font-size: 14px;
}

.drive-search input {
  font-size: 14px;
}

.file-preview pre {
  font-size: 14px;
}

/* Keep global processing separate from the current folder's file list. */
.processing-overview {
  margin-bottom: 12px;
  border: 1px solid var(--ui-line);
  border-radius: 9px;
  background: var(--ui-paper);
}

.processing-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  padding: 2px 10px;
}

.processing-scope {
  font-size: 12px;
  color: var(--ui-muted);
  padding-right: 9px;
  margin-right: 3px;
  border-right: 1px solid var(--ui-line);
  white-space: nowrap;
}

.processing-toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 36px;
  padding: 6px 9px;
  border-radius: 6px;
  font-size: 13px;
  color: var(--ui-text);
  white-space: nowrap;
}

.processing-toggle b {
  font-weight: 650;
  font-variant-numeric: tabular-nums;
}

.processing-toggle > .fa-chevron-down {
  font-size: 9px;
  margin-left: 3px;
}

.processing-toggle:hover, .processing-toggle.active {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.processing-toggle.active > .fa-chevron-down {
  transform: rotate(180deg);
}

.processing-bar .queue-stop-all {
  margin-left: auto;
  margin-right: 0;
}

.processing-overview .queue-panel, .processing-overview .quality-panel {
  margin: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.processing-overview .queue-details, .processing-overview .quality-details {
  border-top: 1px solid var(--ui-line);
}

.drive-content .page-heading {
  flex-wrap: nowrap;
  min-height: 40px;
}

.drive-more {
  width: 40px;
  padding: 0;
  justify-content: center;
}

.drive-toolbar {
  padding: 10px 16px;
  gap: 10px;
}

.drive-search {
  width: 230px;
}

.path-bar button {
  min-height: 36px;
}

.drive-list-heading {
  padding: 5px 16px;
  min-height: 44px;
}

.list-location select {
  max-width: 150px;
  min-height: 36px;
  padding: 5px 22px 5px 0;
  border: 0;
  background-color: transparent;
  font: inherit;
  font-size: 13px;
  font-weight: 550;
  color: var(--ui-text);
}

.list-location select:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.drive-table th {
  padding-top: 7px;
  padding-bottom: 7px;
}

.drive-table td {
  height: 54px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.drive-table th:first-child, .drive-table td:first-child {
  padding-left: 16px;
}

.file-select {
  display: grid;
  place-items: center;
  width: 32px;
  min-height: 40px;
  flex-shrink: 0;
  cursor: pointer;
}

.file-select .file-check {
  margin: 0;
}

.drive-name-heading {
  min-height: 32px;
}

.drive-name-heading .file-check {
  margin-left: 8.5px;
  margin-right: 8.5px;
}

.drive-file-cell {
  gap: 5px;
}

.parent-check-space {
  width: 32px;
}

.drive-file small.mobile-file-state {
  display: none;
}

.file-work-state {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 36px;
  text-align: left;
  font-size: 12px;
  color: var(--ui-accent);
  font-weight: 550;
  white-space: nowrap;
}

.file-work-state i {
  font-size: 9px;
}

.file-work-state:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.drive-menu {
  width: 210px;
}

.drive-menu label {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  border-top: 1px solid var(--ui-line);
  margin-top: 4px;
}

.drive-menu label input {
  width: 16px;
  height: 16px;
  accent-color: var(--ui-accent);
}

@media (max-width: 1200px) {
  .drive-search {
    width: 230px;
  }
}
@media (max-width: 800px) {
  .drive-shell {
    height: calc(100dvh - 208px);
    min-height: 400px;
  }
  .drive-toolbar {
    padding: 10px 12px;
  }
  .drive-list-heading {
    padding: 5px 12px;
  }
}
@media (max-width: 620px) {
  .drive-content .page-heading {
    gap: 8px;
    margin-bottom: 10px;
  }
  .drive-content .page-title {
    flex-shrink: 0;
  }
  .drive-content .page-title h1 {
    font-size: 21px;
    margin: 0;
  }
  .drive-actions {
    gap: 5px;
  }
  .drive-actions > .button {
    min-height: 44px;
    padding: 9px 10px;
    font-size: 13px;
  }
  .drive-actions > .drive-more, .drive-actions > .folder-create {
    width: 40px;
    padding: 0;
  }
  .folder-create > span {
    display: none;
  }
  .processing-bar {
    flex-wrap: wrap;
    gap: 0;
    padding: 3px 7px;
  }
  .processing-scope {
    flex-basis: 100%;
    border: 0;
    margin: 0;
    padding: 3px 6px 0;
    font-size: 12px;
  }
  .processing-toggle {
    padding: 5px 6px;
    min-height: 40px;
    font-size: 13px;
  }
  .processing-toggle > i:first-child {
    display: none;
  }
  .processing-bar .queue-stop-all {
    padding: 6px;
    font-size: 12px;
    min-height: 40px;
  }
  .drive-toolbar {
    gap: 7px;
  }
  .drive-location {
    flex-basis: 100%;
  }
  .drive-search {
    width: 100%;
  }
  .drive-search input {
    padding: 8px 0;
  }
  .path-bar {
    gap: 6px;
  }
  .path-bar button {
    min-height: 28px;
    max-width: 180px;
    font-size: 12px;
  }
  .drive-shell {
    height: calc(100dvh - 230px);
    min-height: 390px;
    border-radius: 10px;
  }
  .drive-table th:nth-child(2), .drive-table td:nth-child(2), .drive-table th:nth-child(3), .drive-table td:nth-child(3) {
    display: none;
  }
  .drive-table th:first-child {
    width: calc(100% - 44px);
  }
  .drive-table th.item-actions-cell, .drive-table td.item-actions-cell {
    width: 44px;
    padding: 0;
  }
  .drive-table th:first-child, .drive-table td:first-child {
    padding-left: 6px;
    padding-right: 0;
  }
  .item-more {
    width: 44px;
    height: 44px;
  }
  .drive-file strong {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }
  .drive-file small.mobile-file-state {
    display: block;
    margin-top: 3px;
    font-size: 12px;
  }
  .drive-file-icon {
    width: 25px;
  }
  .drive-file {
    gap: 8px;
  }
  .drive-table td {
    height: 64px;
  }
  .parent-folder-row td {
    height: 48px;
  }
  .file-select {
    width: 36px;
    min-height: 44px;
  }
  .parent-check-space {
    width: 36px;
  }
  .drive-name-heading .file-check {
    margin-left: 10.5px;
    margin-right: 10.5px;
  }
  .drive-footer {
    padding: 8px 12px;
  }
}
/* The register keeps the working list on one continuous surface. */
.drive-content {
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 64px);
  min-height: 650px;
}

.drive-shell {
  flex: 1;
  border: 0;
  border-radius: 0;
  height: auto;
  min-height: 220px;
  overflow: visible;
}

.drive-toolbar {
  padding: 0 0 18px;
  gap: 16px;
  border-bottom: 0;
}

.drive-location {
  flex: 1 1 180px;
}

.drive-shell .drive-toolbar {
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding-bottom: 10px;
}

.drive-shell .drive-location {
  flex: 0 0 auto;
}

.drive-shell .drive-filters {
  flex: 0 0 auto;
  min-width: 0;
  flex-wrap: nowrap;
}

.drive-shell .drive-search {
  flex: 0 0 250px;
  margin-left: auto;
}

.path-bar button {
  font-size: 14px;
  color: var(--ui-text);
}

.drive-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.drive-search {
  width: 250px;
  border-color: var(--ui-line);
  background: var(--ui-paper);
  border-radius: 6px;
}

.drive-search input {
  font-size: 14px;
  padding: 10px 0;
  color: var(--ui-text);
}

.work-filters {
  display: flex;
  min-width: 0;
  gap: 8px;
}

.work-filter-button {
  flex-shrink: 0;
  min-height: 44px;
  padding: 9px 10px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--ui-text);
  font-size: 14px;
  font-weight: 600;
  transition: color 0.16s, background 0.16s;
  white-space: nowrap;
}

.work-filter-button:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: -2px;
}

.work-filter-button:hover:not(:disabled) {
  background: var(--ui-soft);
  color: var(--ui-accent);
}

.work-filter-button.active {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.drive-list-heading {
  min-height: 52px;
  padding: 4px 12px;
  background: var(--ui-selected);
  border-top: 1px solid var(--ui-line);
}

.selection-actions {
  margin-left: 0;
  gap: 14px;
  font-size: 14px;
  width: 100%;
}

.selection-summary {
  font-weight: 600;
  color: var(--ui-text);
}

.selection-tools {
  padding-left: 12px;
  gap: 4px;
}

.selection-icon {
  color: var(--ui-accent);
  border-radius: 5px;
}

.selection-actions .selection-extract {
  margin-left: 8px;
  color: var(--ui-accent);
  background: transparent;
  box-shadow: none;
  font-size: 14px;
}

.selection-actions .selection-extract:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--ui-accent-hover);
}

.drive-table-wrap {
  overflow: auto;
  max-height: none;
  min-height: 180px;
  border-top: 1px solid var(--ui-line);
}

.drive-table th {
  height: 44px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-text);
  background: var(--ui-soft);
}

.drive-table td {
  height: 56px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom-color: var(--ui-line);
}

.drive-table tr.is-selected, .drive-table tr.is-selected:hover {
  background: var(--ui-selected);
}

.drive-table tr:hover {
  background: var(--ui-soft);
}

.drive-table th:first-child {
  width: 57%;
}

.drive-table th:nth-child(2) {
  width: 17%;
}

.drive-table th:nth-child(3) {
  width: 10%;
}

.drive-table th:nth-child(4) {
  width: 16%;
}

.drive-file strong {
  font-size: 15px;
  font-weight: 550;
  line-height: 1.5;
}

.drive-file-icon.is-folder {
  color: #dca422;
  font-size: 25px;
}

.drive-file-icon.is-pdf {
  color: var(--ui-danger);
  font-size: 23px;
}

.parent-folder-row .drive-file-icon {
  color: var(--ui-accent);
}

.file-check {
  accent-color: var(--ui-accent);
}

.file-size, .file-date, .drive-state, .file-work-state {
  font-size: 13px;
  color: var(--ui-muted);
}

.file-work-state {
  color: var(--ui-accent);
  font-weight: 600;
}

.drive-footer {
  border-top: 1px solid var(--ui-line);
  padding: 10px 0;
  font-size: 13px;
}

.processing-overview {
  flex-shrink: 0;
  margin-top: 6px;
  margin-bottom: 0;
  border: 0;
  border-top: 1px solid var(--ui-line);
  border-radius: 0;
}

.processing-bar {
  padding: 8px 0;
  min-height: 52px;
}

.processing-toggle {
  font-size: 14px;
}

.processing-scope {
  font-size: 13px;
}

.file-dialog-header h2 {
  font-size: 18px;
  margin-top: 0;
}

@media (min-width: 1201px) {
  .drive-table th:nth-child(3), .drive-table th:nth-child(4), .drive-table td:nth-child(4) {
    display: table-cell;
  }
}
@media (max-width: 1200px) {
  .drive-filters {
    flex: 1 1 100%;
  }
  .drive-search {
    flex: 1 1 230px;
  }
  .drive-table th:first-child {
    width: 62%;
  }
  .drive-table th:nth-child(2) {
    width: 23%;
  }
  .drive-table th:nth-child(3) {
    width: 15%;
    display: table-cell;
  }
}
@media (max-width: 760px) {
  .drive-content {
    height: calc(100dvh - 100px);
    min-height: 640px;
  }
  .drive-shell {
    height: auto;
    min-height: 220px;
    border-radius: 0;
  }
  .drive-toolbar {
    padding: 0 0 14px;
    gap: 8px;
  }
  .drive-filters {
    width: 100%;
    gap: 10px;
  }
  .drive-search {
    flex: 1 1 100%;
  }
  .drive-shell .drive-filters {
    flex-wrap: wrap;
    gap: 8px;
  }
  .drive-shell .drive-search {
    flex: 1 1 100%;
  }
  .work-filters {
    width: 100%;
    gap: 4px;
    flex-wrap: wrap;
  }
  .work-filter-button {
    padding-right: 8px;
    padding-left: 8px;
  }
  .drive-table-wrap {
    max-height: none;
    min-height: 180px;
  }
  .drive-content .page-title h1 {
    font-size: 25px;
  }
  .processing-bar {
    flex-wrap: wrap;
  }
  .processing-scope {
    flex-basis: 100%;
    border: 0;
    padding: 3px 6px;
  }
}
@media (max-width: 620px) {
  .drive-table th:nth-child(3) {
    display: none;
  }
  .drive-table th:first-child {
    width: calc(100% - 44px);
  }
  .drive-table td {
    height: 64px;
  }
  .drive-file strong {
    font-size: 14px;
  }
  .drive-list-heading {
    padding: 4px 8px;
    gap: 0;
  }
  .selection-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }
  .selection-summary {
    margin-left: 0;
    min-height: 40px;
  }
  .selection-tools {
    justify-content: flex-start;
    flex-basis: auto;
    flex-wrap: wrap;
    padding-left: 0;
    border-left: 0;
  }
  .selection-actions .selection-extract {
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 0;
  }
  .drive-actions > .button:first-child {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.processing-overview .queue-details, .processing-overview .quality-details {
  max-height: none;
  overflow: visible;
}

/* Selection reuses the sticky table heading without moving the file rows. */
.drive-table thead th {
  height: 44px;
  padding-top: 0;
  padding-bottom: 0;
}

.drive-table thead.has-selection th {
  background: var(--ui-selected);
}

.has-selection .header-idle {
  visibility: hidden;
}

.header-selection {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  color: var(--ui-text);
  text-align: left;
  font-weight: 600;
}

.header-clear {
  display: grid;
  place-items: center;
  width: 32px;
  height: 44px;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0;
}

.header-clear .file-check {
  margin: 0;
}

.header-selection-count {
  font-size: 13px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.header-selection .selection-tools {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex-basis: auto;
  gap: 4px;
  padding-left: 12px;
  margin-left: 4px;
  border-left: 1px solid var(--ui-line);
}

.header-selection .selection-icon {
  width: 36px;
  height: 36px;
  min-width: 0;
}

.header-selection .selection-extract {
  display: inline-flex;
  gap: 6px;
  margin-left: 4px;
  padding: 6px 10px;
  min-height: 36px;
  color: var(--ui-accent);
  background: transparent;
  box-shadow: none;
  font-size: 13px;
  white-space: nowrap;
}

.header-selection .selection-extract:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--ui-accent-hover);
}

@media (max-width: 620px) {
  .header-selection {
    gap: 6px;
    padding: 0 6px;
  }
  .header-clear {
    width: 36px;
  }
  .header-selection-count {
    font-size: 13px;
  }
  .header-selection .selection-tools {
    gap: 0;
    padding-left: 0;
    margin-left: auto;
    border-left: 0;
  }
  .header-selection .selection-icon {
    width: 36px;
    height: 44px;
  }
  .header-selection .selection-extract {
    gap: 5px;
    min-height: 44px;
    padding: 6px;
    margin-left: 0;
    font-size: 13px;
  }
  .header-selection .extract-prefix {
    display: none;
  }
}
/* File detail follows the register: a clear document surface and quiet metadata. */
.file-dialog {
  width: calc(100% - 64px);
  max-width: 1320px;
  height: min(880px, 100dvh - 64px);
  max-height: calc(100dvh - 64px);
  overflow: hidden;
  color: var(--ui-text);
  background: var(--ui-paper);
}

.file-dialog[open] {
  display: flex;
  flex-direction: column;
}

.file-dialog::backdrop {
  background: rgba(35, 39, 47, 0.5019607843);
  backdrop-filter: none;
}

.file-dialog-header {
  flex: 0 0 auto;
  padding: 10px 16px;
  gap: 16px;
}

.file-dialog-identity {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.file-dialog-identity > i {
  flex-shrink: 0;
  font-size: 28px;
  color: var(--ui-muted);
}

.file-dialog-identity > i.is-pdf {
  color: var(--ui-danger);
}

.file-dialog-header h2 {
  font-size: 18px;
  font-weight: 650;
  line-height: 1.5;
  max-height: 81px;
  overflow: auto;
  margin: 0;
}

.file-dialog-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.file-dialog-actions .button {
  min-height: 36px;
  padding: 7px 12px;
  border-radius: 8px;
  background: var(--ui-accent);
  box-shadow: none;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.file-dialog-actions .button:hover {
  background: var(--ui-accent-hover);
  box-shadow: none;
}

.file-dialog-header .file-dialog-close {
  width: 36px;
  height: 36px;
  font-size: 18px;
  color: var(--ui-text);
  border-radius: 6px;
}

.file-dialog .preview-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  grid-template-columns: minmax(0, 1fr) 320px;
}

.file-dialog .file-preview {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: var(--ui-canvas);
}

.file-dialog .pdf-canvas {
  flex: 1;
  min-height: 0;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
}

.file-dialog .pdf-canvas img {
  display: block;
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  box-shadow: 0 4px 16px rgba(35, 39, 47, 0.0784313725);
}

.file-dialog .pdf-controls {
  order: 2;
  flex-shrink: 0;
  gap: 16px;
  padding: 6px 16px;
  border-top: 1px solid var(--ui-line);
  border-bottom: 0;
  background: var(--ui-paper);
  color: var(--ui-text);
  font-size: 14px;
  font-weight: 550;
  font-variant-numeric: tabular-nums;
}

.file-dialog .pdf-controls .icon-button {
  width: 36px;
  height: 36px;
  color: var(--ui-text);
}

.file-dialog .pdf-status {
  margin: 0;
  padding: 10px 16px;
  color: var(--ui-text);
  font-size: 14px;
}

.file-dialog .file-preview pre {
  flex: 1;
  max-height: none;
  padding: 24px;
  font-size: 14px;
  color: var(--ui-text);
}

.file-dialog .text-preview-note {
  padding: 14px 24px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 13px;
}

.file-dialog .preview-empty {
  flex: 1;
  min-height: 220px;
  gap: 12px;
  padding: 32px;
}

.file-dialog .preview-empty > i {
  font-size: 36px;
}

.file-dialog .preview-empty strong {
  font-size: 15px;
  line-height: 1.6;
  color: var(--ui-text);
}

.file-dialog .preview-empty p {
  font-size: 14px;
  line-height: 1.7;
}

.file-dialog .file-metadata {
  min-height: 0;
  max-height: none;
  padding: 24px;
  overflow: auto;
}

.file-dialog .metadata-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.file-dialog .metadata-heading h3 {
  font-size: 14px;
  font-weight: 650;
}

.file-dialog .metadata-heading .drive-state {
  font-size: 13px;
}

.file-dialog .file-metadata dl {
  margin: 16px 0;
}

.file-dialog .file-metadata dl > div {
  display: grid;
  grid-template-columns: 78px minmax(0, 1fr);
  gap: 12px;
  padding: 8px 0;
  font-size: 14px;
  line-height: 1.6;
}

.file-dialog .file-metadata dt {
  color: var(--ui-muted);
}

.file-dialog .file-metadata dd {
  text-align: left;
  color: var(--ui-text);
}

.file-dialog .file-metadata dl > .file-location {
  grid-template-columns: 1fr;
  gap: 6px;
  padding-top: 14px;
}

.file-dialog .file-metadata .file-path {
  max-width: none;
  overflow-wrap: anywhere;
}

.file-info-section {
  border-top: 1px solid var(--ui-line);
}

.file-info-section summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 40px;
  cursor: pointer;
  list-style: none;
  color: var(--ui-text);
  font-size: 14px;
  font-weight: 600;
}

.file-info-section summary::-webkit-details-marker {
  display: none;
}

.file-info-section summary > i {
  font-size: 11px;
  transition: transform 0.16s;
}

.file-info-section[open] summary > i {
  transform: rotate(180deg);
}

.file-dialog .file-info-section dl {
  margin-top: 0;
}

.file-dialog .file-info-section .checksum {
  font-size: 12px;
  word-break: break-all;
}

.file-dialog .version-actions {
  margin: 12px 0;
}

.file-dialog .version-actions .button {
  min-height: 36px;
  border-radius: 8px;
  font-size: 13px;
}

.file-dialog .version-links:empty {
  display: none;
}

.file-dialog .version-links {
  margin: 12px 0 20px;
}

.file-dialog .unregistered-note {
  font-size: 14px;
}

.file-dialog :is(button, a, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: -2px;
}

@media (max-width: 800px) {
  .file-dialog {
    width: calc(100% - 24px);
    height: calc(100dvh - 24px);
    max-height: calc(100dvh - 24px);
  }
  .file-dialog-header {
    padding: 12px 16px;
    gap: 12px;
  }
  .file-dialog .preview-body {
    display: block;
    overflow-y: auto;
  }
  .file-dialog .file-preview {
    height: 58dvh;
    min-height: 280px;
  }
  .file-dialog .pdf-canvas {
    padding: 16px;
  }
  .file-dialog .file-metadata {
    overflow: visible;
    border-left: 0;
    border-top: 1px solid var(--ui-line);
    padding: 20px;
  }
}
@media (max-width: 520px) {
  .file-dialog-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
    gap: 10px;
  }
  .file-dialog-identity {
    grid-column: 1;
    grid-row: 1;
    gap: 10px;
  }
  .file-dialog-identity > i {
    font-size: 24px;
  }
  .file-dialog-header h2 {
    font-size: 16px;
    max-height: 72px;
  }
  .file-dialog-actions {
    display: contents;
  }
  .file-dialog-actions .button {
    grid-column: 1/-1;
    grid-row: 2;
    justify-self: start;
  }
  .file-dialog-close {
    grid-column: 2;
    grid-row: 1;
  }
}
/* Document navigation and zoom stay within the preview viewport. */
.file-dialog .pdf-controls {
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 16px;
  padding: 6px 12px;
}

.pdf-page-navigation, .pdf-zoom-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  min-width: 0;
}

.pdf-page-navigation input {
  width: 58px;
  height: 36px;
  padding: 6px;
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  text-align: center;
  font: inherit;
  color: var(--ui-text);
  background: var(--ui-paper);
  appearance: textfield;
}

.pdf-page-navigation input::-webkit-inner-spin-button, .pdf-page-navigation input::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.pdf-page-navigation input[aria-invalid=true] {
  border-color: var(--ui-danger);
}

.pdf-page-total {
  white-space: nowrap;
  margin: 0 4px;
}

.pdf-zoom-controls select {
  width: 104px;
  height: 36px;
  padding: 6px 4px;
  text-align: center;
  text-align-last: center;
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  font: inherit;
  color: var(--ui-text);
  background: var(--ui-paper);
}

.file-dialog .pdf-canvas {
  display: block;
  padding: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

.pdf-stage {
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: 100%;
  min-height: 100%;
  padding: 24px;
}

.file-dialog .pdf-canvas .pdf-stage img {
  flex-shrink: 0;
  max-width: none;
  max-height: none;
  height: auto;
}

.file-dialog :is(.pdf-canvas, .pdf-page-navigation input, .pdf-zoom-controls select):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: -2px;
}

@media (max-width: 1100px) {
  .file-dialog .pdf-controls {
    justify-content: center;
  }
}
@media (max-width: 520px) {
  .file-dialog .pdf-controls {
    padding: 4px 8px;
    gap: 0;
  }
  .pdf-page-navigation, .pdf-zoom-controls {
    justify-content: center;
    width: 100%;
  }
}
@media (max-width: 620px) {
  .drive-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .header-selection-count {
    max-width: 62px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header-selection .selection-icon {
    width: 32px;
  }
}
/* Document register: one calm surface, distinct actions, full-scale reading panes. */
:host {
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.5;
}

button, input, select, textarea {
  font-family: inherit;
}

::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

:is(button, a, input, select, textarea, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.drive-content {
  height: auto;
  min-height: calc(100dvh - var(--workspace-header-height, 0px));
  padding: 16px var(--workspace-gutter, 16px);
  background: var(--ui-canvas);
}

.drive-content .page-heading {
  gap: 12px;
  min-height: 36px;
  margin-bottom: 16px;
}

.drive-content .page-title h1 {
  font-size: 24px;
  font-weight: 750;
  line-height: 1.3;
  letter-spacing: -0.025em;
  color: var(--ui-ink);
}

.drive-actions {
  flex-wrap: wrap;
  gap: 6px;
}

.drive-actions .button, .queue-actions .button, .extraction-entry .button, .source-form-footer .button, .extraction-controls .button, .extraction-jobbar .button {
  min-height: 36px;
  padding: 7px 12px;
  border-radius: 8px;
  font-size: 13px;
}

.drive-actions .drive-more {
  width: 36px;
  padding: 0;
}

.drive-shell, .trash-pane {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: var(--ui-radius);
}

.drive-shell {
  flex: 0 0 auto;
  height: auto;
  min-height: 0;
  overflow: visible;
}

.file-pane {
  flex: 1 1 auto;
  min-height: 0;
}

.drive-shell .drive-toolbar, .trash-pane .drive-toolbar {
  padding: 10px 14px;
  gap: 8px 16px;
  background: var(--ui-paper);
  border-radius: var(--ui-radius) var(--ui-radius) 0 0;
}

.drive-shell .drive-toolbar {
  flex-direction: row;
  align-items: center;
}

.drive-shell .drive-location {
  flex: 1 1 150px;
}

.path-bar {
  gap: 7px;
}

.path-bar button > i {
  color: var(--ui-accent);
}

.path-bar button {
  color: var(--ui-muted);
  min-height: 32px;
  font-size: 13px;
}

.path-bar button:last-child {
  color: var(--ui-ink);
  font-weight: 650;
}

.drive-shell .drive-filters {
  flex: 0 1 auto;
  gap: 12px;
}

.work-filters {
  gap: 2px;
}

.work-filter-button {
  min-height: 36px;
  padding: 6px 8px;
  font-size: 13px;
  color: var(--ui-muted);
  font-weight: 550;
}

.work-filter-button.active {
  color: var(--ui-accent);
  font-weight: 650;
}

.drive-shell .drive-search {
  flex: 0 1 230px;
  width: 230px;
  margin-left: auto;
}

.drive-search {
  min-height: 36px;
  border-color: var(--ui-control);
  border-radius: 8px;
  background: var(--ui-soft);
}

.drive-search:focus-within {
  border-color: var(--ui-accent);
  box-shadow: none;
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.drive-search input {
  padding: 7px 0;
  font-size: 13px;
  line-height: 1.5;
}

.drive-search .icon-button {
  width: 32px;
  height: 32px;
  min-height: 32px;
}

.drive-table-wrap {
  flex: 0 1 auto;
  min-height: 0;
  max-height: max(260px, 100dvh - var(--workspace-header-height, 0px) - 216px);
}

.drive-table th {
  padding-top: 0;
  padding-bottom: 0;
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 12px;
  font-weight: 550;
  border-bottom: 0;
}

.drive-table td {
  height: 44px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 0;
}

.drive-table td:first-child, .drive-table th:first-child {
  padding-left: 12px;
}

.drive-name-heading {
  gap: 8px;
}

.drive-file {
  gap: 9px;
  padding: 2px 0;
}

.drive-file-cell {
  gap: 4px;
}

.file-select {
  min-height: 32px;
}

.drive-file strong {
  color: var(--ui-ink);
  font-size: 14px;
  font-weight: 550;
  line-height: 1.5;
}

.drive-file-icon {
  width: 28px;
  height: 30px;
}

.drive-file-icon.is-folder {
  color: #9b7928;
  font-size: 19px;
  background: #fbf5e6;
  border-radius: 6px;
}

.drive-file-icon.is-pdf {
  font-size: 19px;
  background: #fff1f1;
  border-radius: 6px;
}

.drive-table tr.is-selected, .drive-table tr.is-selected:hover, .drive-table thead.has-selection th {
  background: var(--ui-selected);
}

.drive-table tr:hover {
  background: var(--ui-soft);
}

.drive-state, .file-size, .file-date, .file-work-state {
  font-size: 12px;
}

.file-work-state {
  color: var(--ui-accent);
}

.drive-footer {
  flex: 0 0 auto;
  margin-top: 0;
  padding: 4px 12px;
  background: var(--ui-paper);
  border-radius: 0 0 var(--ui-radius) var(--ui-radius);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.drive-footer button {
  width: 32px;
  height: 32px;
}

.drive-empty, .drive-loading {
  padding: 40px 20px;
  gap: 12px;
}

.drive-empty > i {
  font-size: 30px;
  color: var(--ui-muted);
}

.drive-empty strong {
  font-size: 14px;
  font-weight: 550;
  color: var(--ui-text);
}

.processing-overview {
  flex: 0 0 auto;
  margin-top: 6px;
  border-top: 0;
  background: transparent;
}

.processing-bar {
  min-height: 40px;
  padding: 2px 0;
  gap: 4px;
}

.processing-scope {
  color: var(--ui-muted);
  font-size: 12px;
}

.processing-toggle {
  min-height: 36px;
  border-radius: 8px;
  color: var(--ui-text);
  font-size: 13px;
}

.processing-toggle.active {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.processing-toggle b {
  font-variant-numeric: tabular-nums;
}

.queue-details, .quality-details {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: var(--ui-radius);
}

.queue-row, .quality-row {
  min-height: 52px;
  padding: 7px 12px;
}

.queue-file strong, .quality-file strong {
  color: var(--ui-ink);
  font-size: 13px;
  line-height: 1.45;
}

.queue-file > span, .quality-file small {
  margin-top: 2px;
}

.queue-file progress {
  margin-top: 6px;
}

.queue-file span, .queue-stopping, .quality-file small {
  font-size: 12px;
  line-height: 1.45;
}

.quality-filters {
  padding: 4px 12px;
  gap: 8px;
  font-size: 12px;
}

.quality-filters button {
  min-height: 32px;
}

.quality-row .button {
  min-height: 32px;
  padding: 6px 10px;
  font-size: 12px;
}

.trash-pane {
  height: auto;
  min-height: 0;
}

.trash-list {
  max-height: max(260px, 100dvh - var(--workspace-header-height, 0px) - 216px);
}

.trash-row {
  min-height: 52px;
  padding: 8px 12px;
  gap: 10px;
}

.trash-file strong {
  font-size: 13px;
}

.trash-file small, .trash-file > span {
  margin-top: 2px;
}

.source-form-dialog, .file-dialog, .extraction-dialog {
  border-radius: var(--ui-radius);
  background: var(--ui-paper);
  box-shadow: 0 24px 80px rgba(35, 39, 47, 0.2);
  scroll-padding-block: 16px;
}

.source-form-dialog::backdrop, .file-dialog::backdrop, .extraction-dialog::backdrop {
  background: rgba(35, 39, 47, 0.4);
  backdrop-filter: none;
}

.source-form-dialog {
  padding: 20px 22px;
}

.source-form-heading {
  gap: 12px;
  margin-bottom: 14px;
}

.source-form-heading h2, .file-dialog-header h2, .extraction-heading h2 {
  color: var(--ui-ink);
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.source-form-footer {
  margin-top: 20px;
}

.source-form-grid {
  gap: 12px;
}

.source-form-dialog :is(input, select, textarea), .extraction-controls input, .extraction-editor-toolbar select, .pdf-page-navigation input, .pdf-zoom-controls select {
  border-color: var(--ui-control);
  border-radius: 8px;
  color: var(--ui-text);
}

.source-form-dialog :is(input, select), .extraction-controls input, .extraction-editor-toolbar select {
  min-height: 36px;
  padding: 7px 10px;
  font-size: 13px;
}

.source-form-dialog .field label {
  color: var(--ui-text);
  font-size: 13px;
}

.source-form-heading p, .input-note, .registration-note, .preview-eyebrow, .extraction-provider {
  font-size: 12px;
}

.file-dialog .file-metadata {
  padding: 18px;
  background: var(--ui-paper);
  border-left: 1px solid var(--ui-line);
}

.file-dialog .file-metadata dl {
  margin: 10px 0;
}

.file-dialog .file-metadata dl > div {
  padding: 7px 0;
  font-size: 13px;
  line-height: 1.6;
}

.file-dialog .file-metadata dd {
  color: var(--ui-ink);
}

.file-dialog .pdf-controls {
  font-size: 13px;
}

.file-dialog .text-preview-note {
  padding: 8px 16px;
  font-size: 12px;
}

.file-dialog .file-preview pre, .extraction-block pre, .extraction-saved-text, .extraction-edit {
  font-size: 16px;
  line-height: 1.85;
  color: var(--ui-ink);
}

.extraction-editor-toolbar, .extraction-editor-footer {
  background: var(--ui-soft);
}

.extraction-original {
  background: var(--ui-canvas);
}

.extraction-section-title strong {
  font-weight: 650;
  color: var(--ui-ink);
}

.extraction-heading {
  border-bottom-color: var(--ui-line);
}

.extraction-page-list {
  background: var(--ui-paper);
}

.extraction-jobbar {
  color: var(--ui-muted);
}

.extraction-editor-footer {
  padding: 8px 16px;
  min-height: 36px;
}

.extraction-heading-actions .button, .editor-actions .button {
  min-height: 36px;
  padding: 7px 10px;
}

.extraction-jobbar select {
  padding: 7px 9px;
  min-height: 36px;
}

.extraction-page-list button {
  min-height: 32px;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 8px;
  font-variant-numeric: tabular-nums;
}

.extraction-edit:focus {
  border-color: var(--ui-accent);
  box-shadow: none;
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.extraction-warning, .drive-notice, .quality-confirmed {
  font-size: 13px;
  line-height: 1.7;
}

.source-item-menu, .download-status {
  border: 0;
  box-shadow: 0 12px 36px rgba(35, 39, 47, 0.1490196078);
  border-radius: 12px;
}

.source-item-menu button, .download-status {
  font-size: 13px;
}

.source-item-menu button {
  min-height: 36px;
  padding: 8px;
}

.source-form-dialog :is(input, select, textarea, button), .file-dialog :is(input, select, button), .extraction-dialog :is(input, select, textarea, button) {
  scroll-margin-block: 12px;
}

@media (min-width: 761px) and (max-width: 1200px) {
  .drive-shell .drive-location {
    flex-basis: 100%;
  }
  .drive-shell .drive-filters {
    flex: 1 1 100%;
    flex-wrap: nowrap;
    gap: 8px;
  }
  .drive-shell .drive-search {
    flex: 0 1 230px;
    margin-left: auto;
  }
}
@media (max-width: 760px) {
  .drive-content {
    min-height: calc(100dvh - var(--workspace-header-height, 92px));
    padding: 12px var(--workspace-gutter, 12px);
  }
  .drive-content .page-heading {
    margin-bottom: 12px;
  }
  .drive-shell .drive-location {
    flex-basis: 100%;
  }
  .drive-shell .drive-toolbar, .trash-pane .drive-toolbar {
    padding: 8px 12px;
    gap: 6px;
  }
  .drive-shell .drive-filters {
    flex: 1 1 100%;
    flex-wrap: wrap;
    gap: 6px;
  }
  .drive-shell .drive-search {
    flex: 1 1 100%;
    width: 100%;
  }
  .work-filters {
    width: 100%;
    gap: 0;
  }
  .work-filter-button {
    min-height: 44px;
    padding: 8px;
  }
  .drive-search {
    min-height: 44px;
  }
  .drive-search input {
    font-size: 16px;
  }
  .drive-search .icon-button {
    width: 40px;
    height: 40px;
    min-height: 40px;
  }
  .drive-table-wrap {
    max-height: max(260px, 100dvh - var(--workspace-header-height, 92px) - 242px);
  }
  .drive-table thead th {
    height: 52px;
  }
  .drive-table td {
    height: 52px;
  }
  .drive-footer {
    padding: 4px 8px;
  }
  .drive-footer button, .processing-toggle {
    min-height: 44px;
  }
  .drive-footer button {
    width: 44px;
    height: 44px;
  }
  .queue-row, .quality-row {
    padding: 10px 12px;
  }
  .quality-row .button {
    min-height: 44px;
  }
  .processing-bar {
    gap: 4px;
  }
  .file-dialog-actions .button {
    min-height: 44px;
  }
  .file-dialog-header .file-dialog-close {
    width: 44px;
    height: 44px;
  }
  .file-dialog .pdf-controls .icon-button {
    width: 44px;
    height: 44px;
  }
  .file-dialog .file-metadata {
    padding: 16px;
    border-left: 0;
  }
  .file-info-section summary {
    min-height: 44px;
  }
  .source-form-dialog {
    padding: 16px;
  }
  .source-form-dialog :is(input, select), .extraction-controls input, .extraction-editor-toolbar select {
    min-height: 44px;
    font-size: 16px;
  }
  .extraction-heading-actions .button, .editor-actions .button, .extraction-page-list button {
    min-height: 44px;
  }
}
@media (max-width: 620px) {
  .drive-content .page-heading {
    flex-wrap: wrap;
    align-items: center;
  }
  .drive-content .page-title {
    min-width: 0;
  }
  .drive-actions {
    margin-left: auto;
  }
  .drive-actions .button {
    min-height: 44px;
  }
  .drive-actions > .drive-more, .drive-actions > .folder-create {
    width: 44px;
    padding: 0;
  }
  .path-bar button {
    min-height: 36px;
  }
  .drive-table td {
    height: 56px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  .drive-table td:first-child, .drive-table th:first-child {
    padding-left: 6px;
  }
  .drive-file {
    gap: 8px;
  }
  .drive-file strong {
    font-size: 13px;
    line-height: 1.45;
  }
  .drive-file small.mobile-file-state {
    font-size: 12px;
  }
  .file-select {
    min-height: 44px;
  }
  .drive-table-wrap {
    max-height: max(240px, 100dvh - var(--workspace-header-height, 132px) - 242px);
  }
  .source-form-footer .button, .extraction-controls .button, .extraction-jobbar .button, .queue-actions .button {
    min-height: 44px;
  }
  .file-dialog-header h2 {
    font-size: 16px;
  }
}
@media (pointer: coarse) {
  .drive-actions .button, .path-bar button, .work-filter-button, .processing-toggle, .source-item-menu button,
  .queue-actions .button, .quality-row .button, .source-form-footer .button, .extraction-controls .button,
  .extraction-jobbar .button, .extraction-heading-actions .button, .editor-actions .button, .extraction-page-list button {
    min-height: 44px;
  }
  .file-select {
    min-height: 44px;
  }
  .item-more, .drive-footer button {
    min-width: 44px;
    width: 44px;
    height: 44px;
  }
  .drive-table thead th {
    height: 52px;
  }
  .header-selection .selection-extract {
    min-height: 44px;
  }
}
/* Short desktop windows keep both extraction readers usable through dialog scroll. */
@media (min-width: 801px) and (max-height: 700px) {
  .extraction-dialog[open] {
    overflow-y: auto;
  }
  .extraction-dialog .extraction-heading {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--ui-paper);
  }
  .extraction-dialog .extraction-comparison {
    flex: 0 0 480px;
    min-height: 480px;
  }
}
/* A failed read leaves the current location and a direct recovery action available. */
.load-recovery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.load-recovery > span {
  flex: 1 1 240px;
  overflow-wrap: anywhere;
}

.load-recovery > .button {
  min-height: 36px;
  flex-shrink: 0;
}

.file-dialog.preview-failed {
  height: auto;
  max-width: 720px;
  overflow: auto;
}

.preview-load-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 24px;
  text-align: center;
}

.preview-load-error > i {
  color: var(--ui-danger);
  font-size: 28px;
}

.preview-load-error > h3 {
  font-size: 18px;
  font-weight: 650;
  line-height: 1.5;
  margin: 0;
  color: var(--ui-ink);
}

.preview-load-error > p {
  font-size: 15px;
  line-height: 1.7;
  max-width: 56ch;
  overflow-wrap: anywhere;
  margin: 0;
  color: var(--ui-text);
}

.preview-load-error > .button {
  min-height: 44px;
  margin-top: 4px;
}

@media (max-width: 760px) {
  .load-recovery {
    margin: 12px;
  }
  .load-recovery > .button {
    min-height: 44px;
  }
  .preview-load-error {
    padding: 24px 16px;
  }
}
@media (pointer: coarse) {
  .load-recovery > .button {
    min-height: 44px;
  }
}
/* Source coverage, search scope and review continuation. */
.drive-shell .scoped-search {
  flex: 0 1 300px;
  width: 300px;
  gap: 8px;
  padding-left: 8px;
}

.scoped-search select {
  flex: 0 0 108px;
  min-width: 0;
  width: 108px;
  min-height: 34px;
  border: 0;
  border-right: 1px solid var(--ui-line);
  border-radius: 0;
  padding: 4px 6px 4px 0;
  background: transparent;
  color: var(--ui-text);
  font-size: 12px;
}

.registered-location {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  min-width: 0;
  font-size: 13px;
}

.registered-location strong {
  color: var(--ui-ink);
  font-weight: 650;
}

.registered-location .panel-link {
  color: var(--ui-accent);
}

.result-folder {
  display: flex;
  align-items: baseline;
  gap: 6px;
  max-width: calc(100% - 34px);
  margin: 0 0 3px 34px;
  text-align: left;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.result-folder:hover {
  color: var(--ui-accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.result-folder i {
  flex-shrink: 0;
}

.file-coverage {
  display: block;
  font-size: 12px;
  color: var(--ui-muted);
  line-height: 1.5;
  font-variant-numeric: tabular-nums;
}

.coverage-note, .queue-scope {
  margin: 0;
  padding: 7px 14px;
  font-size: 12px;
  color: var(--ui-muted);
  line-height: 1.6;
}

.coverage-note {
  border-top: 1px solid var(--ui-line);
}

.extraction-coverage {
  margin: 3px 0 0;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.5;
  font-variant-numeric: tabular-nums;
}

.extraction-coverage > span, .page-count-warning {
  color: var(--ui-warning);
}

.page-count-warning {
  font-size: 13px;
  line-height: 1.6;
  margin: 0 0 12px;
}

@media (max-width: 1100px) {
  .drive-shell .drive-filters {
    flex-wrap: wrap;
    flex: 1 1 100%;
  }
  .drive-shell .scoped-search {
    margin-left: auto;
  }
}
@media (max-width: 600px) {
  .drive-shell .scoped-search {
    flex: 1 1 100%;
    width: 100%;
    margin-left: 0;
  }
  .scoped-search select {
    min-height: 42px;
    font-size: 14px;
  }
  .result-folder {
    margin-left: 32px;
    max-width: calc(100% - 32px);
  }
  .coverage-note, .queue-scope {
    padding: 7px 12px;
  }
  .extraction-heading {
    flex-wrap: wrap;
    gap: 10px;
  }
  .extraction-heading > div:first-child {
    flex: 1 1 100%;
    min-width: 0;
    padding-right: 38px;
  }
  .extraction-heading-actions {
    flex-wrap: wrap;
    gap: 8px;
  }
  .extraction-heading-actions > .icon-button {
    position: absolute;
    right: 12px;
    top: 10px;
  }
}
/* Distinguish the reason for attention from whether the narrative is usable. */
.quality-category-note {
  margin: 6px 12px 9px;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
}

.quality-file .quality-row-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  margin: 5px 0 3px;
}

.quality-category {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--ui-soft);
  color: var(--ui-text);
  font-size: 12px;
  font-weight: 550;
  line-height: 1.5;
}

.quality-category.text-problem {
  color: var(--ui-danger);
  background: #fbeef0;
}

.quality-file .text-available, .quality-category-status p.text-available strong {
  color: var(--ui-success);
}

.quality-category-status {
  margin: 10px 0 0;
  padding: 10px 0 6px;
  border-top: 1px solid var(--ui-line);
}

.quality-category-labels {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.quality-category-status p {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 8px;
  margin: 7px 0 2px;
  font-size: 13px;
  line-height: 1.6;
}

.quality-category-status p strong {
  color: var(--ui-warning);
  font-weight: 650;
}

.quality-category-status p span {
  color: var(--ui-text);
}

.quality-category-status > small {
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
}

@media (max-width: 620px) {
  .quality-category-note {
    margin-top: 8px;
  }
}
/* Resolution is a current decision; preserved warnings remain readable history. */
.quality-status-counts {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px 16px;
  margin: 2px 12px 6px;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
  font-variant-numeric: tabular-nums;
}

.quality-filters button > span {
  margin-left: 4px;
  font-variant-numeric: tabular-nums;
}

.quality-history {
  margin: 8px 0 10px;
  border-top: 1px solid var(--ui-line);
  color: var(--ui-text);
  font-size: 12px;
  line-height: 1.65;
}

.quality-history h3 {
  margin: 10px 0 4px;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
}

.quality-history p {
  margin: 4px 0;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}

.quality-history ol {
  list-style: none;
  margin: 2px 0 8px;
  padding: 0;
}

.quality-history li {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 10px;
  margin: 5px 0;
}

.quality-history li strong {
  font-weight: 550;
}

.quality-history li time {
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

.quality-history li > span {
  flex-basis: 100%;
  color: var(--ui-muted);
  overflow-wrap: anywhere;
}

@media (max-width: 620px) {
  .quality-filters {
    gap: 4px;
  }
  .quality-filters button {
    min-height: 44px;
  }
  .quality-filters > span {
    display: none;
  }
  .quality-status-counts {
    gap: 2px 10px;
  }
  .quality-history summary {
    min-height: 44px;
  }
}
/* File decisions stay in place; only newly opened content changes opacity. */
@media (prefers-reduced-motion: no-preference) {
  .drive-table tbody tr {
    transition: background-color var(--motion-fast, 120ms) ease-out;
  }
  .header-selection, .queue-details, .quality-details,
  .source-item-menu:popover-open, .drive-menu:popover-open, .download-status {
    animation: source-content-arrive var(--motion-ui, 180ms) ease-out;
  }
}
@keyframes source-content-arrive {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 1;
  }
}
/* Focused source review: work rows use the document, with interpretation on demand. */
#source-work-heading {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 16px);
}

#source-work-heading:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 4px;
}

.processing-focused .processing-overview {
  flex: 1;
}

.queue-view-controls, .quality-reason-control {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 12px;
}

.queue-view-controls button {
  min-height: 36px;
  padding: 7px 12px;
  color: var(--ui-text);
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 13px;
}

.queue-view-controls button.active {
  background: var(--ui-selected);
  color: var(--ui-accent);
  font-weight: 650;
}

.queue-view-controls > span {
  margin-left: auto;
  color: var(--ui-muted);
  font-size: 13px;
}

.quality-reason-control {
  padding-top: 6px;
  padding-bottom: 6px;
}

.quality-reason-control label {
  font-size: 13px;
  color: var(--ui-muted);
}

.quality-reason-control select {
  flex: 0 1 320px;
  min-width: 0;
  min-height: 36px;
  padding: 7px 10px;
  border: 1px solid var(--ui-control-line);
  border-radius: 6px;
  background: var(--ui-paper);
  color: var(--ui-text);
  font: inherit;
  font-size: 13px;
}

.quality-help {
  padding: 0 12px 8px;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.7;
}

.quality-help summary, .quality-diagnostic-details summary, .extraction-diagnostics summary {
  width: fit-content;
  min-height: 36px;
  padding: 8px 0;
  cursor: pointer;
  color: var(--ui-text);
  font-size: 13px;
}

.quality-help p {
  margin: 4px 0;
}

.quality-help .quality-status-counts {
  margin: 4px 0;
}

.queue-view-controls button:focus-visible, .quality-reason-control select:focus-visible, .quality-help summary:focus-visible, .quality-diagnostic-details summary:focus-visible, .extraction-diagnostics summary:focus-visible, .extraction-reader-tabs button:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.extraction-content > .page-quality, .extraction-content > .extraction-notice, .extraction-content > .extraction-message {
  flex-shrink: 0;
}

.page-quality {
  padding-top: 8px;
}

.quality-current {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
}

.quality-current strong {
  color: var(--ui-warning);
  font-size: 13px;
}

.quality-current strong.text-available {
  color: var(--ui-success);
}

.quality-page-actions {
  margin: 8px 0 0;
}

.quality-diagnostic-details {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
}

.quality-diagnostic-details > p {
  margin: 8px 0;
}

.quality-diagnostic-details .quality-category-status {
  margin: 0;
  padding: 8px 0;
}

.extraction-notice {
  margin: 0 16px;
  padding: 8px 0;
  color: var(--ui-warning);
  font-size: 13px;
  line-height: 1.7;
  border-bottom: 1px solid var(--ui-line);
}

.extraction-notice p {
  margin: 0;
}

.extraction-diagnostics {
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.7;
}

.extraction-diagnostics ul {
  margin: 4px 0 8px;
  padding-left: 18px;
}

.extraction-diagnostics li, .extraction-diagnostics pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: inherit;
}

.extraction-reader-tabs {
  display: none;
}

@media (max-width: 800px) {
  .extraction-reader-tabs {
    display: flex;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 3;
    padding: 4px 12px;
    gap: 6px;
    border-bottom: 1px solid var(--ui-line);
    background: var(--ui-paper);
  }
  .extraction-reader-tabs button {
    min-height: 44px;
    flex: 1;
    padding: 8px 12px;
    border-radius: 6px;
    font: inherit;
    font-size: 14px;
    color: var(--ui-text);
    background: transparent;
  }
  .extraction-reader-tabs button.active {
    background: var(--ui-selected);
    color: var(--ui-accent);
    font-weight: 650;
  }
  .extraction-comparison:not(.reader-original) .extraction-original, .extraction-comparison.reader-original .extraction-text {
    display: none;
  }
  .extraction-dialog .extraction-original, .extraction-dialog .extraction-text {
    overflow: visible;
    height: auto;
    min-height: 0;
  }
  .extraction-dialog .extraction-content {
    overflow: visible;
    flex: none;
    min-height: 0;
  }
  .extraction-dialog .extraction-paper {
    flex: none;
    min-height: 0;
    overflow-x: auto;
    padding: 12px;
  }
  .extraction-dialog .extraction-edit {
    flex: none;
    min-height: 55dvh;
    resize: vertical;
  }
  .quality-help summary, .quality-diagnostic-details summary, .extraction-diagnostics summary, .queue-view-controls button {
    min-height: 44px;
  }
  .quality-reason-control select {
    flex: 1 1 210px;
    min-height: 44px;
  }
  .quality-page-actions .button {
    min-height: 44px;
  }
  .queue-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
/* Source register: one state control, a clear search field and readable rows. */
.drive-shell .drive-toolbar {
  padding: 12px 16px;
  gap: 12px 16px;
}

.drive-shell .drive-location {
  flex: 1 1 180px;
}

.drive-shell .drive-filters {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  flex-wrap: nowrap;
  gap: 12px;
}

.drive-shell .work-filters {
  flex: 0 0 auto;
  width: auto;
}

.work-filter-select {
  width: 146px;
  min-height: 40px;
  padding: 8px 28px 8px 12px;
  appearance: auto;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
  color: var(--ui-text);
  font: inherit;
  font-size: 14px;
}

.drive-shell .scoped-search {
  flex: 0 1 360px;
  width: 360px;
  min-height: 40px;
  background: var(--ui-paper);
}

.scoped-search select {
  appearance: auto;
  flex-basis: 118px;
  width: 118px;
  min-height: 36px;
  font-size: 13px;
}

.drive-search input {
  font-size: 14px;
}

.path-bar button {
  min-height: 40px;
  font-size: 14px;
}

.path-bar .path-divider {
  font-size: 13px;
}

.drive-table thead th {
  height: 48px;
  color: var(--ui-text);
  font-size: 13px;
}

.drive-table td {
  height: 56px;
  border-bottom: 1px solid var(--ui-line);
}

.drive-table tbody tr:last-child td {
  border-bottom: 0;
}

.drive-file strong {
  font-size: 15px;
  font-weight: 550;
  line-height: 1.5;
}

.drive-state, .file-size, .file-date {
  font-size: 13px;
}

.file-work-state {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  min-height: 28px;
  padding: 4px 8px;
  border-radius: 6px;
  color: var(--ui-accent);
  background: var(--ui-selected);
  font-size: 13px;
  font-weight: 550;
}

.file-work-state.needs-check {
  color: var(--ui-warning);
  background: #fff0d8;
}

.file-work-state.result-ready {
  color: var(--ui-success);
  background: var(--ui-success-soft);
}

.file-work-state.result-active {
  color: var(--ui-accent);
  background: var(--ui-selected);
}

.file-work-state.result-failed {
  color: var(--ui-danger);
  background: #fbeef0;
}

.file-coverage {
  margin-top: 4px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.drive-state:empty {
  display: none;
}

.drive-table.folder-list :is(th, td):nth-child(2),
.drive-table.folder-list :is(th, td):nth-child(3) {
  display: none;
}

.drive-table.folder-list th:first-child {
  width: auto;
}

.drive-table.folder-list :is(th, td):nth-child(4) {
  display: table-cell;
  width: 180px;
}

.drive-table.folder-list :is(th, td):nth-child(5) {
  width: 48px;
}

.drive-footer {
  gap: 8px 16px;
  flex-wrap: wrap;
  padding: 6px 16px;
  font-size: 13px;
}

.drive-footer > div {
  margin-left: auto;
}

.list-guide {
  min-width: 0;
  color: var(--ui-muted);
  font-size: 13px;
}

.list-guide > summary {
  display: list-item;
  min-height: 36px;
  align-content: center;
  cursor: pointer;
  color: var(--ui-text);
  font-size: 13px;
}

.list-guide[open] {
  flex-basis: 100%;
  order: 3;
}

.list-guide .coverage-note {
  padding: 4px 0 8px;
  font-size: 13px;
  line-height: 1.6;
  max-width: 80ch;
}

.header-selection .selection-icon {
  width: auto;
  height: 40px;
  padding: 8px 10px;
  gap: 6px;
  color: var(--ui-text);
  font-size: 14px;
}

.selection-tool-label {
  font-size: 13px;
  font-weight: 550;
  white-space: nowrap;
}

.header-selection .selection-icon::after {
  display: none;
}

.header-selection .selection-trash {
  color: var(--ui-danger);
}

.header-selection .selection-extract {
  min-height: 40px;
  margin-left: 8px;
  background: var(--ui-accent);
  color: var(--ui-paper);
}

.header-selection .selection-extract:hover:not(:disabled) {
  background: var(--ui-accent-hover);
  color: var(--ui-paper);
}

.processing-bar {
  gap: 8px;
  padding: 4px 0;
}

.processing-scope {
  font-size: 13px;
}

.processing-toggle {
  min-height: 44px;
  font-size: 14px;
}

.processing-toggle.needs-check {
  background: transparent;
  color: var(--ui-text);
}

.processing-toggle.active, .processing-toggle.active.needs-check {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.processing-toggle > i:first-child {
  color: var(--ui-accent);
}

.processing-toggle.needs-check > i:first-child {
  color: var(--ui-warning);
}

.queue-file strong, .quality-file strong {
  font-size: 14px;
  line-height: 1.5;
}

.queue-file > span, .quality-file small, .queue-stopping {
  font-size: 13px;
  line-height: 1.5;
}

.queue-row, .quality-row {
  padding: 12px 16px;
}

.quality-filters, .quality-reason-control {
  font-size: 14px;
}

.quality-row .button {
  min-height: 40px;
  font-size: 13px;
}

.quality-help {
  font-size: 13px;
}

@media (max-width: 900px) {
  .drive-shell .drive-toolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .drive-shell .drive-location {
    grid-column: 1;
    grid-row: 1;
  }
  .drive-shell .drive-filters {
    display: contents;
  }
  .drive-shell .work-filters {
    grid-column: 2;
    grid-row: 1;
  }
  .drive-shell .scoped-search {
    grid-column: 1/-1;
    grid-row: 2;
    width: 100%;
    margin: 0;
  }
}
@media (max-width: 620px) {
  .drive-shell .drive-toolbar {
    padding: 8px 12px;
    gap: 8px;
  }
  .work-filter-select {
    width: 124px;
    min-height: 44px;
    padding-left: 8px;
    padding-right: 22px;
    font-size: 13px;
  }
  .drive-shell .drive-search {
    min-height: 44px;
  }
  .drive-shell .drive-search input {
    font-size: 16px;
  }
  .path-bar {
    flex-wrap: nowrap;
  }
  .path-bar button {
    min-height: 44px;
    max-width: 100%;
    font-size: 13px;
  }
  .path-bar button:first-child {
    flex-shrink: 0;
  }
  .path-bar button:last-child {
    min-width: 0;
    overflow: hidden;
  }
  .drive-file strong {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    overflow-wrap: anywhere;
    font-size: 14px;
    line-height: 1.5;
  }
  .drive-file small.mobile-file-state {
    font-size: 13px;
    line-height: 1.5;
    white-space: normal;
  }
  .drive-table td {
    min-height: 60px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .drive-table.folder-list :is(th, td):nth-child(4) {
    display: none;
  }
  .drive-table.folder-list th:first-child {
    width: auto;
  }
  .drive-table.folder-list :is(th, td):last-child {
    width: 44px;
  }
  .drive-footer {
    gap: 0 8px;
    padding: 4px 8px;
  }
  .drive-footer > div {
    gap: 4px;
  }
  .list-guide > summary {
    min-height: 44px;
  }
  .drive-table thead.has-selection th {
    height: 96px;
  }
  .header-selection {
    flex-wrap: wrap;
    align-content: center;
    gap: 0 6px;
    padding: 4px 8px;
  }
  .header-selection-count {
    max-width: none;
    font-size: 14px;
  }
  .header-selection .selection-tools {
    flex-basis: 100%;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    gap: 4px;
  }
  .header-selection .selection-icon {
    width: 44px;
    min-width: 44px;
    height: 44px;
    padding: 8px;
  }
  .selection-tool-label {
    display: none;
  }
  .header-selection .selection-extract {
    margin-left: auto;
    min-height: 44px;
    padding: 8px 12px;
  }
  .processing-bar {
    gap: 4px;
  }
  .processing-scope {
    flex-basis: 100%;
    padding-left: 0;
  }
  .processing-toggle {
    font-size: 13px;
  }
  .queue-file strong, .quality-file strong {
    font-size: 14px;
  }
  .queue-row, .quality-row {
    padding: 12px;
  }
}
/* Secondary information and mobile targets follow the same workspace scale. */
.source-form-heading p, .input-note, .registration-note, .preview-eyebrow, .text-preview-note,
.file-metadata dl > div, .file-metadata h4, .unregistered-note, .version-links, .pdf-status,
.quality-status-counts, .quality-category, .quality-category-status > small, .quality-current,
.quality-flags > span, .quality-flags small, .quality-help, .extraction-coverage, .queue-scope,
.trash-file small, .trash-file > span {
  font-size: 13px;
}

@media (max-width: 600px) {
  .drive-file {
    min-height: 44px;
  }
  .drive-file strong {
    font-size: 15px;
  }
  .registered-location .panel-link, .result-folder {
    min-height: 44px;
    font-size: 13px;
  }
  .trash-row .button, .trash-actions .button {
    min-height: 44px;
    min-width: 44px;
  }
}
@media (max-width: 600px) {
  .drive-shell .scoped-search select {
    flex-basis: 140px;
    width: 140px;
  }
}
/* Folder locations and quality scope remain readable beside file metadata. */
.result-folder, .quality-filters > span {
  font-size: 13px;
}

/* Keep the page and its text ahead of repeated reader chrome. */
.extraction-reading {
  flex: none;
  min-width: 0;
}

@media (prefers-reduced-motion: no-preference) {
  .extraction-reading {
    animation: source-copy-ready 140ms var(--motion-ease, ease-out);
  }
}
@keyframes source-copy-ready {
  from {
    opacity: 0.9;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 800px) {
  .extraction-dialog .extraction-heading {
    padding: 10px 14px;
    gap: 8px;
  }
  .extraction-dialog .extraction-heading h2 {
    font-size: 16px;
    line-height: 1.5;
  }
  .extraction-dialog .extraction-coverage {
    margin-top: 4px;
  }
  .extraction-dialog .extraction-heading-actions {
    gap: 8px;
  }
  .extraction-dialog .extraction-jobbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 4px 8px;
    padding: 8px 12px;
  }
  .extraction-jobbar select {
    grid-column: 1;
    width: 100%;
    min-width: 0;
    min-height: 44px;
  }
  .extraction-jobbar > .icon-button {
    grid-column: 2;
    grid-row: 1;
    margin: 0;
    width: 44px;
    height: 44px;
  }
  .extraction-jobbar > span {
    grid-column: 1/-1;
    font-size: 13px;
  }
  .extraction-jobbar > .button {
    justify-self: start;
  }
  .extraction-dialog .extraction-page-list {
    padding: 4px 12px;
  }
  .extraction-dialog .extraction-section-title {
    flex-wrap: wrap;
    gap: 6px;
  }
}
@media (max-height: 480px) {
  .extraction-dialog .extraction-heading {
    position: static;
  }
}
/* Selected pages keep readable text even when they also need review. */
.extraction-page-list button.active.needs-check {
  color: var(--ui-paper) !important;
}

/* Page alignment: one register text edge and one shared comparison reading origin. */
:host, .drive-content {
  background: transparent;
}

.drive-content .drive-shell {
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  background: var(--ui-paper);
}

.drive-content .file-pane {
  background: var(--ui-paper);
  border: 0;
  border-radius: 12px;
}

.drive-content .drive-shell .drive-toolbar {
  padding: 16px 20px;
  gap: 12px;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 12px 12px 0 0;
  background: var(--ui-paper);
}

.drive-content .drive-search {
  border-color: var(--ui-control);
  border-radius: 7px;
  background: var(--ui-paper);
}

.drive-content .drive-table th {
  height: 42px;
  background: var(--ui-soft);
  border-color: var(--ui-line);
}

.drive-content .drive-table td {
  padding-top: 10px;
  padding-bottom: 10px;
  border-color: var(--ui-line);
}

.drive-content .drive-table.folder-list td {
  height: 60px;
}

.drive-content .drive-file-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.drive-content .file-select, .drive-content .parent-check-space {
  flex: 0 0 20px;
  width: 20px;
  min-width: 20px;
  margin: 0;
}

.drive-content .file-select {
  display: flex;
  align-items: center;
}

.drive-content .drive-name-heading {
  display: grid;
  grid-template-columns: 20px 28px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
}

.drive-content .drive-name-heading > .file-check {
  grid-column: 1;
  margin: 0;
  justify-self: start;
}

.drive-content .drive-name-heading > span {
  grid-column: 3;
}

.drive-content .drive-file {
  min-height: 40px;
  gap: 12px;
}

.drive-content .drive-file strong {
  font-size: 14px;
  font-weight: 550;
  letter-spacing: -0.01em;
}

.drive-content .drive-file-icon {
  flex: 0 0 28px;
  width: 28px;
  height: 32px;
  background: transparent;
  font-size: 20px;
}

.drive-content .drive-file-icon.is-folder {
  color: #b08735;
}

.drive-content .drive-file-icon.is-pdf {
  color: #b34c54;
  background: #fbf0f1;
  border-radius: 7px;
  font-size: 18px;
}

.drive-content .result-folder {
  margin-left: 72px;
  max-width: calc(100% - 72px);
  padding-left: 0;
}

.drive-content .drive-footer {
  flex: none;
  padding: 12px 20px;
  border-top: 1px solid var(--ui-line);
  font-size: 12px;
  color: var(--ui-muted);
}

.drive-content .drive-note {
  margin-top: 12px;
  font-size: 12px;
}

.drive-content .processing-overview {
  scroll-margin-top: calc(var(--workspace-header-height) + 16px);
}

.drive-content:not(.processing-focused) .processing-overview {
  flex: none;
  margin: 0 0 16px;
  padding: 0;
  border: 0;
}

.drive-content .processing-bar {
  gap: 8px 16px;
}

.drive-content .processing-toggle {
  min-height: 40px;
}

.drive-content .quality-details, .drive-content .queue-details {
  scroll-margin-top: calc(var(--workspace-header-height) + 16px);
}

@media (min-width: 961px) {
  .drive-content {
    min-height: calc(100dvh - 24px);
  }
  .drive-content:has(.drive-shell) {
    display: flex;
    flex-direction: column;
    height: calc(100dvh - 24px);
    min-height: 0;
  }
  .drive-content:has(.drive-shell) > .page-heading {
    flex: none;
  }
  .drive-content .drive-shell {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
  .drive-content .file-pane {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }
  .drive-content .drive-table-wrap {
    flex: 1;
    min-height: 0;
    max-height: none;
    overflow: auto;
  }
}
.file-dialog .file-dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.file-metadata-disclosure > summary {
  display: none;
}

.file-metadata-disclosure {
  min-width: 0;
}

.extraction-dialog .extraction-heading {
  padding: 14px 16px;
  gap: 12px;
}

.extraction-dialog .extraction-heading h2 {
  font-size: 16px;
  line-height: 1.5;
}

.extraction-dialog .extraction-jobbar {
  padding: 8px 16px;
  gap: 6px 12px;
}

.extraction-dialog .extraction-page-list {
  padding: 6px 16px;
}

.extraction-dialog .extraction-reading-tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: none;
  gap: 8px 16px;
  min-height: 52px;
  padding: 8px 16px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.extraction-reading-tools > .extraction-editor-toolbar {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  border: 0;
  gap: 8px;
}

.extraction-reading-tools .editor-actions {
  margin-left: auto;
}

.extraction-reading-tools .extraction-editor-toolbar select {
  width: auto;
  min-width: 104px;
  max-width: 180px;
}

.extraction-reading-tools .extraction-review-details {
  min-width: 0;
  margin: 0;
  color: var(--ui-text);
  font-size: 13px;
}

.extraction-reading-tools .extraction-review-details[open] {
  flex: 1 1 100%;
}

.extraction-reading-tools .extraction-review-details > summary {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  cursor: pointer;
  list-style: none;
}

.extraction-review-details > summary::-webkit-details-marker {
  display: none;
}

.extraction-review-details .reader-quality-summary {
  color: var(--ui-warning);
  font-size: 12px;
}

.extraction-review-details .extraction-review-information {
  padding: 12px 0 4px;
}

.extraction-review-information > .revision-author {
  max-width: none;
  margin-bottom: 8px;
  font-size: 12px;
  color: var(--ui-muted);
}

.extraction-review-information .page-quality {
  padding: 8px 0;
}

.extraction-review-information .extraction-notice {
  margin: 8px 0 0;
  padding: 8px 0;
}

.extraction-dialog .extraction-comparison {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.extraction-dialog :is(.extraction-original, .extraction-text) {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.extraction-dialog .extraction-section-title {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  flex: 0 0 44px;
  min-height: 44px;
  padding: 8px 16px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.extraction-dialog .extraction-paper {
  flex: 1;
  min-height: 0;
  padding: 20px;
  overflow: auto;
  background: var(--ui-chrome);
}

.extraction-dialog .extraction-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 20px;
}

.extraction-dialog .extraction-reading {
  margin: 0;
  padding: 0;
  border: 0;
}

.extraction-dialog .extraction-saved-text {
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.85;
  color: var(--ui-ink);
}

.extraction-dialog .extraction-block {
  padding: 0 0 16px;
}

.extraction-dialog .extraction-editor-footer {
  flex: none;
  padding: 8px 16px;
  font-size: 12px;
}

@media (max-width: 800px) {
  .drive-content .drive-shell .drive-toolbar {
    padding: 14px;
  }
  .drive-content .drive-file strong {
    font-size: 15px;
  }
  .drive-content .drive-footer {
    padding: 12px 14px;
  }
  .drive-content .processing-bar {
    gap: 4px 10px;
  }
  .drive-content .quality-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: 8px 12px;
    padding: 16px;
  }
  .drive-content .quality-row .quality-file {
    grid-column: 1/-1;
    min-width: 0;
  }
  .drive-content .quality-row .quality-file strong {
    display: block;
    font-size: 14px;
    line-height: 1.6;
  }
  .drive-content .quality-row .quality-file strong > span {
    white-space: nowrap;
  }
  .drive-content .quality-row > .button {
    grid-column: 2;
    justify-self: end;
    margin: 0;
    min-height: 44px;
  }
  .file-dialog .preview-body {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }
  .file-dialog .file-preview {
    flex: 1;
    min-height: 0;
    max-height: none;
    height: auto;
    overflow: auto;
  }
  .file-dialog .file-preview > pre {
    min-height: 0;
    max-height: none;
    height: auto;
    overflow: visible;
  }
  .file-dialog .file-metadata {
    flex: none;
    min-height: 0;
    max-height: none;
    padding: 0;
    overflow: visible;
    border-top: 1px solid var(--ui-line);
  }
  .file-metadata-disclosure > summary {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 48px;
    padding: 12px 16px;
    list-style: none;
    cursor: pointer;
    font-weight: 600;
  }
  .file-metadata-disclosure > summary::-webkit-details-marker {
    display: none;
  }
  .file-metadata-disclosure > summary > i {
    margin-left: auto;
  }
  .file-metadata-disclosure .file-metadata-content {
    padding: 16px;
    max-height: 42dvh;
    overflow: auto;
  }
  .file-metadata-disclosure .metadata-heading {
    display: none;
  }
  .extraction-dialog .extraction-heading {
    padding: 12px;
    gap: 8px;
  }
  .extraction-dialog .extraction-heading h2 {
    font-size: 15px;
    line-height: 1.45;
  }
  .extraction-dialog .extraction-coverage {
    margin-top: 4px;
    font-size: 12px;
  }
  .extraction-dialog .extraction-heading-actions {
    gap: 8px;
    padding-top: 0;
  }
  .extraction-dialog .extraction-jobbar {
    padding: 6px 12px;
  }
  .extraction-dialog .extraction-jobbar > span {
    font-size: 12px;
  }
  .extraction-dialog .extraction-page-list {
    padding: 4px 12px;
  }
  .extraction-dialog .extraction-reading-tools {
    flex-wrap: wrap;
    gap: 6px 10px;
    padding: 6px 12px;
  }
  .extraction-reading-tools > .extraction-editor-toolbar {
    flex: 0 0 auto;
    gap: 6px;
  }
  .extraction-reading-tools .extraction-editor-toolbar select {
    min-width: 0;
    width: 120px;
    max-width: 120px;
    padding-left: 8px;
    padding-right: 24px;
  }
  .extraction-reading-tools .extraction-review-details {
    flex: 1;
  }
  .extraction-reading-tools .extraction-review-details > summary {
    min-height: 44px;
    gap: 6px;
    font-size: 12px;
  }
  .extraction-reading-tools .extraction-review-details > summary > span:first-child {
    flex-shrink: 0;
  }
  .extraction-reading-tools .reader-quality-summary {
    line-height: 1.35;
  }
  .extraction-dialog .extraction-comparison {
    display: block;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
  .extraction-dialog .extraction-comparison:not(.reader-original) .extraction-original, .extraction-dialog .extraction-comparison.reader-original .extraction-text {
    display: none;
  }
  .extraction-dialog .extraction-text > .extraction-section-title {
    display: none;
  }
  .extraction-dialog .extraction-section-title {
    padding: 6px 12px;
  }
  .extraction-dialog .extraction-content {
    padding: 16px;
  }
  .extraction-dialog .extraction-paper {
    padding: 12px;
  }
}
/* Correction: cap long registers without growing a five-folder list. */
@media (min-width: 961px) {
  .drive-content .drive-shell, .drive-content .file-pane, .drive-content .drive-table-wrap {
    flex: 0 1 auto;
  }
}
.drive-content .result-folder {
  position: relative;
}

.drive-content .result-folder > i {
  position: absolute;
  left: -22px;
  margin: 0;
}

@media (max-width: 800px) {
  .drive-content .quality-row .quality-file {
    grid-column: 1/-1;
    grid-row: 1;
  }
  .drive-content .quality-row .quality-row-reason {
    grid-column: 1;
    grid-row: 2;
    align-self: center;
    margin: 0;
    color: var(--ui-muted);
    font-size: 12px;
    line-height: 1.6;
  }
  .drive-content .quality-row > .button {
    grid-column: 2;
    grid-row: 2;
    align-self: center;
  }
}
/* Keep browser select affordances visible in the source reader. */
.extraction-dialog :is(.extraction-jobbar, .extraction-editor-toolbar) select {
  appearance: auto;
  padding-right: 24px;
}

/* At the narrowest width, keep job labels and quality status on complete lines. */
@media (max-width: 360px) {
  .extraction-dialog .extraction-jobbar select {
    grid-column: 1/-1;
    grid-row: 1;
  }
  .extraction-dialog .extraction-jobbar > .icon-button {
    grid-column: 2;
    grid-row: 2;
  }
  .extraction-dialog .extraction-jobbar > span:first-of-type {
    grid-column: 1;
    grid-row: 2;
  }
  .extraction-dialog .extraction-reading-tools .extraction-review-details {
    flex: 1 1 100%;
  }
}
.quality-input-scope {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  align-items: baseline;
  margin: 12px 0;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
}

.quality-input-scope strong {
  color: var(--ui-ink);
  font-weight: 600;
}

/* Source library: persistent location, explicit processing states, continuous document register. */
.drive-content .page-title h1 {
  font-size: 26px;
  line-height: 1.3;
  letter-spacing: -0.025em;
}
.drive-content .processing-overview {
  margin: 0 0 16px;
  border: 0;
  background: transparent;
}
.drive-content .processing-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
}
.drive-content .processing-scope {
  padding: 0 8px;
  color: var(--ui-muted);
  font-size: 13px;
}
.drive-content .processing-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 12px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--ui-text);
  font-size: 13px;
}
.drive-content .processing-toggle.active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  box-shadow: none;
}
.drive-content .processing-toggle.active.needs-check {
  color: var(--ui-on-navy) !important;
}
.drive-content .processing-toggle.active > i:first-child {
  color: inherit;
}
.drive-content .processing-toggle.active.needs-check > i:first-child {
  color: #edce9c;
}
.drive-content .processing-toggle:hover:not(.active) {
  background: var(--ui-selected);
}
.drive-content .processing-toggle.needs-check:not(.active) {
  color: var(--ui-warning);
}
.drive-content .processing-toggle b {
  font-variant-numeric: tabular-nums;
  font-weight: 650;
}
.drive-content .queue-details, .drive-content .quality-details {
  padding: 16px 18px;
  background: var(--ui-paper);
  border: 0;
  border-radius: 14px;
}
.drive-content .queue-view-controls, .drive-content .quality-filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 5px;
  margin: 0 0 14px;
  border: 0;
  border-radius: 10px;
  background: var(--ui-soft);
}
.drive-content .queue-view-controls button, .drive-content .quality-filters button {
  min-height: 34px;
  padding: 6px 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  font-size: 13px;
  color: var(--ui-text);
}
.drive-content .queue-view-controls button.active, .drive-content .quality-filters button.active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  box-shadow: none;
}
.drive-content .queue-view-controls > span, .drive-content .quality-filters > span {
  margin-left: auto;
  padding-inline: 8px;
  color: var(--ui-muted);
  font-size: 13px;
}
.drive-content .queue-row, .drive-content .quality-row {
  padding: 14px 0;
  border-bottom: 1px solid var(--ui-line);
}
.drive-content .queue-row:last-of-type, .drive-content .quality-row:last-of-type {
  border-bottom: 0;
}
.drive-content .quality-reason-control {
  padding: 0;
  margin: 0;
}
.drive-content .quality-input-scope {
  margin: 12px 0;
  color: var(--ui-text);
  font-size: 13px;
}
.drive-content .quality-input-scope strong {
  color: var(--ui-ink);
}
.drive-content .quality-help {
  margin-block: 12px;
  border: 0;
  background: var(--ui-soft);
  border-radius: 9px;
  padding: 3px 12px;
}
.drive-content .drive-shell, .drive-content .trash-pane {
  border: 1px solid var(--ui-line);
  border-radius: 14px;
  background: var(--ui-paper);
  box-shadow: none;
}
.drive-content .drive-shell .drive-toolbar, .drive-content .trash-pane .drive-toolbar {
  padding: 14px 18px;
  gap: 12px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}
.drive-content .drive-location {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 180px;
  min-width: 0;
}
.drive-content .drive-location .path-bar, .drive-content .drive-location .registered-location {
  flex: 1;
  min-width: 0;
}
.drive-content .drive-location .folder-create {
  flex: none;
  min-height: 34px;
  padding: 6px 10px;
  font-size: 12px;
}
.drive-content .path-bar {
  gap: 8px;
}
.drive-content .path-bar button {
  min-height: 32px;
  border-radius: 6px;
  padding: 3px 5px;
  font-size: 13px;
}
.drive-content .path-bar button:hover {
  background: var(--ui-paper);
  color: var(--ui-accent);
}
.drive-content .path-bar button:last-child {
  color: var(--ui-ink);
}
.drive-content .drive-filters {
  gap: 8px;
}
.drive-content .drive-search {
  background: var(--ui-paper);
  border-color: var(--ui-control);
  border-radius: 9px;
}
.drive-content .drive-search input {
  color: var(--ui-ink);
  font-size: 13px;
}
.drive-content .drive-search:focus-within {
  border-color: var(--ui-accent);
  box-shadow: none;
  outline: 2px solid var(--ui-selected);
  outline-offset: 1px;
}
.drive-content .scoped-search select {
  background: transparent;
  appearance: auto;
  color: var(--ui-text);
}
.drive-content .work-filter-select {
  appearance: auto;
  border-radius: 9px;
  background: var(--ui-paper);
  color: var(--ui-text);
}
.drive-content .drive-table thead th {
  padding-block: 11px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 13px;
  font-weight: 550;
}
.drive-content .drive-table tbody tr {
  background: var(--ui-paper);
}
.drive-content .drive-table tbody tr:hover {
  background: var(--ui-soft);
}
.drive-content .drive-table tbody tr.is-selected, .drive-content .drive-table tbody tr.is-selected:hover {
  background: var(--ui-selected);
}
.drive-content .drive-table tbody td {
  height: auto;
  min-height: 60px;
  padding-block: 11px;
  border-bottom: 1px solid var(--ui-line);
  background: transparent;
}
.drive-content .drive-table tbody tr:last-child td {
  border-bottom: 0;
}
.drive-content .drive-file {
  gap: 12px;
}
.drive-content .drive-file strong {
  font-size: 15px;
  font-weight: 600;
  color: var(--ui-ink);
}
.drive-content .drive-file small {
  font-size: 13px;
  color: var(--ui-muted);
}
.drive-content .drive-file-icon {
  flex: 0 0 28px;
  width: 28px;
  height: 34px;
  border-radius: 7px;
  background: transparent;
  color: var(--ui-text);
  font-size: 20px;
}
.drive-content .drive-file-icon.is-folder {
  background: transparent;
  color: var(--ui-muted);
  font-size: 23px;
}
.drive-content .drive-file-icon.is-pdf {
  background: #fbf0f2;
  color: var(--ui-danger);
  font-size: 20px;
}
.drive-content .parent-folder-row .drive-file-icon {
  background: transparent;
}
.drive-content .drive-footer {
  padding: 10px 18px;
  background: var(--ui-soft);
  border-top: 1px solid var(--ui-line);
  font-size: 13px;
}
.drive-content .drive-footer .icon-button {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--ui-paper);
  color: var(--ui-text);
}
.drive-content .drive-footer .icon-button:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--ui-accent);
}
.drive-content .drive-empty, .drive-content .drive-loading {
  padding: 48px 20px;
  min-height: 180px;
  gap: 12px;
  font-size: 14px;
}
.drive-content .drive-empty > i {
  font-size: 28px;
  color: var(--ui-muted);
}
.drive-content .drive-notice {
  border: 0;
  border-radius: 10px;
  background: var(--ui-selected);
  color: var(--ui-text);
}
.drive-content .header-selection {
  background: var(--ui-selected);
}
.drive-content .selection-icon {
  border-radius: 8px;
}
.drive-content .drive-table .file-check {
  appearance: auto;
  flex: none;
  width: 18px;
  height: 18px;
  min-height: 18px;
  padding: 0;
  accent-color: var(--ui-accent);
}

.drive-content.processing-focused .processing-overview {
  border: 1px solid var(--ui-line);
  border-radius: 14px;
  background: var(--ui-paper);
  box-shadow: none;
}

.drive-content.processing-focused .processing-bar {
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 14px 14px 0 0;
}

.file-dialog, .extraction-dialog, .source-form-dialog {
  border: 0;
  border-radius: 16px;
  background: var(--ui-paper);
  box-shadow: var(--ui-overlay-shadow, 0 18px 64px rgba(35, 39, 47, 0.16));
}

.file-dialog::backdrop, .extraction-dialog::backdrop, .source-form-dialog::backdrop {
  background: rgba(35, 39, 47, 0.32);
  backdrop-filter: blur(3px);
}

.file-dialog .file-dialog-header, .extraction-dialog .extraction-heading, .source-form-dialog .source-form-heading {
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.file-dialog .file-dialog-header {
  padding: 15px 20px;
}

.file-dialog .file-dialog-identity {
  gap: 12px;
}

.file-dialog .file-dialog-identity > i {
  display: grid;
  place-items: center;
  width: 38px;
  height: 42px;
  border-radius: 9px;
  background: var(--ui-paper);
  font-size: 21px;
}

.file-dialog .file-dialog-header h2, .source-form-dialog .source-form-heading h2 {
  font-size: 18px;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.file-dialog .pdf-controls {
  padding: 8px 16px;
  background: var(--ui-paper);
  gap: 12px;
}

.file-dialog .file-preview {
  background: var(--ui-chrome);
}

.file-dialog .file-preview > pre {
  font-family: inherit;
  font-size: 16px;
  line-height: 1.85;
  color: var(--ui-ink);
  background: var(--ui-paper);
}

.file-dialog .file-metadata {
  background: var(--ui-soft);
}

.file-dialog .file-metadata dl > div {
  font-size: 13px;
}

.file-dialog .metadata-heading h3 {
  font-size: 15px;
}

.file-dialog .text-preview-note {
  background: var(--ui-paper);
}

.extraction-dialog .extraction-heading {
  padding: 14px 18px;
}

.extraction-dialog .extraction-jobbar, .extraction-dialog .extraction-reading-tools {
  background: var(--ui-soft);
}

.extraction-dialog .extraction-jobbar {
  border-bottom: 1px solid var(--ui-line);
}

.extraction-dialog .extraction-page-list {
  padding: 7px 14px;
  background: var(--ui-paper);
}

.extraction-dialog .extraction-page-list button {
  border-radius: 7px;
  min-height: 32px;
}

.extraction-dialog .extraction-section-title {
  background: var(--ui-paper);
  font-weight: 600;
}

.extraction-dialog .extraction-paper {
  background: var(--ui-chrome);
}

.extraction-dialog .extraction-content {
  background: var(--ui-paper);
}

.extraction-dialog .extraction-saved-text {
  font-size: 16px;
  line-height: 1.85;
}

.extraction-dialog .extraction-editor-footer {
  background: var(--ui-soft);
}

.source-form-dialog :is(input:not([type=checkbox]), select, textarea) {
  border-radius: 9px;
  border-color: var(--ui-control);
  color: var(--ui-ink);
}

.source-form-dialog select {
  appearance: auto;
}

:is(.file-dialog, .extraction-dialog, .source-form-dialog) .icon-button {
  border-radius: 9px;
}

@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .drive-content :is(.processing-toggle, .path-bar button, .drive-table tbody tr, .queue-view-controls button, .quality-filters button, .selection-icon) {
    transition: background-color var(--ui-duration, 180ms) var(--ui-ease, ease-out), color var(--ui-duration, 180ms) var(--ui-ease, ease-out), box-shadow var(--ui-duration, 180ms) var(--ui-ease, ease-out);
  }
}
@media (max-width: 800px) {
  .drive-content .drive-shell .drive-toolbar, .drive-content .trash-pane .drive-toolbar {
    padding: 12px;
  }
  .drive-content .drive-file {
    gap: 9px;
  }
  .drive-content .drive-file-icon {
    flex-basis: 30px;
    width: 30px;
    height: 34px;
  }
  .drive-content .drive-file strong {
    font-size: 15px;
  }
  .drive-content .queue-details, .drive-content .quality-details {
    padding: 12px;
  }
  .drive-content .quality-row {
    padding: 14px 0;
  }
  .drive-content .processing-bar {
    gap: 4px;
  }
  .drive-content .processing-toggle {
    min-height: 44px;
    font-size: 13px;
    white-space: normal;
    text-align: left;
    justify-content: flex-start;
  }
  .drive-content .drive-footer {
    padding: 10px 12px;
    flex-wrap: wrap;
  }
  .drive-content .drive-footer .icon-button {
    width: 44px;
    height: 44px;
  }
  .file-dialog .file-dialog-header {
    padding: 12px 14px;
  }
  .file-dialog .file-dialog-header h2 {
    font-size: 16px;
  }
  .file-dialog .file-metadata {
    background: var(--ui-soft);
  }
  .extraction-dialog .extraction-heading {
    padding: 12px;
  }
  .extraction-dialog .extraction-page-list button {
    min-height: 44px;
  }
}
@media (max-width: 600px) {
  .drive-content .page-title h1 {
    font-size: 24px;
  }
  .drive-content .processing-scope {
    flex-basis: 100%;
    padding: 4px 8px;
    font-size: 13px;
  }
  .drive-content .processing-toggle {
    flex: 1 1 100%;
    gap: 8px;
  }
  .drive-content .queue-view-controls button, .drive-content .quality-filters button {
    min-height: 44px;
    padding-inline: 9px;
  }
  .drive-content .queue-view-controls > span, .drive-content .quality-filters > span {
    flex-basis: 100%;
    padding-block: 4px;
    margin-left: 0;
  }
  .drive-content .drive-search input, .drive-content .drive-search select, .drive-content .work-filter-select {
    font-size: 16px;
  }
  .source-form-dialog :is(input:not([type=checkbox]), select, textarea) {
    font-size: 16px;
    min-height: 44px;
  }
}
@media (pointer: coarse) {
  .drive-content :is(.processing-toggle, .queue-view-controls button, .quality-filters button, .path-bar button) {
    min-height: 44px;
  }
  .drive-content .drive-footer .icon-button {
    width: 44px;
    height: 44px;
  }
  .extraction-dialog .extraction-page-list button {
    min-height: 44px;
  }
}
/* Full diagnostic text must not squeeze its document name or action. */
.drive-content .quality-row .quality-row-reason {
  min-width: 0;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.drive-content .quality-row .quality-row-reason.needs-check {
  color: var(--ui-warning);
}

.drive-content .quality-row .quality-file strong > span {
  white-space: nowrap;
}

@media (min-width: 801px) {
  .drive-content .quality-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: 5px 20px;
  }
  .drive-content .quality-row .quality-file {
    grid-column: 1;
    grid-row: 1;
    min-width: 0;
  }
  .drive-content .quality-row .quality-row-reason {
    grid-column: 1;
    grid-row: 2;
    margin: 0;
  }
  .drive-content .quality-row > .button {
    grid-column: 2;
    grid-row: 1/span 2;
    align-self: center;
    justify-self: end;
  }
}
/* Source tasks use one fixed navigation level; each view owns its controls. */
.source-workspace-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0 0 16px;
  padding: 0 0 8px;
  border-bottom: 1px solid var(--ui-line);
}

.source-workspace-nav > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 9px 14px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--ui-muted);
  font-size: 14px;
  font-weight: 550;
  white-space: nowrap;
}

.source-workspace-nav > button:hover {
  background: var(--ui-soft);
  color: var(--ui-ink);
}

.source-workspace-nav > button.active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  font-weight: 650;
}

.source-workspace-nav .source-nav-count {
  padding: 1px 6px;
  border-radius: 5px;
  background: var(--ui-soft);
  color: var(--ui-text);
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.source-workspace-nav > button.active .source-nav-count {
  background: var(--ui-accent-hover);
  color: var(--ui-on-navy);
}

.source-workspace-scope {
  margin-left: auto;
  padding-inline: 6px;
  color: var(--ui-muted);
  font-size: 12px;
}

.drive-content .drive-actions > .drive-more {
  gap: 6px;
  width: auto;
  min-width: 82px;
  padding-inline: 11px;
}

.drive-content .quality-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0 0 12px;
  border-bottom: 1px solid var(--ui-line);
}

.drive-content .quality-toolbar .quality-filters {
  flex: 0 1 auto;
  margin: 0;
  background: transparent;
  padding: 0;
  gap: 4px;
}

.drive-content .quality-toolbar .quality-filters > span {
  display: none;
}

.drive-content .quality-toolbar .quality-reason-control {
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 0 1 320px;
  min-width: 0;
}

.drive-content .quality-toolbar .quality-reason-control label {
  white-space: nowrap;
  font-size: 12px;
  color: var(--ui-muted);
}

.drive-content .quality-toolbar .quality-reason-control select {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  height: 36px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
  padding: 5px 8px;
}

.drive-content .quality-help {
  margin: 10px 0 4px;
  background: transparent;
  padding: 0;
  border-radius: 0;
  color: var(--ui-muted);
}

.drive-content .quality-help summary {
  min-height: 30px;
  padding: 4px 0;
  font-size: 12px;
}

.drive-content .quality-help[open] {
  padding: 0 12px 10px;
  background: var(--ui-soft);
  border-radius: 8px;
}

.drive-content .quality-help .quality-input-scope {
  font-size: 13px;
  line-height: 1.65;
}

.drive-content .queue-view-controls {
  background: transparent;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 0;
  padding: 0 0 12px;
  margin-bottom: 0;
}

.drive-content .queue-view-controls .queue-stop-all {
  margin-left: 8px;
  border: 1px solid var(--ui-control);
  background: var(--ui-paper);
}

.drive-content .quality-row .quality-file strong {
  font-size: 15px;
}

.drive-content .quality-row .quality-row-reason {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
}

/* A completed extraction opens directly into reading; full run history stays nearby. */
.extraction-dialog .extraction-run-history {
  flex: none;
  margin: 0;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.extraction-dialog .extraction-run-history > summary {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 38px;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: var(--ui-text);
  list-style: none;
}

.extraction-dialog .extraction-run-history > summary::-webkit-details-marker {
  display: none;
}

.extraction-dialog .extraction-run-history > summary > span {
  font-weight: 450;
  color: var(--ui-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.extraction-dialog .extraction-run-history > summary > i {
  margin-left: auto;
  font-size: 11px;
}

.extraction-dialog .extraction-run-history[open] > summary > i {
  transform: rotate(180deg);
}

.extraction-dialog .extraction-run-history .extraction-jobbar {
  border-bottom: 0;
  padding-top: 0;
}

.extraction-dialog .extraction-page-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
  padding: 8px 18px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.extraction-dialog .extraction-page-navigation select {
  flex: 0 1 320px;
  min-width: 0;
  max-width: 100%;
  min-height: 36px;
  padding: 6px 10px;
  font-family: inherit;
  font-size: 13px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  color: var(--ui-ink);
  background: var(--ui-paper);
}

.extraction-dialog .extraction-page-navigation > .icon-button {
  min-width: 36px;
  height: 36px;
  flex: none;
  border: 1px solid var(--ui-line);
}

.extraction-dialog .extraction-page-navigation > span {
  margin-left: auto;
  color: var(--ui-muted);
  font-size: 12px;
  white-space: nowrap;
}

@media (max-width: 800px) {
  .source-workspace-nav {
    gap: 3px;
    margin-bottom: 12px;
    padding-bottom: 8px;
  }
  .source-workspace-nav > button {
    min-height: 44px;
    padding: 8px 10px;
    font-size: 13px;
    gap: 6px;
  }
  .source-workspace-scope {
    display: none;
  }
  .drive-content .drive-location {
    flex: 1 1 100%;
  }
  .drive-content .quality-toolbar .quality-reason-control {
    flex: 1 1 260px;
  }
  .drive-content .quality-toolbar .quality-reason-control select {
    min-height: 44px;
  }
  .extraction-dialog .extraction-run-history > summary {
    min-height: 44px;
    padding: 8px 12px;
  }
  .extraction-dialog .extraction-page-navigation {
    padding: 8px 12px;
    gap: 6px;
  }
  .extraction-dialog .extraction-page-navigation select {
    min-height: 44px;
    font-size: 16px;
  }
  .extraction-dialog .extraction-page-navigation > .icon-button {
    min-width: 44px;
    height: 44px;
  }
}
@media (max-width: 600px) {
  .source-workspace-nav {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .source-workspace-nav > button {
    min-width: 0;
    padding: 8px 5px;
    flex-wrap: wrap;
    column-gap: 5px;
    row-gap: 3px;
    font-size: 13px;
  }
  .source-workspace-nav > button > i {
    display: none;
  }
  .source-workspace-nav .source-nav-count {
    padding-inline: 5px;
    font-size: 11px;
  }
  .drive-content .drive-more span {
    display: inline;
    font-size: 12px;
  }
  .drive-content .drive-location .folder-create {
    min-height: 40px;
  }
  .drive-content .quality-toolbar {
    gap: 10px;
  }
  .drive-content .quality-toolbar .quality-filters {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 3px;
  }
  .drive-content .quality-toolbar .quality-filters button {
    min-width: 0;
    padding: 8px 5px;
    font-size: 12px;
    line-height: 1.5;
  }
  .drive-content .quality-toolbar .quality-reason-control {
    flex-basis: 100%;
  }
  .drive-content .queue-view-controls > span {
    order: 3;
    flex: 1 1 100%;
    margin: 0;
  }
  .drive-content .queue-view-controls .queue-stop-all {
    margin-left: auto;
  }
  .extraction-dialog .extraction-page-navigation select {
    flex: 1;
  }
  .extraction-dialog .extraction-page-navigation > span {
    display: none;
  }
  .extraction-dialog .extraction-run-history > summary {
    gap: 8px;
  }
}
/* Keep the warning and counts readable; full machine diagnostic remains available. */
.drive-content .quality-raw-detail {
  margin-top: 4px;
  color: var(--ui-muted);
}

.drive-content .quality-raw-detail > summary {
  width: fit-content;
  min-height: 28px;
  padding: 3px 0;
  cursor: pointer;
  font-size: 12px;
}

.drive-content .quality-raw-detail p {
  margin: 4px 0 0;
  padding: 8px 10px;
  background: var(--ui-soft);
  border-left: 2px solid var(--ui-line);
  overflow-wrap: anywhere;
  color: var(--ui-text);
}

@media (pointer: coarse), (max-width: 760px) {
  .drive-content .quality-raw-detail > summary {
    min-height: 44px;
    align-content: center;
  }
}
/* Review reading order: document, current finding, input state and destination. */
.drive-content .quality-details {
  padding: 0 20px;
}

.drive-content .quality-toolbar {
  padding: 16px 0;
  gap: 12px;
  border-bottom: 1px solid var(--ui-line);
}

.drive-content .quality-toolbar .quality-filters {
  gap: 4px;
}

.drive-content .quality-toolbar .quality-filters button {
  min-height: 40px;
  padding: 8px 14px;
  font-size: 13px;
  white-space: nowrap;
}

.drive-content .quality-toolbar .quality-reason-control {
  flex: 0 1 280px;
}

.drive-content .quality-toolbar .quality-reason-control select {
  height: 40px;
  font-size: 14px;
}

.drive-content .quality-review-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: "document actions" "problem actions";
  column-gap: 32px;
  row-gap: 8px;
  padding: 24px 0;
  border-bottom: 1px solid var(--ui-line);
  cursor: pointer;
}

.drive-content .quality-review-item:hover {
  background: transparent;
}

.drive-content .quality-document {
  grid-area: document;
  display: flex;
  align-items: baseline;
  gap: 12px;
  min-width: 0;
}

.drive-content .quality-document > strong {
  font-size: 17px;
  font-weight: 650;
  line-height: 1.5;
  letter-spacing: -0.015em;
  color: var(--ui-ink);
  overflow-wrap: anywhere;
}

.drive-content .quality-document > span {
  flex: none;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
}

.drive-content .quality-problem {
  grid-area: problem;
  min-width: 0;
  max-width: 78ch;
}

.drive-content .quality-problem > summary {
  display: flex;
  align-items: baseline;
  gap: 8px;
  list-style: none;
  cursor: pointer;
  min-height: 32px;
  padding: 4px 0;
  color: var(--ui-text);
}

.drive-content .quality-problem > summary::-webkit-details-marker {
  display: none;
}

.drive-content .quality-problem > summary > i:first-child {
  flex: none;
  color: var(--ui-accent);
  font-size: 13px;
}

.drive-content .quality-problem.has-issue > summary > i:first-child {
  color: var(--ui-warning);
}

.drive-content .quality-problem-title {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.drive-content .quality-more-reasons {
  flex: none;
  white-space: nowrap;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.65;
}

.drive-content .quality-expand {
  flex: none;
  color: var(--ui-muted);
  font-size: 10px;
}

.drive-content .quality-problem[open] .quality-expand {
  transform: rotate(180deg);
}

.drive-content .quality-problem-details {
  padding: 12px 0 0 21px;
  font-size: 13px;
  line-height: 1.7;
  color: var(--ui-muted);
}

.drive-content .quality-problem-details dl {
  display: grid;
  gap: 4px;
  margin: 0 0 12px;
}

.drive-content .quality-problem-details dl:empty {
  display: none;
}

.drive-content .quality-problem-details dl > div {
  display: flex;
  gap: 12px;
}

.drive-content .quality-problem-details dt {
  flex: none;
  min-width: 52px;
  font-weight: 500;
}

.drive-content .quality-problem-details dd {
  margin: 0;
  color: var(--ui-text);
}

.drive-content .quality-problem-details ul {
  margin: 0;
  padding-left: 17px;
  display: grid;
  gap: 8px;
  color: var(--ui-text);
}

.drive-content .quality-problem-details li {
  overflow-wrap: anywhere;
}

.drive-content .quality-review-footer {
  grid-area: actions;
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: center;
}

.drive-content .quality-input-state {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--ui-accent);
  white-space: nowrap;
}

.drive-content .quality-input-state.input-blocked {
  color: var(--ui-warning);
}

.drive-content .quality-review-footer .quality-open {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 40px;
  white-space: nowrap;
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
}

.drive-content .quality-review-footer .quality-open i {
  font-size: 12px;
}

.drive-content .quality-help {
  margin: 0;
  padding: 12px 0;
  color: var(--ui-muted);
}

.drive-content .quality-help > summary {
  font-size: 12px;
  min-height: 40px;
  align-content: center;
}

@media (max-width: 1100px) {
  .drive-content .quality-review-footer {
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
  }
}
@media (max-width: 800px) {
  .drive-content .quality-details {
    padding: 0 16px;
  }
  .drive-content .quality-toolbar {
    padding: 12px 0;
    gap: 8px;
  }
  .drive-content .quality-toolbar .quality-filters {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    flex: 1 1 100%;
  }
  .drive-content .quality-toolbar .quality-filters button {
    min-height: 44px;
    padding: 8px 6px;
    font-size: 13px;
  }
  .drive-content .quality-toolbar .quality-reason-control {
    flex: 1 1 100%;
  }
  .drive-content .quality-toolbar .quality-reason-control select {
    min-height: 44px;
    font-size: 16px;
  }
  .drive-content .quality-review-item {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "document" "problem" "actions";
    row-gap: 8px;
    padding: 20px 0;
  }
  .drive-content .quality-document {
    display: block;
  }
  .drive-content .quality-document > strong {
    display: block;
    font-size: 17px;
  }
  .drive-content .quality-document > span {
    display: block;
    margin-top: 3px;
  }
  .drive-content .quality-problem > summary {
    min-height: 44px;
    align-items: baseline;
    gap: 7px;
  }
  .drive-content .quality-problem-title {
    font-size: 15px;
  }
  .drive-content .quality-review-footer {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
  }
  .drive-content .quality-review-footer .quality-open {
    min-height: 44px;
    margin-left: auto;
  }
  .drive-content .quality-input-state {
    white-space: normal;
    line-height: 1.5;
  }
}
@media (pointer: coarse) {
  .drive-content .quality-problem > summary, .drive-content .quality-review-footer .quality-open {
    min-height: 44px;
  }
}
/* Reserve the same chevron space in the compact document controls. */
.pdf-zoom-controls select {
  width: 160px;
  text-align: start;
  text-align-last: start;
}

.drive-shell .scoped-search select {
  flex-basis: 160px;
  width: 160px;
}

@media (max-width: 620px) {
  .work-filter-select {
    width: 156px;
  }
  .extraction-reading-tools .extraction-editor-toolbar select {
    width: 154px;
    max-width: 154px;
  }
}
@media (max-width: 600px) {
  .drive-shell .scoped-search select {
    flex-basis: 176px;
    width: 176px;
  }
}`],
})
export class PageSourcesComponent implements OnInit, OnDestroy {
    openRow(event:MouseEvent) { activateListRow(event); }
    @ViewChild('sourceHeading') sourceHeading?: ElementRef<HTMLElement>;
    @ViewChild('driveMenu') driveMenu!: ElementRef<HTMLElement>;
    datasetCount=0; datasetBusy=false;
    workFilter=''; showSystem=false; searchScope='folder';
    download:any=null; downloadBusy=false; downloadSending=false; private downloadTimer:any;
    private downloadDead=false; private downloadAuto=false; private downloadRequest=0; private downloadWatchUntil=0;
    private downloadFrame:HTMLIFrameElement|null=null;
    @ViewChild('trashConfirm') trashConfirm!: ElementRef<HTMLDialogElement>;
    trashMode=false; lastFolder='storage'; trashChecked:string[]=[]; trashAction=''; trashTargets:any[]=[];
    trashBusy=false; trashError='';
    @ViewChild('itemMenu') itemMenu!: ElementRef<HTMLElement>;
    @ViewChild('organizeDialog') organizeDialog!: ElementRef<HTMLDialogElement>;
    menuItem:any=null; menuLeft=0; menuTop=0;
    organizeMode=''; organizeItems:any[]=[]; organizeName=''; organizeBusy=false; organizeError='';
    destination=''; destinationPage:any={items:[],page:1,pages:1}; destinationLoading=false; private destinationRequest=0;
    @ViewChild('uploader') uploader:any;
    canDeactivate() { return !this.trashBusy && !this.exSaving && (this.uploader?.canLeave() ?? true) && this.leaveExtractionEdit(); }
    @ViewChild('pdfViewport') pdfViewport?: ElementRef<HTMLElement>;
    @ViewChild('pdfImage') pdfImage?: ElementRef<HTMLImageElement>;
    pdfPageInput: number | null = 1; pdfPageError = ''; pdfZoom = 100; pdfView = 'page'; pdfWidth = 0;
    private pdfResize?: ResizeObserver;
    private pdfRequest = 0;
    @ViewChild('previewDialog') previewDialog!: ElementRef<HTMLDialogElement>;
    @ViewChild('registrationDialog') registrationDialog!: ElementRef<HTMLDialogElement>;
    @ViewChild('folderDialog') folderDialog!: ElementRef<HTMLDialogElement>;
    @ViewChild('extractionDialog') extractionDialog!: ElementRef<HTMLDialogElement>;
    @ViewChild('batchDialog') batchDialog!: ElementRef<HTMLDialogElement>;
    quality:any={counts:{},items:[],page:1,pages:1,mode:'issues',category:''};
    qualityCategories=[{code:'TEXT',label:'실제 텍스트 문제'},{code:'STRUCTURE',label:'표·그림 구조 확인'},{code:'REVIEW',label:'기존 검토 보류'},{code:'UNCLASSIFIED',label:'사유 미분류'}];
    qualityOpen=false; qualityLoaded=false; qualityLoading=false; qualityWorking=false; qualityError=''; private qualityRequest=0; private qualityRefreshing=false;
    checked:any[]=[]; batchPlan:any=null; batchBusy=false; batchError='';
    queue:any={items:[],counts:{},page:1,pages:1,total:0}; fileJobs:any={};
    queueView='work'; queueLoading=false;
    queueOpen=false; queueLoaded=false; queueBusy=false; queueError=''; private queueTimer:any; private queueDead=false; private queueRequest=0;
    exOpen=false; exSource:any=null; exState:any={jobs:[],pages:[]}; exJob=0; exPage=1; exFirst=1; exLast=1;
    exResult:any=null; exError=''; exBusy=false; exLoading=false; exImageError=false; private exTimer:any; private exEpoch=0; private exResultKey='';
    exIssueReview=false; exIssueMessage='';
    exEditing=false; exDraft=''; exOriginal=false; exSaving=false; exSaved=''; exRevision=0;
    exPageLoading=false; exShowSetup=false; exZoom=100; exPane='text';
    canRead = false; canWrite = false; canAdmin = false; formBusy = false; formError = ''; notice = ''; folderName = '';
    registration: any = {}; registrationFile: File | null = null; uploadProgress = 0;
    registeredInfo: any = null; formParent = ''; formKey = '';
    workspacePage = '문헌 관리';
    user: any = null; csrf = ''; restricted = false;
    loading = true; error = ''; detailError = ''; query = ''; path = 'storage';
    page: any = {items:[],total:0,page:1,pages:1}; selected: any = null;
    previewTarget: {key:string,name:string} | null = null;
    selecting = false; pdfUrl: string | null = null; pdfPage = 1; pdfLoading = false; pdfError = false;
    private routeSub: any; private requestId = 0; private detailId = 0;
    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute,@Inject( Router)  private router: Router) {
        const prepared = this.route.snapshot.data['workspace'];
        this.user = prepared?.session?.data?.user;
        this.csrf = prepared?.session?.data?.csrf || '';
        this.canRead = this.user?.status === 'active' && ['admin','researcher','reviewer','external'].includes(this.user.role);
        this.canAdmin = this.user?.status === 'active' && this.user?.role === 'admin';
        this.canWrite = this.user?.status === 'active' && ['admin','researcher'].includes(this.user.role);
        this.restricted = !!this.user && (this.user.status !== 'active' || !['admin','researcher','reviewer','external'].includes(this.user.role));
        this.trashMode = this.route.snapshot.queryParamMap.get('trash') === '1';
        this.path = this.route.snapshot.queryParamMap.get('path') || 'storage';
        this.query = this.route.snapshot.queryParamMap.get('q') || '';
        this.searchScope = this.route.snapshot.queryParamMap.get('scope') === 'registered' ? 'registered' : 'folder';
        this.workFilter=this.route.snapshot.queryParamMap.get('work') || '';
        this.showSystem=this.route.snapshot.queryParamMap.get('system')==='1';
        if (prepared?.result?.code === 200) this.page = prepared.result.data;
        else if (prepared?.result?.code===204) this.loading=true;
        else if (!this.restricted) this.error = prepared?.result?.data?.message || '자료를 불러오지 못했습니다.';
        this.loading = prepared?.result?.code===204 && !this.restricted;
    }
    async ngOnInit() {
        await this.service.init();
        document.title = '문헌 관리 · 한의문헌 저작도구';
        if(this.canWrite) this.loadDatasetBasket();
        if (this.restricted || !this.user) { await this.service.render(); return; }
        let initial = true;
        this.routeSub = this.route.queryParamMap.subscribe(params => {
            const path = params.get('path') || 'storage';
            const trashMode = params.get('trash') === '1';
            const searchScope = params.get('scope') === 'registered' ? 'registered' : 'folder';
            if (path !== this.path || trashMode !== this.trashMode || searchScope !== this.searchScope || (params.get('work') || '')!==this.workFilter || (params.get('system')==='1')!==this.showSystem) { this.checked = []; this.trashChecked = []; this.notice = ''; this.itemMenu?.nativeElement.hidePopover(); }
            this.searchScope = searchScope;
            this.trashMode = trashMode; this.path = path; this.query = params.get('q') || '';
            this.workFilter=params.get('work') || ''; this.showSystem=params.get('system')==='1';
            this.queueOpen=false; this.qualityOpen=false;
            if(params.get('focus')==='issues' || params.get('focus')==='results') {
                this.qualityOpen=true; this.queueOpen=false;
                const mode=params.get('focus')==='results'?'all':params.get('quality_mode')==='structure'?'structure':'issues';
                const category=mode==='issues' && this.qualityCategories.some(item=>item.code===params.get('category')) ? params.get('category') : '';
                if(this.quality.mode!==mode || this.quality.category!==category) this.quality.page=1;
                this.quality.mode=mode; this.quality.category=category;
            }
            if(params.get('focus')==='queue') { this.queueOpen=true; this.qualityOpen=false; this.queueView=params.get('queue_view')==='history'?'history':'work'; }
            if(['issues','results','queue'].includes(params.get('focus'))) this.focusProcessing();
            if (initial) { initial = false; if(this.loading)this.load(Number(params.get('page')) || 1); return; }
            this.closePreview();
            this.load(Number(params.get('page')) || 1);
            if(params.get('result')) this.openLinkedResult();
        });
        await this.service.render(); this.loadQueue();
        this.openLinkedResult();
        const token=sessionStorage.getItem(this.downloadStorageKey());
        if(token) { this.download={id:token,state:'PENDING'}; this.pollDownload(); }
    }

    async loadDatasetBasket() {
        try { const res=await wiz.app('page.datasets').call('draft'); if(res.code===200) this.datasetCount=res.data.draft.selection.length; }
        catch { /* The drive remains available if the dataset service cannot load. */ }
        await this.service.render();
    }
    async addDatasetSources() {
        if(this.datasetBusy || !this.checked.length) return;
        this.datasetBusy=true; this.error=''; await this.service.render();
        try {
            const res=await wiz.app('page.datasets').call('add',{csrf:this.csrf,selection:JSON.stringify(this.checked.map(item=>({key:item.key,kind:item.kind})))});
            if(res.code!==200) throw new Error(res.data?.message || '자료를 담지 못했습니다.');
            this.datasetCount=res.data.draft.selection.length;
            this.notice='데이터셋 자료에 담았습니다. 다른 폴더에서 더 담거나 데이터셋 설정으로 이동할 수 있습니다.';
        } catch(e:any) { this.error=e.message; }
        finally { this.datasetBusy=false; await this.service.render(); }
    }

    ngOnDestroy() { this.pdfResize?.disconnect(); this.downloadDead=true; this.downloadRequest++; clearTimeout(this.downloadTimer); this.downloadFrame?.remove(); this.queueDead=true; clearTimeout(this.queueTimer); this.closeExtraction(undefined,true); this.routeSub?.unsubscribe(); this.requestId++; this.detailId++; }
    get appliedQuery() { return this.route.snapshot.queryParamMap.get('q') || ''; }
    async load(page = this.page.page) {
        const requestId = ++this.requestId;
        this.loading = true; this.error = ''; await this.service.render();
        try {
            const res = await wiz.call(this.trashMode?'trash_list':'browse',{path:this.path,scope:this.searchScope,q:this.appliedQuery,page,work:this.workFilter,show_system:this.showSystem?'1':'0'});
            if (requestId !== this.requestId) return;
            if (res.code === 401) { this.service.href('/access/login'); return; }
            if (res.code !== 200) throw new Error(res.data?.message || '자료를 불러오지 못했습니다.');
            this.page = res.data;
        } catch(e) { if (requestId === this.requestId) { this.page = {items:[],total:0,page:1,pages:1}; this.error = e.message || '연결을 확인해 주세요.'; } }
        finally { if(requestId === this.requestId) { this.loading = false; await this.service.render(); this.loadQueue(); } }
    }
    refresh() { this.load(); }
    retryBrowse() { if(!this.loading) this.load(Number(this.route.snapshot.queryParamMap.get('page')) || 1); }
    parentFolder() {
        if (this.path === 'storage' || this.loading) return;
        this.navigate(this.path.split('/').slice(0,-1).join('/'));
    }
    navigate(path: string, q = '', page = 1, work=this.workFilter, system=this.showSystem, scope='folder') {
        this.router.navigate(['/sources'],{queryParams:{path:!path || path === 'storage' ? null : path,q:q || null,page:page>1?page:null,work:scope==='folder' ? work || null : null,system:system?'1':null,scope:scope==='registered' ? scope : null}});
        this.service.render();
    }
    setWork(value:string) { this.navigate(this.path,this.query,1,value); }
    setSystem(value:boolean) { this.driveMenu.nativeElement.hidePopover(); this.navigate(this.path,this.query,1,this.workFilter,value); }
    processingOpen() { return !this.restricted && !this.trashMode && (this.queueOpen || this.qualityOpen); }
    async focusProcessing() {
        await this.service.render();
        if(this.queueDead || !this.processingOpen()) return;
        const heading=this.sourceHeading?.nativeElement;
        heading?.focus({preventScroll:true});
        heading?.scrollIntoView({block:'start',behavior:'instant' as ScrollBehavior});
    }
    async returnToStorage() {
        this.queueOpen=false; this.qualityOpen=false;
        this.router.navigate(['/sources'],{queryParams:{focus:null,quality_mode:null,category:null,queue_view:null},queryParamsHandling:'merge'});
        await this.service.render();
        if(this.queueDead || this.processingOpen()) return;
        this.sourceHeading?.nativeElement.focus({preventScroll:true});
    }
    toggleProcessing(section:string) {
        if((section==='queue' && this.queueOpen) || (section==='quality' && this.qualityOpen)) { this.returnToStorage(); return; }
        this.queueOpen=section==='queue'; this.qualityOpen=section!=='queue';
        this.focusProcessing();
    }
    selectSourceView(section:string) {
        if(this.restricted || this.trashMode || !['storage','quality','queue'].includes(section)) return;
        if(section==='storage') {
            if(this.processingOpen()) this.returnToStorage();
            return;
        }
        if((section==='quality' && this.qualityOpen) || (section==='queue' && this.queueOpen)) return;
        this.toggleProcessing(section);
    }
    adjacentExtractionPage(offset:number) {
        const pages=this.exState?.pages || [];
        const index=pages.findIndex(row=>Number(row.page)===Number(this.exPage));
        if(index<0 || ![-1,1].includes(offset)) return null;
        return pages[index+offset]?.page ?? null;
    }
    stepExtractionPage(offset:number) {
        if(this.exSaving || this.exPageLoading) return;
        const page=this.adjacentExtractionPage(offset);
        if(page!==null) this.selectExtractionPage(page);
    }
    setQueueView(view:string) {
        if(!['work','history'].includes(view) || this.queueView===view) return;
        this.queueView=view; this.queue.items=[]; this.queueLoaded=false;
        this.loadQueue(1);
    }
    async openDriveMenu(event:MouseEvent) {
        const menu=this.driveMenu.nativeElement, rect=(event.currentTarget as HTMLElement).getBoundingClientRect();
        menu.style.left=Math.max(8,Math.min(rect.right-210,innerWidth-218))+'px';
        menu.style.top=(rect.bottom+6)+'px'; menu.showPopover();
    }
    async openLinkedResult() {
        const params=this.route.snapshot.queryParamMap, key=params.get('result');
        if(!key) return;
        try {
            const res=await wiz.call('detail',{path:key});
            if(this.queueDead || this.route.snapshot.queryParamMap.get('result')!==key || this.route.snapshot.queryParamMap.get('job')!==params.get('job')) return;
            if(res.code!==200) throw new Error(res.data?.message || '결과를 열지 못했습니다.');
            this.selected=res.data;
            await this.openExtraction(Number(params.get('job')) || 0, Number(params.get('pdf_page')) || 0);
        } catch(e) { this.error=e.message; await this.service.render(); }
    }
    rowJob(item:any) { return this.fileJobs[item.id] || item.extraction; }
    rowLabel(item:any) {
        if(item.kind==='folder') return '';
        if(item.state!=='registered' || (item.format!=='PDF' && !this.rowJob(item))) return this.status(item.state);
        const job=this.rowJob(item);
        if(job && ['PENDING','RUNNING','PAUSING','PAUSED'].includes(job.status)) return this.exStatus(job.status);
        if(item.issue_count) return '확인 필요 '+item.issue_count+(item.format==='PDF'?'쪽':'건');
        if(job?.status==='FAILED') return '추출 실패';
        if(item.has_results || job?.status==='SUCCESS') return '결과 있음';
        return job ? '결과 확인' : item.unextracted ? '추출 전' : this.status(item.state);
    }
    rowHasResult(item:any) { return !!item && item.state==='registered' && !!this.rowJob(item); }
    openRowResult(item:any) {
        this.itemMenu?.nativeElement.hidePopover();
        const job=this.rowJob(item);
        if(item.issue_target && !['PENDING','RUNNING','PAUSING','PAUSED'].includes(job.status)) {
            this.openQualityPage({path:item.key,job:item.issue_target.job,page:item.issue_target.page});
            return;
        }
        this.openQueueResult({id:job.id || job.job,source:item.id,file_key:item.key});
    }
    search() {
        if (this.trashMode) this.navigateTrash(this.query);
        else this.navigate(this.path, this.query, 1, this.workFilter, this.showSystem, this.searchScope);
    }
    setSearchScope(value: string) {
        this.searchScope = value; this.checked = [];
        this.search();
    }
    browsePage(page: number) {
        this.navigate(this.path, this.appliedQuery, page, this.workFilter, this.showSystem, this.searchScope);
    }
    folderOnly() { return this.page.items.length > 0 && this.page.items.every(item => item.kind === 'folder'); }
    hasCoverage() { return this.page.items.some(item => item.text_pages != null && (item.format === 'PDF' || item.has_results)); }
    coverage(item: any) {
        if (item?.format !== 'PDF') return item?.has_results ? '문서 전체 텍스트' : '';
        if (item.text_pages == null) return '';
        const pages = Number(item.text_pages).toLocaleString();
        return item.page_count == null
            ? '텍스트 ' + pages + '쪽 · 전체 미확인'
            : '텍스트 ' + pages + ' / ' + Number(item.page_count).toLocaleString() + '쪽';
    }
    previewPageMismatch() {
        const file = this.selected;
        return file?.preview?.kind === 'pdf' && file.metadata?.page_count != null &&
            file.preview.pages !== file.metadata.page_count;
    }
    crumbs() {
        const chunks = this.path ? this.path.split('/') : [];
        return chunks.slice(1).map((name,index)=>({name:name.normalize('NFC'),key:chunks.slice(0,index+2).join('/')}));
    }
    open(item: any) {
        if(item.state === 'blocked') return;
        if(item.kind === 'folder') { this.navigate(item.key); return; }
        this.openPreview(item);
    }
    async openPreview(item: any) {
        this.previewTarget = {key:item.key,name:item.name || item.key?.split('/').pop() || '파일 미리보기'};
        const detailId = ++this.detailId;
        this.pdfResize?.disconnect(); this.pdfResize=undefined;
        this.pdfView='page'; this.pdfZoom=100; this.pdfWidth=0; this.pdfPageError='';
        this.selecting = true; this.detailError = ''; this.selected = null; this.pdfUrl = null;
        await this.service.render(); this.previewDialog.nativeElement.showModal();
        try {
            const res = await wiz.call('detail',{path:item.key});
            if(detailId !== this.detailId) return;
            if(res.code === 401) { this.service.href('/access/login'); return; }
            if(res.code !== 200) throw new Error(res.data?.message || '파일 정보를 불러오지 못했습니다.');
            this.selected = res.data;
            if(res.data.preview.kind === 'pdf') {
                this.changePdfPage(1);
            }
        } catch(e) { if(detailId === this.detailId) this.detailError = e.message || '연결 상태를 확인한 뒤 다시 시도해 주세요.'; }
        finally { if(detailId===this.detailId) { this.selecting = false; await this.service.render(); } }
    }
    changePdfPage(page: number) {
        const total=Number(this.selected?.preview?.pages || 0);
        if(!Number.isInteger(page) || page<1 || page>total) {
            this.pdfPageError='1–'+total+'쪽을 입력해 주세요.'; this.service.render(); return;
        }
        this.pdfPageInput=page; this.pdfPageError='';
        // Reusing the same image URL does not emit another load event.
        if(page===this.pdfPage && this.pdfUrl && !this.pdfError) { this.service.render(); return; }
        this.pdfPage = page;
        this.pdfLoading = true; this.pdfError = false;
        this.pdfViewport?.nativeElement.scrollTo(0,0);
        this.pdfUrl = '/wiz/api/page.sources/pdf?path='+encodeURIComponent(this.selected.key)+'&page='+page+'&request='+(++this.pdfRequest);
        this.service.render();
    }
    jumpPdfPage() { this.changePdfPage(Number(this.pdfPageInput)); }
    pdfLoaded(failed = false) {
        this.pdfLoading = false; this.pdfError = failed;
        if(!failed) {
            if(!this.pdfResize && this.pdfViewport) {
                this.pdfResize=new ResizeObserver(()=>{ if(this.pdfView!=='custom') this.fitPdf(); });
                this.pdfResize.observe(this.pdfViewport.nativeElement);
            }
            this.fitPdf();
        }
        this.service.render();
    }
    fitPdf() {
        const viewport=this.pdfViewport?.nativeElement, image=this.pdfImage?.nativeElement;
        if(!viewport || !image?.naturalWidth || this.pdfError) return;
        const width=Math.max(1,viewport.clientWidth-48),height=Math.max(1,viewport.clientHeight-48);
        let ratio=this.pdfZoom/100;
        if(this.pdfView==='width') ratio=width/image.naturalWidth;
        if(this.pdfView==='page') ratio=Math.min(width/image.naturalWidth,height/image.naturalHeight);
        this.pdfWidth=Math.max(1,Math.round(image.naturalWidth*ratio));
        this.pdfZoom=Math.round(ratio*100);
        this.service.render();
    }
    async setPdfView(value: string) {
        const viewport=this.pdfViewport?.nativeElement;
        const centerX=viewport ? (viewport.scrollLeft+viewport.clientWidth/2)/viewport.scrollWidth : .5;
        const centerY=viewport ? (viewport.scrollTop+viewport.clientHeight/2)/viewport.scrollHeight : .5;
        if(value==='page' || value==='width') this.pdfView=value;
        else {
            const zoom=Number(value);
            if(!Number.isFinite(zoom)) return;
            this.pdfView='custom'; this.pdfZoom=Math.min(300,Math.max(25,zoom));
        }
        this.fitPdf(); await this.service.render();
        if(viewport && this.pdfView==='custom') {
            viewport.scrollTo(Math.max(0,centerX*viewport.scrollWidth-viewport.clientWidth/2),Math.max(0,centerY*viewport.scrollHeight-viewport.clientHeight/2));
        } else viewport?.scrollTo(0,0);
    }
    zoomPdf(step: number) {
        const zoom=step>0 ? Math.floor(this.pdfZoom/25)*25+25 : Math.ceil(this.pdfZoom/25)*25-25;
        this.setPdfView(String(zoom));
    }
    pdfKey(event: KeyboardEvent) {
        if(event.ctrlKey || event.metaKey || event.altKey || this.pdfLoading || this.pdfError) return;
        if(event.key==='PageDown' || event.key==='PageUp') {
            event.preventDefault();
            const page=this.pdfPage+(event.key==='PageDown'?1:-1);
            if(page>=1 && page<=this.selected.preview.pages) this.changePdfPage(page);
        } else if(['+','=','-'].includes(event.key)) {
            event.preventDefault(); this.zoomPdf(event.key==='-'?-25:25);
        }
    }
    license(code: string) { return {MIT_REPO_SOURCE_RIGHTS_REVIEW:'MIT 표기 · 원천 이용조건 검토 필요','APACHE-2.0_SOURCE_RIGHTS_REVIEW':'Apache 2.0 표기 · 원천 이용조건 검토 필요'}[code] || '미확인'; }
    closePreview() { this.pdfResize?.disconnect(); this.pdfResize=undefined; this.detailId++; this.previewDialog?.nativeElement.close(); this.selected = null; this.previewTarget = null; this.detailError = ''; this.pdfUrl = null; this.selecting = false; this.service.render(); }
    status(code: string) { return {registered:'등록됨',unregistered:'미등록',missing:'파일 없음',changed:'크기 변경',blocked:'접근 불가',folder:'폴더'}[code] || code; }
    processing(code: string) { return {DRAFT:'등록',REVIEW:'검토 중',APPROVED:'승인',RETIRED:'사용 종료'}[code] || code; }
    decision(code: string) { return {USE:'사용',HOLD:'보류',EXCLUDE:'제외'}[code] || '미판정'; }
    icon(item: any) {
        if(item.kind === 'folder') return 'fa-solid fa-folder';
        if(item.format === 'PDF') return 'fa-regular fa-file-pdf';
        if(['ZIP','GZ','TAR'].includes(item.format)) return 'fa-regular fa-file-zipper';
        return 'fa-regular fa-file-lines';
    }
    size(bytes: number) {
        if(bytes == null) return '—';
        if(bytes<1024) return bytes+' B';
        if(bytes<1048576) return (bytes/1024).toFixed(1)+' KB';
        if(bytes<1073741824) return (bytes/1048576).toFixed(1)+' MB';
        return (bytes/1073741824).toFixed(2)+' GB';
    }
    previewMetadataOpen=false;
    get compactFilePreview() {return window.innerWidth<=800;}
    togglePreviewMetadata(event:Event) {
        if(!this.compactFilePreview)return;
        this.previewMetadataOpen=(event.target as HTMLDetailsElement).open;
        this.service.render();
    }
    date(value: string) { return formatWorkspaceDate(value,true,'—'); }
    async openFolderForm() {
        this.formBusy = false; this.formError = ''; this.folderName = ''; this.formParent = this.path;
        await this.service.render(); this.folderDialog.nativeElement.showModal();
    }
    closeFolderForm(event?: Event) {
        event?.preventDefault(); if(this.formBusy) return;
        this.folderDialog.nativeElement.close();
    }
    async createFolder() {
        if(this.formBusy) return;
        this.formBusy = true; this.formError = ''; await this.service.render();
        try {
            const res = await wiz.call('create_folder',{path:this.formParent,name:this.folderName,csrf:this.csrf});
            if(res.code !== 200) throw new Error(res.data?.message || '폴더를 만들지 못했습니다.');
            this.folderDialog.nativeElement.close(); this.notice = '폴더를 만들었습니다.'; this.refresh();
        } catch(e) { this.formError = e.message; }
        finally { this.formBusy = false; await this.service.render(); }
    }
    async openRegistration(mode = 'upload') {
        const selected = this.selected;
        const meta = selected?.metadata;
        this.formParent = mode === 'upload' ? this.path : selected.key.slice(0,selected.key.lastIndexOf('/'));
        this.formKey = mode === 'existing' ? selected.key : '';
        this.registration = {
            title:meta?.title || (mode === 'existing' ? selected.name.replace(/\.[^.]+$/,'') : ''),
            version:mode === 'version' ? '' : '1.0',source:meta?.source_label || meta?.source_uri || '',
            license:meta?.license_note || '',role:meta?.file_role || 'DATA',
            previous:mode === 'version' ? meta.id : '',
            fileName:mode === 'existing' ? selected.name : '',
            previousVersion:mode === 'version' ? meta.original_version : ''
        };
        this.formBusy = false; this.formError = ''; this.registeredInfo = null;
        this.registrationFile = null; this.uploadProgress = 0;
        this.closePreview();
        await this.service.render(); this.registrationDialog.nativeElement.showModal();
    }
    closeRegistration(event?: Event) {
        event?.preventDefault(); if(this.formBusy) return;
        this.registrationDialog.nativeElement.close(); this.registrationFile = null;
    }
    chooseFile(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0]; input.value = '';
        if(!file) return;
        this.registeredInfo = null;
        if(file.size > 250*1024*1024) { this.formError = '파일은 250 MB까지 올릴 수 있습니다.'; this.service.render(); return; }
        this.registrationFile = file; this.registration.fileName = file.name;
        if(!this.registration.title) this.registration.title = file.name.replace(/\.[^.]+$/,'');
        this.formError = ''; this.service.render();
    }
    sendUpload(form: FormData): Promise<any> {
        return new Promise((resolve,reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open('POST','/wiz/api/page.sources/upload'); xhr.timeout = 600000;
            xhr.upload.onprogress = event=>{
                if(event.lengthComputable) { this.uploadProgress = Math.round(event.loaded/event.total*100); this.service.render(); }
            };
            xhr.onload = ()=>{
                try { resolve(JSON.parse(xhr.responseText)); }
                catch { reject(new Error(xhr.status===413 ? '서버가 허용하는 업로드 크기를 초과했습니다.' : '등록 결과를 확인하지 못했습니다. 폴더를 새로고침해 주세요.')); }
            };
            xhr.onerror = ()=>reject(new Error('연결이 끊겼습니다. 폴더를 새로고침해 등록 여부를 확인해 주세요.'));
            xhr.ontimeout = ()=>reject(new Error('응답 시간이 초과됐습니다. 폴더를 새로고침해 등록 여부를 확인해 주세요.'));
            xhr.send(form);
        });
    }
    async submitRegistration() {
        if(this.formBusy) return;
        if(!this.formKey && !this.registrationFile) { this.formError = '파일을 선택해 주세요.'; await this.service.render(); return; }
        this.formBusy = true; this.formError = ''; this.registeredInfo = null; this.uploadProgress = 0;
        await this.service.render();
        try {
            const values = {title:this.registration.title,version:this.registration.version,
                source:this.registration.source,license:this.registration.license,role:this.registration.role,
                previous:this.registration.previous,csrf:this.csrf};
            let res: any;
            if(this.formKey) res = await wiz.call('register',{...values,path:this.formKey});
            else {
                const form = new FormData();
                for(const key of Object.keys(values)) form.append(key,values[key]);
                form.append('path',this.formParent); form.append('file',this.registrationFile!,this.registrationFile!.name);
                res = await this.sendUpload(form);
            }
            if(res.code !== 200) {
                if(res.data?.saved_key) { this.formKey = res.data.saved_key; this.registrationFile = null; this.refresh(); }
                if(res.data?.reason === 'REGISTERED') this.registeredInfo = res.data;
                throw new Error(res.data?.message || '원천을 등록하지 못했습니다.');
            }
            this.registrationDialog.nativeElement.close(); this.notice = this.registration.previous ? '새 버전을 등록했습니다.' : '원천을 등록했습니다.';
            this.registrationFile = null; this.refresh();
        } catch(e) { this.formError = e.message; }
        finally { this.formBusy = false; await this.service.render(); }
    }
    showRegistered(item: any) {
        this.closeRegistration(); this.openPreview({key:item.key});
    }

    async openExtraction(job=0, page=0) {
        const file=this.selected;
        this.exSource={id:file.metadata.id,key:file.key,name:file.name,format:file.metadata.format,
            kind:'file',state:file.state,can_download:file.can_download,
            pages:file.preview.pages || file.metadata.page_count, registeredPages:file.metadata.page_count,
            actualPages:file.preview.pages, textPages:file.metadata.text_pages};
        this.exIssueReview=false; this.exIssueMessage='';
        this.exFirst=file.metadata.format==='PDF' ? (page || this.pdfPage || 1) : 1;
        this.exLast=this.exFirst; this.exPage=this.exFirst;
        this.exEditing=false; this.exDraft=''; this.exSaved=''; this.exOriginal=false; this.exRevision=0; this.exZoom=100; this.exShowSetup=false; this.exPane='text';
        this.exOpen=true; this.exJob=job; this.exResult=null; this.exResultKey=''; this.exError=''; this.exImageError=false;
        this.exState={jobs:[],pages:[]}; this.exLoading=true; this.exEpoch++;
        this.closePreview(); await this.service.render(); this.extractionDialog.nativeElement.showModal();
        await this.loadExtraction();
    }
    closeExtraction(event?:Event,force=false) {
        event?.preventDefault();
        if(!force && (this.exSaving || !this.leaveExtractionEdit())) return;
        this.exOpen=false; this.exEpoch++; clearTimeout(this.exTimer);
        this.extractionDialog?.nativeElement.close();
        if(!force) this.load();
    }
    exDirty() { return this.exEditing && this.exDraft !== this.exResult?.editor?.text; }
    @HostListener('window:beforeunload',['$event'])
    protectExtractionEdit(event:BeforeUnloadEvent) {
        if(this.exDirty() || this.exSaving) { event.preventDefault(); event.returnValue=''; }
    }
    leaveExtractionEdit() {
        if(this.exSaving) return false;
        if(this.exDirty() && !window.confirm('저장하지 않은 수정 내용을 버릴까요?')) return false;
        this.exEditing=false; return true;
    }
    setExtractionPane(pane:string) {
        if(!['text','original'].includes(pane)) return;
        this.exPane=pane; this.service.render();
    }
    beginExtractionEdit() {
        if(!this.canWrite || !this.exResult?.editor?.is_latest || this.exActive() || this.qualityWorking) return;
        this.exDraft=this.exResult.editor.text; this.exEditing=true; this.exOriginal=false; this.exPane='text';
        this.exSaved=''; this.exError=''; this.service.render();
    }
    cancelExtractionEdit() { this.leaveExtractionEdit(); this.service.render(); }
    async refreshExtraction() {
        if(!this.leaveExtractionEdit()) return;
        this.exEpoch++; this.exResultKey=''; this.exRevision=0; this.exSaved=''; this.exError='';
        await this.loadExtraction();
    }
    async selectExtractionRevision(event:Event) {
        const select=event.target as HTMLSelectElement;
        if(!this.leaveExtractionEdit()) { select.value=String(this.exResult.editor.id); await this.service.render(); return; }
        this.exRevision=Number(select.value); this.exEpoch++; this.exResultKey=''; this.exSaved=''; this.exError='';
        try { await this.loadExtractionPage(); } catch(e) { this.exError=e.message; }
        this.scheduleExtraction(); await this.service.render();
    }
    async saveExtractionEdit() {
        if(!this.exDirty() || this.exSaving || !this.canWrite) return;
        this.exSaving=true; this.exError=''; this.exSaved=''; await this.service.render();
        try {
            const res=await wiz.call('extraction_save',{source:this.exSource.id,job:this.exJob,
                page:this.exPage,base:this.exResult.editor.id,text:this.exDraft,csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '저장하지 못했습니다. 다시 시도해 주세요.');
            this.exResult=res.data; this.exRevision=0; this.exResultKey=''; this.exEditing=false;
            this.exSaved='저장했습니다 · v'+res.data.editor.revision;
            this.loadQuality();
        } catch(e) { this.exError=e.message; }
        finally { this.exSaving=false; await this.service.render(); }
    }
    scheduleExtraction() {
        clearTimeout(this.exTimer);
        if(this.exOpen && this.exState.jobs.some(job=>['PENDING','RUNNING','PAUSING'].includes(job.status))) this.exTimer=setTimeout(()=>this.loadExtraction(),2500);
    }
    exStatus(code:string) { return {PENDING:'대기',RUNNING:'추출 중',PAUSING:'중단 중',PAUSED:'중단됨',SUCCESS:'완료',FAILED:'실패'}[code] || code; }
    exCurrent() { return this.exState.jobs.find(job=>Number(job.id)===Number(this.exJob)); }
    exPageCount(status: string) { return this.exState.pages.filter(page => page.status === status).length; }
    exDone() { return this.exPageCount('SUCCESS') + this.exPageCount('FAILED'); }
    exActive() { return this.exState.jobs.some(job=>['PENDING','RUNNING','PAUSING','PAUSED'].includes(job.status)); }
    resultIsDocument(row:any) {
        return row?.content_scope==='DOCUMENT' || row?.quality?.content_scope==='DOCUMENT' ||
            ['HWP','HWPX'].includes(row?.format) || /\.hwpx?$/i.test(row?.path || row?.file_key || row?.key || row?.name || '');
    }
    resultUnitLabel(row:any) { return this.resultIsDocument(row) ? '문서 전체' : row.page+'쪽'; }
    exNative() { return this.exResult?.result?.content_scope==='DOCUMENT' || this.exCurrent()?.content_scope==='DOCUMENT' || ['HWP','HWPX'].includes(this.exSource?.format); }
    exUnitLabel() { return this.exNative() ? '문서 전체' : this.exPage+'쪽'; }
    exBlocks() { return (this.exNative() ? this.exResult?.result?.document?.blocks : null) || this.exResult?.result?.page?.blocks || []; }
    exEditMaxLength() { return this.exResult?.editor?.max_length || 200000; }
    exJobRange(job:any) { return job?.content_scope==='DOCUMENT' ? '문서 전체' : job.first_page+'–'+job.last_page+'쪽'; }
    exImage() { return this.exNative() ? '' : '/wiz/api/page.sources/pdf?path='+encodeURIComponent(this.exSource.key)+'&page='+this.exPage; }
    async loadExtraction() {
        const epoch=this.exEpoch; clearTimeout(this.exTimer);
        try {
            const res=await wiz.call('extraction_state',{source:this.exSource.id,job:this.exJob});
            if(!this.exOpen || epoch!==this.exEpoch) return;
            if(res.code!==200) throw new Error(res.data?.message || '추출 작업을 불러오지 못했습니다.');
            this.exState=res.data; this.exJob=res.data.job;
            if(!res.data.jobs.length) this.exShowSetup=!this.exNative();
            if(this.exJob && !res.data.pages.some(row=>row.page===this.exPage)) this.exPage=res.data.pages[0]?.page || 1;
            await this.loadExtractionPage();
        } catch(e) { if(this.exOpen && epoch===this.exEpoch)this.exError=e.message; }
        finally {
            if(this.exOpen && epoch===this.exEpoch) {
                this.exLoading=false; await this.service.render();
                this.scheduleExtraction();
            }
        }
    }
    async selectExtractionJob(event:Event) {
        const select=event.target as HTMLSelectElement;
        if(!this.leaveExtractionEdit()) { select.value=String(this.exJob); await this.service.render(); return; }
        this.exJob=Number(select.value); this.exRevision=0; this.exSaved=''; this.exOriginal=false;
        this.exEpoch++; this.exResultKey=''; this.exResult=null; this.exError=''; await this.loadExtraction();
    }
    async selectExtractionPage(page:number) {
        if(page===this.exPage || !this.leaveExtractionEdit()) return;
        this.exEpoch++; this.exPage=page; this.exImageError=false; this.exResult=null;
        this.exRevision=0; this.exSaved=''; this.exError=''; this.exResultKey='';
        try { await this.loadExtractionPage(); } catch(e) { this.exError=e.message; }
        this.scheduleExtraction(); await this.service.render();
    }
    @HostListener('window:resize')
    revealExtractionPage() {
        const dialog=this.extractionDialog?.nativeElement;
        if(!this.exOpen || !dialog?.querySelector) return;
        const list=dialog.querySelector<HTMLElement>('.extraction-page-list');
        const active=list?.querySelector<HTMLElement>('button.active');
        if(!list?.clientWidth || !active) return;
        const outer=list.getBoundingClientRect(),chip=active.getBoundingClientRect();
        if(chip.left<outer.left || chip.right>outer.right)
            list.scrollTo({left:list.scrollLeft+chip.left-outer.left-(list.clientWidth-chip.width)/2,behavior:'instant'});
    }
    async loadExtractionPage() {
        if(!this.exJob || this.exEditing || this.exSaving) return;
        const page=this.exState.pages.find(row=>row.page===this.exPage);
        const key=[this.exJob,this.exPage,page?.status,page?.attempts,page?.quality_status,this.exRevision].join(':');
        if(this.exResultKey===key && this.exResult) return;
        const epoch=this.exEpoch,number=this.exPage,job=this.exJob;
        this.exPageLoading=true; await this.service.render(); this.revealExtractionPage();
        try {
            const res=await wiz.call('extraction_page',{source:this.exSource.id,job,page:number,revision:this.exRevision});
            if(!this.exOpen || epoch!==this.exEpoch || number!==this.exPage || job!==this.exJob) return;
            if(res.code!==200) throw new Error(res.data?.message || '추출 결과를 불러오지 못했습니다.');
            this.exResult=res.data; this.exResultKey=key;
            if (res.data.quality?.status === 'ISSUE') this.exIssueReview = true;
        } finally {
            if(epoch===this.exEpoch) this.exPageLoading=false;
        }
    }
    async startExtraction(retry=false) {
        if(this.exNative()) return;
        if(this.exBusy || !this.leaveExtractionEdit()) return;
        this.exBusy=true; this.exError=''; await this.service.render();
        try {
            const res=await wiz.call(retry?'extraction_retry':'extraction_start',{
                source:this.exSource.id,job:this.exJob,first:this.exFirst,last:this.exLast,csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '추출을 시작하지 못했습니다.');
            this.exJob=res.data.id; this.exShowSetup=false; this.exRevision=0; this.exSaved=''; this.exResultKey=''; this.exResult=null; this.exEpoch++;
            await this.loadExtraction();
        } catch(e) { this.exError=e.message; }
        finally { this.exBusy=false; await this.service.render(); }
    }

    selectable(item:any) { return !['missing','blocked'].includes(item.state); }
    extractable(item:any) { return item.kind==='folder' || (item.format==='PDF' && item.state==='registered'); }
    extractionSelection() { return this.checked.filter(item=>item.extractable); }
    canOrganize(item:any) { return this.canWrite && !!item && item.key.includes('/') && this.selectable(item); }
    canMoveSelection() { return this.checked.length>0 && this.checked.every(item=>item.key.includes('/')); }
    selectionItem(item:any) { return {key:item.key,kind:item.kind,extractable:this.extractable(item),can_download:item.can_download}; }
    isChecked(item:any) { return this.checked.some(row=>row.key===item.key); }
    someChecked() { return this.page.items.some(row=>this.selectable(row) && this.isChecked(row)); }
    allChecked() { const rows=this.page.items.filter(row=>this.selectable(row)); return rows.length>0 && rows.every(row=>this.isChecked(row)); }
    toggleChecked(item:any) {
        this.checked=this.isChecked(item)?this.checked.filter(row=>row.key!==item.key):[...this.checked,this.selectionItem(item)];
        this.service.render();
    }
    toggleAllChecked() {
        const rows=this.page.items.filter(row=>this.selectable(row));
        this.checked=this.allChecked()?this.checked.filter(row=>!rows.some(item=>item.key===row.key)):
            [...this.checked,...rows.filter(row=>!this.isChecked(row)).map(row=>this.selectionItem(row))];
        this.service.render();
    }
    queueKey(index:number,row:any) { return row.id; }
    queueActiveCount() { return (this.queue.counts.PENDING||0)+(this.queue.counts.RUNNING||0); }
    queuePercent(row:any) { return row.total?Math.round((Number(row.done)+Number(row.failed))/row.total*100):0; }
    async loadQueue(page=this.queue.page) {
        const request=++this.queueRequest; clearTimeout(this.queueTimer);
        const path=this.path, view=this.queueView; this.queueLoading=true;
        await this.service.render();
        try {
            const res=await wiz.call('extraction_queue_list',{page,view,sources:JSON.stringify(this.page.items.filter(row=>row.id).map(row=>row.id))});
            if(this.queueDead || request!==this.queueRequest || path!==this.path || view!==this.queueView) return;
            if(res.code!==200) throw new Error(res.data?.message || '추출 상태를 불러오지 못했습니다.');
            this.queue=res.data; this.queueLoaded=true; this.fileJobs=Object.fromEntries(res.data.files.map(row=>[row.source,row])); this.queueError='';
        } catch(e) { if(!this.queueDead && request===this.queueRequest) this.queueError=e.message; }
        finally {
            if(!this.queueDead && request===this.queueRequest) {
                this.queueLoading=false;
                await this.service.render();
                this.loadQuality(undefined,undefined,undefined,this.qualityLoaded);
                this.queueTimer=setTimeout(()=>this.loadQueue(),this.queueActiveCount()?2500:10000);
            }
        }
    }
    async prepareBatch() {
        if(this.batchBusy || !this.extractionSelection().length) return;
        this.batchBusy=true; this.batchError=''; this.batchPlan=null;
        await this.service.render(); this.batchDialog.nativeElement.showModal();
        try {
            const res=await wiz.call('extraction_queue_prepare',{selection:JSON.stringify(this.extractionSelection()),csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '추출 대상을 확인하지 못했습니다.');
            this.batchPlan=res.data;
        } catch(e) { this.batchError=e.message; }
        finally { this.batchBusy=false; await this.service.render(); }
    }
    closeBatch(event?:Event) { event?.preventDefault(); if(!this.batchBusy) this.batchDialog.nativeElement.close(); }
    async startBatch() {
        if(this.batchBusy || !this.batchPlan?.files) return;
        this.batchBusy=true; this.batchError=''; await this.service.render();
        try {
            const res=await wiz.call('extraction_queue_start',{selection:JSON.stringify(this.extractionSelection()),
                fingerprint:this.batchPlan.fingerprint,csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '추출 작업을 등록하지 못했습니다.');
            this.batchDialog.nativeElement.close(); this.checked=[]; this.queueOpen=true;
            this.notice=res.data.files+'개 문헌 · '+res.data.pages+'쪽을 추출 대기에 등록했습니다.';
            await this.loadQueue(1);
        } catch(e) { this.batchError=e.message; }
        finally { this.batchBusy=false; await this.service.render(); }
    }
    async controlQueue(row:any,action:string) {
        if(this.queueBusy) return;
        if(!this.canWrite || (row && !row.can_control)) return;
        if(!row && !window.confirm(this.canAdmin ? '진행·대기 중인 모든 추출 작업을 중단할까요?' : '내가 요청한 진행·대기 작업을 중단할까요?')) return;
        this.queueBusy=true; this.queueError=''; await this.service.render();
        try {
            const res=await wiz.call('extraction_queue_'+action,{jobs:JSON.stringify(row?[Number(row.id)]:[]),scope:row?'':'active',csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '작업 상태를 변경하지 못했습니다.');
            await this.loadQueue();
            if(this.exOpen) await this.loadExtraction();
        } catch(e) { this.queueError=e.message; if(this.exOpen) this.exError=e.message; }
        finally { this.queueBusy=false; await this.service.render(); }
    }
    async openQueueResult(row:any) {
        if(row.trash_id) return;
        await this.openPreview({key:row.file_key || this.page.items.find(item=>item.id===row.source)?.key});
        if(this.selected) await this.openExtraction(Number(row.id));
    }

    extractionWarnings() { return (this.exNative() ? this.exResult?.result?.document?.warnings : null) || this.exResult?.result?.page?.warnings || []; }
    showExtractionWarnings() { return this.extractionWarnings().length && (!this.qualityResolved(this.exResult?.quality) || this.exOriginal); }
    extractionWarningMessage() {
        if(this.exResult?.quality?.status==='USER_CONFIRMED') return '사용자 요청으로 검토 기록 확인을 완료했습니다. 추출 당시 경고와 생성 입력 제한은 유지됩니다.';
        if(this.exOriginal && this.qualityResolved(this.exResult?.quality)) return '추출 당시의 주의 기록입니다. 현재 검토 결과는 저장본에서 확인해 주세요.';
        return '추출·자동 검토에 확인할 내용이 있습니다. 원문과 저장 텍스트를 비교하고 아래 점검 상세를 확인해 주세요.';
    }
    qualityLabel(status:string) { return {OK:'자동 점검 통과',ISSUE:'확인 필요',CONFIRMED:'문제없음 확인',USER_CONFIRMED:'사용자 일괄 확인 완료',WAITING:'추출·점검 대기'}[status] || '추출·점검 대기'; }
    qualityReasonItems(row:any):string[] {
        const report=row.quality;
        if(report.resolution_state==='RESOLVED' || ['CONFIRMED','USER_CONFIRMED'].includes(report.status)) return [report.resolution_label || this.qualityLabel(report.status)];
        const items=report.resolution_reasons?.length ? report.resolution_reasons : (report.flags || []);
        const labels=items.map(item=>item.label).filter(label=>typeof label==='string' && label.length>0);
        return labels.length ? labels : [this.qualityLabel(report.status)];
    }
    qualityReason(row:any) { return this.qualityReasonItems(row).join(' · '); }
    qualityReasonHeadline(row:any) {
        return this.qualityReasonItems(row)[0].replace(/;\s*[A-Za-z][A-Za-z0-9_]*(?=\s*\))/g, '');
    }
    qualityReasonSummary(row:any) {
        return this.qualityReason(row).replace(/;\s*[A-Za-z][A-Za-z0-9_]*(?=\s*\))/g, '');
    }
    qualityHasStructure(report:any) { return report?.advisories?.some(item=>item.category==='STRUCTURE') || report?.text_scope==='NARRATIVE_ONLY'; }
    qualityStructureAdvisories(report:any) { return (report?.advisories || []).filter(item=>item.category==='STRUCTURE'); }
    qualityResolved(report:any) { return report?.resolution_state==='RESOLVED' || report?.status==='CONFIRMED'; }
    qualityScopeDescription(report:any) {
        if(report?.status==='USER_CONFIRMED') return '사용자 요청으로 검토 기록 확인을 완료했습니다. 기존 생성 입력 제한은 유지됩니다.';
        if(report?.text_scope==='NARRATIVE_ONLY') return report.text_usable ? '표·그림 내용을 제외한 일반 본문만 QA·지식 생성 입력으로 사용합니다.' : '검토 상태와 별개로, 입력에 사용할 일반 본문이 없습니다.';
        return report?.text_usable ? 'QA·지식 생성 시 다른 사용 조건도 함께 확인합니다.' : '원문·추출 결과를 확인한 뒤 수정하거나 문제없음을 기록해 주세요.';
    }
    qualityCategoryLabel(code:string) { return this.qualityCategories.find(item=>item.code===code)?.label || '사유 미분류'; }
    qualityTextLabel(report:any) {
        if(report?.text_scope==='NARRATIVE_ONLY') return report.text_usable ? '일반 본문만 사용 가능' : '사용할 일반 본문 없음';
        return report?.text_usable ? '텍스트 입력 사용 가능' : '텍스트 입력 보류';
    }
    async loadQuality(page=this.quality.page || 1,mode=this.quality.mode || 'issues',category=this.quality.category || '',background=false) {
        if(this.qualityLoading || this.qualityWorking || this.queueDead || (background && this.qualityRefreshing)) return;
        const request=++this.qualityRequest; this.qualityError='';
        if(background) this.qualityRefreshing=true;
        else this.qualityLoading=true;
        await this.service.render();
        try {
            const res=await wiz.call('extraction_quality',{list_page:page,mode,category:mode==='issues'?category:''});
            if(this.queueDead || request!==this.qualityRequest) return;
            if(res.code!==200) throw new Error(res.data?.message || '점검 결과를 불러오지 못했습니다.');
            this.quality=res.data; this.qualityLoaded=true;
        } catch(e) { if(request===this.qualityRequest) this.qualityError=e.message; }
        finally { if(!this.queueDead && request===this.qualityRequest) { this.qualityLoading=false; this.qualityRefreshing=false; await this.service.render(); } }
    }
    async showQualityPage(row: any, isCurrent: () => boolean) {
        const res = await wiz.call('detail', {path: row.path});
        if (!isCurrent()) return;
        if (res.code !== 200) throw new Error(res.data?.message || '원천을 불러오지 못했습니다.');
        this.selected = res.data;
        await this.openExtraction(Number(row.job), Number(row.page));
        if (this.exOpen) this.exIssueReview = this.quality.mode==='structure' || row.quality?.status==='ISSUE' || this.exResult?.quality?.status==='ISSUE';
    }
    async nextQualityIssue() {
        if (this.qualityWorking || this.exLoading || this.exPageLoading || this.exBusy || !this.leaveExtractionEdit()) return;
        this.qualityWorking = true; this.exError = ''; this.exIssueMessage = '';
        const epoch = this.exEpoch;
        const isCurrent = () => !this.queueDead && this.exOpen && this.exEpoch === epoch;
        await this.service.render();
        try {
            const res = await wiz.call('extraction_quality', {
                action: 'next', source: this.exSource.id, job: this.exJob, page: this.exPage, category: this.quality.category || '', mode: this.quality.mode
            });
            if (!isCurrent()) return;
            if (res.code !== 200) throw new Error(res.data?.message || '다음 확인 필요 쪽을 찾지 못했습니다.');
            if (res.data.item) await this.showQualityPage(res.data.item, isCurrent);
            else this.exIssueMessage = this.quality.mode==='structure' ? '현재 쪽 이후에 구조 안내가 있는 쪽이 없습니다.' : this.quality.category ? '현재 쪽 이후에 '+this.qualityCategoryLabel(this.quality.category)+' 대상이 없습니다.' : '현재 쪽 이후에 확인이 필요한 쪽이 없습니다.';
        } catch (error) {
            if (isCurrent()) this.exError = error.message;
        } finally {
            this.qualityWorking = false;
            await this.service.render();
        }
    }
    async openQualityPage(row:any) {
        if(this.qualityWorking || !this.leaveExtractionEdit()) return;
        this.qualityWorking=true; this.qualityError='';
        const epoch = this.exEpoch, browseRequest = this.requestId;
        const isCurrent = () => !this.queueDead && this.exEpoch === epoch && this.requestId === browseRequest;
        await this.service.render();
        try {
            await this.showQualityPage(row, isCurrent);
        } catch(e) { if(isCurrent()) this.qualityError=e.message; }
        finally { this.qualityWorking=false; await this.service.render(); }
    }
    canConfirmQuality() {
        return this.canWrite && !this.exActive() && !this.exEditing && this.exResult?.editor?.is_latest &&
            this.exResult?.quality?.status==='ISSUE' && !this.exResult.quality.flags.some(flag=>flag.code==='MISSING_RESULT');
    }
    async confirmQuality() {
        if(!this.canConfirmQuality() || this.qualityWorking) return;
        this.qualityWorking=true; this.qualityRequest++; this.qualityLoading=false; this.qualityRefreshing=false; this.exError='';
        await this.service.render();
        try {
            const res=await wiz.call('extraction_quality',{action:'confirm',source:this.exSource.id,job:this.exJob,
                page:this.exPage,base:this.exResult.editor.id,csrf:this.csrf,mode:this.quality.mode,category:this.quality.category || ''});
            if(res.code!==200) throw new Error(res.data?.message || '확인 기록을 저장하지 못했습니다.');
            this.quality=res.data; this.qualityLoaded=true;
            await this.refreshExtraction();
        } catch(e) { this.exError=e.message; }
        finally { this.qualityWorking=false; await this.service.render(); }
    }
    async retryQualityPage() {
        if(this.exActive() || this.exBusy || this.qualityWorking) return;
        this.exFirst=this.exPage; this.exLast=this.exPage;
        await this.startExtraction();
        this.loadQueue();
    }


    async openItemMenu(item:any,event:MouseEvent) {
        this.menuItem=item;
        const rect=(event.currentTarget as HTMLElement).getBoundingClientRect();
        this.menuLeft=Math.max(8,Math.min(rect.right-176,window.innerWidth-184));
        this.menuTop=Math.max(8,Math.min(rect.bottom+4,window.innerHeight-144));
        await this.service.render(); this.itemMenu.nativeElement.showPopover();
        this.menuTop=Math.max(8,Math.min(rect.bottom+4,window.innerHeight-this.itemMenu.nativeElement.offsetHeight-8));
        await this.service.render();
    }
    async openOrganize(mode:string,item:any=null) {
        if(this.organizeBusy) return;
        this.itemMenu?.nativeElement.hidePopover();
        this.organizeMode=mode;
        this.organizeItems=item?[{key:item.key,kind:item.kind}]:this.checked.map(row=>({key:row.key,kind:row.kind}));
        this.organizeName=mode==='rename'?item.name:'';
        this.organizeError=''; this.destinationPage={items:[],page:1,pages:1};
        this.destination=this.organizeItems[0].key.split('/')[0];
        await this.service.render(); this.organizeDialog.nativeElement.showModal();
        if(mode==='rename') {
            const input=this.organizeDialog.nativeElement.querySelector('input');
            input?.focus(); input?.select();
        } else await this.loadDestination(this.path || this.destination);
    }
    closeOrganize(event?:Event) {
        event?.preventDefault();
        if(this.organizeBusy) return;
        this.destinationRequest++; this.organizeMode=''; this.organizeDialog.nativeElement.close();
    }
    destinationCrumbs() {
        const parts=this.destination.split('/');
        return parts.map((name,index)=>({name:index===0?{storage:'보관함'}[name]:name.normalize('NFC'),key:parts.slice(0,index+1).join('/')}));
    }
    destinationBlocked(key:string) {
        return this.organizeItems.some(item=>item.kind==='folder' && (key===item.key || key.startsWith(item.key+'/')));
    }
    canMoveHere() {
        return this.destination && !this.destinationLoading && !this.organizeBusy && !this.organizeError &&
            !this.destinationBlocked(this.destination) && this.organizeItems.some(item=>item.key.slice(0,item.key.lastIndexOf('/'))!==this.destination);
    }
    async loadDestination(path:string,page=1) {
        if(this.organizeBusy || this.destinationBlocked(path)) return;
        const request=++this.destinationRequest; this.destination=path; this.destinationLoading=true; this.organizeError='';
        await this.service.render();
        try {
            const res=await wiz.call('browse',{path,folders:'1',page});
            if(request!==this.destinationRequest) return;
            if(res.code!==200) throw new Error(res.data?.message || '폴더를 불러오지 못했습니다.');
            this.destinationPage=res.data;
        } catch(e) { if(request===this.destinationRequest) this.organizeError=e.message; }
        finally { if(request===this.destinationRequest) { this.destinationLoading=false; await this.service.render(); } }
    }
    async saveOrganize() {
        if(this.organizeBusy || (this.organizeMode==='move' && !this.canMoveHere())) return;
        this.organizeBusy=true; this.organizeError=''; await this.service.render();
        try {
            const res=await wiz.call(this.organizeMode,{selection:JSON.stringify(this.organizeItems),
                name:this.organizeName,target:this.destination,csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '변경하지 못했습니다. 다시 시도해 주세요.');
            this.notice=res.data.changed?(this.organizeMode==='rename'?'이름을 변경했습니다.':res.data.changed+'개 항목을 이동했습니다.'):'변경 사항이 없습니다.';
            this.checked=[]; this.organizeDialog.nativeElement.close(); this.organizeMode='';
            await this.load();
        } catch(e) { this.organizeError=e.message; }
        finally { this.organizeBusy=false; await this.service.render(); }
    }

    navigateTrash(q='',page=1) {
        if(this.trashBusy) return;
        if(!this.trashMode) this.lastFolder=this.path;
        this.router.navigate(['/sources'],{queryParams:{trash:'1',q:q||null,page:page>1?page:null}});
    }
    trashSelected(item:any) { return this.trashChecked.includes(item.id); }
    toggleTrash(item:any) {
        this.trashChecked=this.trashSelected(item)?this.trashChecked.filter(id=>id!==item.id):[...this.trashChecked,item.id];
        this.service.render();
    }
    allTrashSelected() { return this.page.items.length>0 && this.page.items.every(item=>this.trashSelected(item)); }
    toggleTrashPage() {
        const ids=this.page.items.map(item=>item.id);
        this.trashChecked=this.allTrashSelected()?this.trashChecked.filter(id=>!ids.includes(id)):
            Array.from(new Set([...this.trashChecked,...ids]));
        this.service.render();
    }
    async confirmTrash(action:string,item?:any) {
        if(!this.canWrite || this.trashBusy || (action!=='send' && !this.canAdmin)) return;
        this.itemMenu?.nativeElement.hidePopover();
        this.trashAction=action;
        this.trashTargets=item?[item]:(action==='send'?[...this.checked]:this.trashChecked.map(id=>this.page.items.find(row=>row.id===id)||{id}));
        if(!this.trashTargets.length) return;
        this.trashError='';
        await this.service.render(); this.trashConfirm.nativeElement.showModal();
    }
    closeTrashConfirm(event?:Event) {
        event?.preventDefault(); if(this.trashBusy) return;
        this.trashConfirm.nativeElement.close();
    }
    async applyTrash() {
        if(this.trashBusy) return;
        this.trashBusy=true; this.trashError=''; await this.service.render();
        try {
            const res=await wiz.call('trash_'+this.trashAction,{csrf:this.csrf,
                selection:JSON.stringify(this.trashTargets),ids:JSON.stringify(this.trashTargets.map(item=>item.id)),
                confirmed:this.trashAction==='purge'?'DELETE':''});
            if(res.code!==200) throw new Error(res.data?.message || '처리하지 못했습니다. 목록을 새로고침해 주세요.');
            const verb={send:'휴지통으로 보냈습니다.',restore:'복원했습니다.',purge:'영구 삭제했습니다.'}[this.trashAction];
            this.notice=res.data.changed+'개 항목을 '+verb;
            this.checked=[]; this.trashChecked=[]; this.trashConfirm.nativeElement.close();
            await this.load(); this.loadQuality();
        } catch(e) { this.trashError=e.message; await this.load(); }
        finally { this.trashBusy=false; await this.service.render(); }
    }
    downloadStorageKey() { return 'source-download:'+this.user?.id; }
    downloadActive() { return this.downloadBusy || ['PENDING','SCANNING','PREPARING'].includes(this.download?.state); }
    downloadPercent() { return this.download?.total ? Math.min(99,Math.floor(this.download.done/this.download.total*100)) : 0; }
    downloadLabel() {
        if(this.downloadBusy) return '다운로드 준비 중';
        if(this.downloadSending) return '다운로드를 시작했습니다';
        return {PENDING:'다운로드 준비 중',SCANNING:'파일 확인 중',PREPARING:'ZIP 준비 중 · '+this.downloadPercent()+'%',
            READY:'다운로드 준비 완료',FAILED:'다운로드 준비 실패',CANCELLED:'준비 취소됨'}[this.download?.state] || '다운로드';
    }
    canDownload(item?:any) {
        const selected=item?[item]:this.checked;
        return this.canRead && selected.length>0 && selected.every(row=>this.selectable(row) && (this.canWrite || row.can_download===true));
    }
    async startDownload(item?:any) {
        if(!this.canDownload(item) || this.downloadActive()) return;
        const selection=item?[item]:this.checked;
        if(!selection.length) return;
        this.itemMenu?.nativeElement.hidePopover(); clearTimeout(this.downloadTimer);
        const request=++this.downloadRequest;
        this.downloadBusy=true; this.downloadSending=false; this.downloadAuto=true;
        this.download={state:'PENDING',name:item?.name || selection.length+'개 항목'};
        await this.service.render();
        try {
            const res=await wiz.call('download_prepare',{csrf:this.csrf,selection:JSON.stringify(selection)});
            if(res.code===200 && res.data?.id) sessionStorage.setItem(this.downloadStorageKey(),res.data.id);
            if(this.downloadDead || request!==this.downloadRequest) return;
            if(res.code!==200) throw new Error(res.data?.message || '다운로드를 준비하지 못했습니다.');
            this.download=res.data; sessionStorage.setItem(this.downloadStorageKey(),this.download.id);
            this.downloadBusy=false; await this.pollDownload();
        } catch(e) { if(request===this.downloadRequest) this.download={state:'FAILED',message:e.message}; }
        finally { if(!this.downloadDead && request===this.downloadRequest) { this.downloadBusy=false; await this.service.render(); } }
    }
    async pollDownload() {
        clearTimeout(this.downloadTimer);
        if(this.downloadDead || !this.download?.id) return;
        const token=this.download.id,request=this.downloadRequest;
        try {
            const res=await wiz.call('download_status',{id:token});
            if(this.downloadDead || request!==this.downloadRequest) return;
            if(res.code!==200) throw new Error(res.data?.message || '다운로드 상태를 확인하지 못했습니다.');
            this.download=res.data;
            if(this.download.state==='READY' && this.downloadAuto) { this.downloadAuto=false; this.saveDownload(); }
            if(this.downloadActive() || (this.download.state==='READY' && Date.now()<this.downloadWatchUntil)) this.downloadTimer=setTimeout(()=>this.pollDownload(),1000);
            if(this.download.state==='FAILED') this.downloadSending=false;
        } catch(e) {
            if(request===this.downloadRequest) { this.download={...this.download,state:'FAILED',message:e.message}; this.downloadAuto=false; }
        }
        if(!this.downloadDead) await this.service.render();
    }
    async saveDownload() {
        if(this.download?.state!=='READY') return;
        const token=this.download.id,request=this.downloadRequest;
        try {
            const res=await wiz.call('download_status',{id:token,verify:'1'});
            if(this.downloadDead || request!==this.downloadRequest) return;
            if(res.code!==200 || res.data?.state!=='READY') throw new Error(res.data?.message || '다운로드를 다시 준비해 주세요.');
            this.downloadSending=true;this.downloadFrame?.remove();
            const frame=document.createElement('iframe');this.downloadFrame=frame;
            frame.hidden=true;frame.title='파일 다운로드';frame.referrerPolicy='no-referrer';
            frame.src='/wiz/api/page.sources/download_file?id='+encodeURIComponent(token);
            document.body.appendChild(frame);
            this.downloadWatchUntil=Date.now()+30000;
            clearTimeout(this.downloadTimer);this.downloadTimer=setTimeout(()=>this.pollDownload(),1000);
        } catch(e) {
            this.downloadSending=false;this.download={...this.download,state:'FAILED',message:e.message};
        }
        await this.service.render();
    }
    async cancelDownload() {
        if(this.downloadBusy || !this.download?.id) return;
        this.downloadAuto=false; this.downloadRequest++;clearTimeout(this.downloadTimer);
        try {
            const res=await wiz.call('download_cancel',{id:this.download.id,csrf:this.csrf});
            if(res.code!==200) throw new Error(res.data?.message || '준비를 취소하지 못했습니다.');
            this.download=res.data;sessionStorage.removeItem(this.downloadStorageKey());
        } catch(e) { this.download={...this.download,message:e.message}; this.pollDownload(); }
        await this.service.render();
    }
    closeDownload() {
        if(this.downloadActive()) return;
        this.downloadRequest++;clearTimeout(this.downloadTimer);this.download=null;this.downloadSending=false;
        sessionStorage.removeItem(this.downloadStorageKey());this.service.render();
    }
}

export default PageSourcesComponent;